
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("22qj4", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $17c02c9ac42c81ea$export$ffb0004e005737fa, (v) => $17c02c9ac42c81ea$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $17c02c9ac42c81ea$export$34b9dba7ce09269b, (v) => $17c02c9ac42c81ea$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $17c02c9ac42c81ea$export$25062201e9e25d76, (v) => $17c02c9ac42c81ea$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $17c02c9ac42c81ea$export$ffb0004e005737fa;
var $17c02c9ac42c81ea$export$34b9dba7ce09269b;
var $17c02c9ac42c81ea$export$25062201e9e25d76;
"use strict";
var $17c02c9ac42c81ea$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $17c02c9ac42c81ea$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $17c02c9ac42c81ea$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $17c02c9ac42c81ea$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$17c02c9ac42c81ea$export$ffb0004e005737fa = $17c02c9ac42c81ea$var$REACT_FRAGMENT_TYPE;
$17c02c9ac42c81ea$export$34b9dba7ce09269b = $17c02c9ac42c81ea$var$jsxProd;
$17c02c9ac42c81ea$export$25062201e9e25d76 = $17c02c9ac42c81ea$var$jsxProd;

});

parcelRegister("k9SHz", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $eacf148c9521df60$export$9c16c1426311996d, (v) => $eacf148c9521df60$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $eacf148c9521df60$export$dca3b0875bd9a954, (v) => $eacf148c9521df60$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $eacf148c9521df60$export$16fa2f45be04daa8, (v) => $eacf148c9521df60$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $eacf148c9521df60$export$ffb0004e005737fa, (v) => $eacf148c9521df60$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $eacf148c9521df60$export$e2c29f18771995cb, (v) => $eacf148c9521df60$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $eacf148c9521df60$export$221d75b3f55bb0bd, (v) => $eacf148c9521df60$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $eacf148c9521df60$export$5f8d39834fd61797, (v) => $eacf148c9521df60$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $eacf148c9521df60$export$74bf444e3cd11ea5, (v) => $eacf148c9521df60$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $eacf148c9521df60$export$1ced07cd6b1985ce, (v) => $eacf148c9521df60$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $eacf148c9521df60$export$abd8e32b826d7ea7, (v) => $eacf148c9521df60$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $eacf148c9521df60$export$69a3209f1a06c04d, (v) => $eacf148c9521df60$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $eacf148c9521df60$export$8c538325882c7eec, (v) => $eacf148c9521df60$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $eacf148c9521df60$export$e530037191fcd5d7, (v) => $eacf148c9521df60$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $eacf148c9521df60$export$fd42f52fd3ae1109, (v) => $eacf148c9521df60$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $eacf148c9521df60$export$c8a8987d4410bf2d, (v) => $eacf148c9521df60$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $eacf148c9521df60$export$7d1e3a5e95ceca43, (v) => $eacf148c9521df60$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $eacf148c9521df60$export$257a8862b851cb5b, (v) => $eacf148c9521df60$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $eacf148c9521df60$export$a8257692ac88316c, (v) => $eacf148c9521df60$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $eacf148c9521df60$export$488013bae63b21da, (v) => $eacf148c9521df60$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $eacf148c9521df60$export$7c73462e0d25e514, (v) => $eacf148c9521df60$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $eacf148c9521df60$export$7568632d0d33d16d, (v) => $eacf148c9521df60$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $eacf148c9521df60$export$f93f40ac0ca7e3a8, (v) => $eacf148c9521df60$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $eacf148c9521df60$export$1f96ae73734a86cc, (v) => $eacf148c9521df60$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $eacf148c9521df60$export$9a47ced3238df325, (v) => $eacf148c9521df60$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $eacf148c9521df60$export$35808ee640e87ca7, (v) => $eacf148c9521df60$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $eacf148c9521df60$export$fae74005e78b1a27, (v) => $eacf148c9521df60$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $eacf148c9521df60$export$dc8fbce3eb94dc1e, (v) => $eacf148c9521df60$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $eacf148c9521df60$export$6a7bc4e911dc01cf, (v) => $eacf148c9521df60$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $eacf148c9521df60$export$6d9c69b0de29b591, (v) => $eacf148c9521df60$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $eacf148c9521df60$export$7f54fc3180508a52, (v) => $eacf148c9521df60$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $eacf148c9521df60$export$f680877a34711e37, (v) => $eacf148c9521df60$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $eacf148c9521df60$export$d5a552a76deda3c2, (v) => $eacf148c9521df60$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $eacf148c9521df60$export$aaabe4eda9ed9969, (v) => $eacf148c9521df60$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $eacf148c9521df60$export$e5c5a5f917a5871c, (v) => $eacf148c9521df60$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $eacf148c9521df60$export$1538c33de8887b59, (v) => $eacf148c9521df60$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $eacf148c9521df60$export$fca7f784ae7a249a, (v) => $eacf148c9521df60$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $eacf148c9521df60$export$13e3392192263954, (v) => $eacf148c9521df60$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $eacf148c9521df60$export$b8f5890fc79d6aca, (v) => $eacf148c9521df60$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $eacf148c9521df60$export$60241385465d0a34, (v) => $eacf148c9521df60$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $eacf148c9521df60$export$306c0aa65ff9ec16, (v) => $eacf148c9521df60$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $eacf148c9521df60$export$7b286972b8d8ccbf, (v) => $eacf148c9521df60$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $eacf148c9521df60$export$83d89fbfd8236492, (v) => $eacf148c9521df60$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eacf148c9521df60$export$9c16c1426311996d;
var $eacf148c9521df60$export$dca3b0875bd9a954;
var $eacf148c9521df60$export$16fa2f45be04daa8;
var $eacf148c9521df60$export$ffb0004e005737fa;
var $eacf148c9521df60$export$e2c29f18771995cb;
var $eacf148c9521df60$export$221d75b3f55bb0bd;
var $eacf148c9521df60$export$5f8d39834fd61797;
var $eacf148c9521df60$export$74bf444e3cd11ea5;
var $eacf148c9521df60$export$1ced07cd6b1985ce;
var $eacf148c9521df60$export$abd8e32b826d7ea7;
var $eacf148c9521df60$export$69a3209f1a06c04d;
var $eacf148c9521df60$export$8c538325882c7eec;
var $eacf148c9521df60$export$e530037191fcd5d7;
var $eacf148c9521df60$export$fd42f52fd3ae1109;
var $eacf148c9521df60$export$c8a8987d4410bf2d;
var $eacf148c9521df60$export$7d1e3a5e95ceca43;
var $eacf148c9521df60$export$257a8862b851cb5b;
var $eacf148c9521df60$export$a8257692ac88316c;
var $eacf148c9521df60$export$488013bae63b21da;
var $eacf148c9521df60$export$7c73462e0d25e514;
var $eacf148c9521df60$export$7568632d0d33d16d;
var $eacf148c9521df60$export$f93f40ac0ca7e3a8;
var $eacf148c9521df60$export$1f96ae73734a86cc;
var $eacf148c9521df60$export$9a47ced3238df325;
var $eacf148c9521df60$export$35808ee640e87ca7;
var $eacf148c9521df60$export$fae74005e78b1a27;
var $eacf148c9521df60$export$dc8fbce3eb94dc1e;
var $eacf148c9521df60$export$6a7bc4e911dc01cf;
var $eacf148c9521df60$export$6d9c69b0de29b591;
var $eacf148c9521df60$export$7f54fc3180508a52;
var $eacf148c9521df60$export$f680877a34711e37;
var $eacf148c9521df60$export$d5a552a76deda3c2;
var $eacf148c9521df60$export$aaabe4eda9ed9969;
var $eacf148c9521df60$export$e5c5a5f917a5871c;
var $eacf148c9521df60$export$1538c33de8887b59;
var $eacf148c9521df60$export$fca7f784ae7a249a;
var $eacf148c9521df60$export$13e3392192263954;
var $eacf148c9521df60$export$b8f5890fc79d6aca;
var $eacf148c9521df60$export$60241385465d0a34;
var $eacf148c9521df60$export$306c0aa65ff9ec16;
var $eacf148c9521df60$export$7b286972b8d8ccbf;
var $eacf148c9521df60$export$83d89fbfd8236492;
"use strict";
var $eacf148c9521df60$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $eacf148c9521df60$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $eacf148c9521df60$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $eacf148c9521df60$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $eacf148c9521df60$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $eacf148c9521df60$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $eacf148c9521df60$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $eacf148c9521df60$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $eacf148c9521df60$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $eacf148c9521df60$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $eacf148c9521df60$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $eacf148c9521df60$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $eacf148c9521df60$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $eacf148c9521df60$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $eacf148c9521df60$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$eacf148c9521df60$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $eacf148c9521df60$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $eacf148c9521df60$var$assign = Object.assign, $eacf148c9521df60$var$emptyObject = {};
function $eacf148c9521df60$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $eacf148c9521df60$var$emptyObject;
    this.updater = updater || $eacf148c9521df60$var$ReactNoopUpdateQueue;
}
$eacf148c9521df60$var$Component.prototype.isReactComponent = {};
$eacf148c9521df60$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$eacf148c9521df60$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $eacf148c9521df60$var$ComponentDummy() {}
$eacf148c9521df60$var$ComponentDummy.prototype = $eacf148c9521df60$var$Component.prototype;
function $eacf148c9521df60$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $eacf148c9521df60$var$emptyObject;
    this.updater = updater || $eacf148c9521df60$var$ReactNoopUpdateQueue;
}
var $eacf148c9521df60$var$pureComponentPrototype = $eacf148c9521df60$var$PureComponent.prototype = new $eacf148c9521df60$var$ComponentDummy();
$eacf148c9521df60$var$pureComponentPrototype.constructor = $eacf148c9521df60$var$PureComponent;
$eacf148c9521df60$var$assign($eacf148c9521df60$var$pureComponentPrototype, $eacf148c9521df60$var$Component.prototype);
$eacf148c9521df60$var$pureComponentPrototype.isPureReactComponent = !0;
var $eacf148c9521df60$var$isArrayImpl = Array.isArray;
function $eacf148c9521df60$var$noop() {}
var $eacf148c9521df60$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $eacf148c9521df60$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $eacf148c9521df60$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $eacf148c9521df60$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $eacf148c9521df60$var$cloneAndReplaceKey(oldElement, newKey) {
    return $eacf148c9521df60$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $eacf148c9521df60$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $eacf148c9521df60$var$REACT_ELEMENT_TYPE;
}
function $eacf148c9521df60$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $eacf148c9521df60$var$userProvidedKeyEscapeRegex = /\/+/g;
function $eacf148c9521df60$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $eacf148c9521df60$var$escape("" + element.key) : index.toString(36);
}
function $eacf148c9521df60$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($eacf148c9521df60$var$noop, $eacf148c9521df60$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $eacf148c9521df60$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $eacf148c9521df60$var$REACT_ELEMENT_TYPE:
                case $eacf148c9521df60$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $eacf148c9521df60$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $eacf148c9521df60$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $eacf148c9521df60$var$getElementKey(children, 0) : nameSoFar, $eacf148c9521df60$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($eacf148c9521df60$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $eacf148c9521df60$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($eacf148c9521df60$var$isValidElement(callback) && (callback = $eacf148c9521df60$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($eacf148c9521df60$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($eacf148c9521df60$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $eacf148c9521df60$var$getElementKey(nameSoFar, i), invokeCallback += $eacf148c9521df60$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $eacf148c9521df60$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $eacf148c9521df60$var$getElementKey(nameSoFar, i++), invokeCallback += $eacf148c9521df60$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $eacf148c9521df60$var$mapIntoArray($eacf148c9521df60$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $eacf148c9521df60$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $eacf148c9521df60$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $eacf148c9521df60$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $eacf148c9521df60$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $eacf148c9521df60$var$Children = {
    map: $eacf148c9521df60$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $eacf148c9521df60$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $eacf148c9521df60$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $eacf148c9521df60$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$eacf148c9521df60$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$eacf148c9521df60$export$9c16c1426311996d = $eacf148c9521df60$var$REACT_ACTIVITY_TYPE;
$eacf148c9521df60$export$dca3b0875bd9a954 = $eacf148c9521df60$var$Children;
$eacf148c9521df60$export$16fa2f45be04daa8 = $eacf148c9521df60$var$Component;
$eacf148c9521df60$export$ffb0004e005737fa = $eacf148c9521df60$var$REACT_FRAGMENT_TYPE;
$eacf148c9521df60$export$e2c29f18771995cb = $eacf148c9521df60$var$REACT_PROFILER_TYPE;
$eacf148c9521df60$export$221d75b3f55bb0bd = $eacf148c9521df60$var$PureComponent;
$eacf148c9521df60$export$5f8d39834fd61797 = $eacf148c9521df60$var$REACT_STRICT_MODE_TYPE;
$eacf148c9521df60$export$74bf444e3cd11ea5 = $eacf148c9521df60$var$REACT_SUSPENSE_TYPE;
$eacf148c9521df60$export$1ced07cd6b1985ce = $eacf148c9521df60$var$ReactSharedInternals;
$eacf148c9521df60$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $eacf148c9521df60$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$eacf148c9521df60$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$eacf148c9521df60$export$8c538325882c7eec = function() {
    return null;
};
$eacf148c9521df60$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $eacf148c9521df60$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$eacf148c9521df60$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $eacf148c9521df60$var$ReactElement(element.type, key, props);
};
$eacf148c9521df60$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $eacf148c9521df60$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $eacf148c9521df60$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$eacf148c9521df60$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$eacf148c9521df60$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $eacf148c9521df60$var$ReactElement(type, key, props);
};
$eacf148c9521df60$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$eacf148c9521df60$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $eacf148c9521df60$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$eacf148c9521df60$export$a8257692ac88316c = $eacf148c9521df60$var$isValidElement;
$eacf148c9521df60$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $eacf148c9521df60$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $eacf148c9521df60$var$lazyInitializer
    };
};
$eacf148c9521df60$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $eacf148c9521df60$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$eacf148c9521df60$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $eacf148c9521df60$var$ReactSharedInternals.T, currentTransition = {};
    $eacf148c9521df60$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $eacf148c9521df60$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($eacf148c9521df60$var$noop, $eacf148c9521df60$var$reportGlobalError);
    } catch (error) {
        $eacf148c9521df60$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $eacf148c9521df60$var$ReactSharedInternals.T = prevTransition;
    }
};
$eacf148c9521df60$export$f93f40ac0ca7e3a8 = function() {
    return $eacf148c9521df60$var$ReactSharedInternals.H.useCacheRefresh();
};
$eacf148c9521df60$export$1f96ae73734a86cc = function(usable) {
    return $eacf148c9521df60$var$ReactSharedInternals.H.use(usable);
};
$eacf148c9521df60$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $eacf148c9521df60$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$eacf148c9521df60$export$35808ee640e87ca7 = function(callback, deps) {
    return $eacf148c9521df60$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$eacf148c9521df60$export$fae74005e78b1a27 = function(Context) {
    return $eacf148c9521df60$var$ReactSharedInternals.H.useContext(Context);
};
$eacf148c9521df60$export$dc8fbce3eb94dc1e = function() {};
$eacf148c9521df60$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $eacf148c9521df60$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$eacf148c9521df60$export$6d9c69b0de29b591 = function(create, deps) {
    return $eacf148c9521df60$var$ReactSharedInternals.H.useEffect(create, deps);
};
$eacf148c9521df60$export$7f54fc3180508a52 = function(callback) {
    return $eacf148c9521df60$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$eacf148c9521df60$export$f680877a34711e37 = function() {
    return $eacf148c9521df60$var$ReactSharedInternals.H.useId();
};
$eacf148c9521df60$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $eacf148c9521df60$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$eacf148c9521df60$export$aaabe4eda9ed9969 = function(create, deps) {
    return $eacf148c9521df60$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$eacf148c9521df60$export$e5c5a5f917a5871c = function(create, deps) {
    return $eacf148c9521df60$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$eacf148c9521df60$export$1538c33de8887b59 = function(create, deps) {
    return $eacf148c9521df60$var$ReactSharedInternals.H.useMemo(create, deps);
};
$eacf148c9521df60$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $eacf148c9521df60$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$eacf148c9521df60$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $eacf148c9521df60$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$eacf148c9521df60$export$b8f5890fc79d6aca = function(initialValue) {
    return $eacf148c9521df60$var$ReactSharedInternals.H.useRef(initialValue);
};
$eacf148c9521df60$export$60241385465d0a34 = function(initialState) {
    return $eacf148c9521df60$var$ReactSharedInternals.H.useState(initialState);
};
$eacf148c9521df60$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $eacf148c9521df60$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$eacf148c9521df60$export$7b286972b8d8ccbf = function() {
    return $eacf148c9521df60$var$ReactSharedInternals.H.useTransition();
};
$eacf148c9521df60$export$83d89fbfd8236492 = "19.2.5";

});

parcelRegister("93C2Y", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $6981e83672fe6c5f$export$882461b6382ed46c, (v) => $6981e83672fe6c5f$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $6981e83672fe6c5f$export$757ceba2d55c277e, (v) => $6981e83672fe6c5f$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $6981e83672fe6c5f$export$83d89fbfd8236492, (v) => $6981e83672fe6c5f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $6981e83672fe6c5f$export$882461b6382ed46c;
var $6981e83672fe6c5f$export$757ceba2d55c277e;
var $6981e83672fe6c5f$export$83d89fbfd8236492;
"use strict";

var $eHVWl = parcelRequire("eHVWl");

var $5a48l = parcelRequire("5a48l");

var $7aO71 = parcelRequire("7aO71");
function $6981e83672fe6c5f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $6981e83672fe6c5f$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $6981e83672fe6c5f$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $6981e83672fe6c5f$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $6981e83672fe6c5f$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $6981e83672fe6c5f$var$assertIsMounted(fiber) {
    if ($6981e83672fe6c5f$var$getNearestMountedFiber(fiber) !== fiber) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(188));
}
function $6981e83672fe6c5f$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $6981e83672fe6c5f$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $6981e83672fe6c5f$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $6981e83672fe6c5f$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $6981e83672fe6c5f$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $6981e83672fe6c5f$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $6981e83672fe6c5f$var$assign = Object.assign, $6981e83672fe6c5f$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $6981e83672fe6c5f$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $6981e83672fe6c5f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $6981e83672fe6c5f$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $6981e83672fe6c5f$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $6981e83672fe6c5f$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $6981e83672fe6c5f$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $6981e83672fe6c5f$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $6981e83672fe6c5f$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $6981e83672fe6c5f$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $6981e83672fe6c5f$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $6981e83672fe6c5f$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $6981e83672fe6c5f$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $6981e83672fe6c5f$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $6981e83672fe6c5f$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $6981e83672fe6c5f$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $6981e83672fe6c5f$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $6981e83672fe6c5f$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$6981e83672fe6c5f$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $6981e83672fe6c5f$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $6981e83672fe6c5f$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $6981e83672fe6c5f$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $6981e83672fe6c5f$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $6981e83672fe6c5f$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $6981e83672fe6c5f$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $6981e83672fe6c5f$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $6981e83672fe6c5f$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $6981e83672fe6c5f$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $6981e83672fe6c5f$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $6981e83672fe6c5f$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $6981e83672fe6c5f$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $6981e83672fe6c5f$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $6981e83672fe6c5f$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $6981e83672fe6c5f$var$getComponentNameFromType(type.type) || "Memo";
        case $6981e83672fe6c5f$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $6981e83672fe6c5f$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $6981e83672fe6c5f$var$isArrayImpl = Array.isArray, $6981e83672fe6c5f$var$ReactSharedInternals = $5a48l.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $6981e83672fe6c5f$var$ReactDOMSharedInternals = $7aO71.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $6981e83672fe6c5f$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $6981e83672fe6c5f$var$valueStack = [], $6981e83672fe6c5f$var$index = -1;
function $6981e83672fe6c5f$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $6981e83672fe6c5f$var$pop(cursor) {
    0 > $6981e83672fe6c5f$var$index || (cursor.current = $6981e83672fe6c5f$var$valueStack[$6981e83672fe6c5f$var$index], $6981e83672fe6c5f$var$valueStack[$6981e83672fe6c5f$var$index] = null, $6981e83672fe6c5f$var$index--);
}
function $6981e83672fe6c5f$var$push(cursor, value) {
    $6981e83672fe6c5f$var$index++;
    $6981e83672fe6c5f$var$valueStack[$6981e83672fe6c5f$var$index] = cursor.current;
    cursor.current = value;
}
var $6981e83672fe6c5f$var$contextStackCursor = $6981e83672fe6c5f$var$createCursor(null), $6981e83672fe6c5f$var$contextFiberStackCursor = $6981e83672fe6c5f$var$createCursor(null), $6981e83672fe6c5f$var$rootInstanceStackCursor = $6981e83672fe6c5f$var$createCursor(null), $6981e83672fe6c5f$var$hostTransitionProviderCursor = $6981e83672fe6c5f$var$createCursor(null);
function $6981e83672fe6c5f$var$pushHostContainer(fiber, nextRootInstance) {
    $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$rootInstanceStackCursor, nextRootInstance);
    $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$contextFiberStackCursor, fiber);
    $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $6981e83672fe6c5f$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $6981e83672fe6c5f$var$getOwnHostContext(nextRootInstance), fiber = $6981e83672fe6c5f$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $6981e83672fe6c5f$var$pop($6981e83672fe6c5f$var$contextStackCursor);
    $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$contextStackCursor, fiber);
}
function $6981e83672fe6c5f$var$popHostContainer() {
    $6981e83672fe6c5f$var$pop($6981e83672fe6c5f$var$contextStackCursor);
    $6981e83672fe6c5f$var$pop($6981e83672fe6c5f$var$contextFiberStackCursor);
    $6981e83672fe6c5f$var$pop($6981e83672fe6c5f$var$rootInstanceStackCursor);
}
function $6981e83672fe6c5f$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$hostTransitionProviderCursor, fiber);
    var context = $6981e83672fe6c5f$var$contextStackCursor.current;
    var JSCompiler_inline_result = $6981e83672fe6c5f$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$contextFiberStackCursor, fiber), $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$contextStackCursor, JSCompiler_inline_result));
}
function $6981e83672fe6c5f$var$popHostContext(fiber) {
    $6981e83672fe6c5f$var$contextFiberStackCursor.current === fiber && ($6981e83672fe6c5f$var$pop($6981e83672fe6c5f$var$contextStackCursor), $6981e83672fe6c5f$var$pop($6981e83672fe6c5f$var$contextFiberStackCursor));
    $6981e83672fe6c5f$var$hostTransitionProviderCursor.current === fiber && ($6981e83672fe6c5f$var$pop($6981e83672fe6c5f$var$hostTransitionProviderCursor), $6981e83672fe6c5f$var$HostTransitionContext._currentValue = $6981e83672fe6c5f$var$sharedNotPendingObject);
}
var $6981e83672fe6c5f$var$prefix, $6981e83672fe6c5f$var$suffix;
function $6981e83672fe6c5f$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $6981e83672fe6c5f$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $6981e83672fe6c5f$var$prefix = match && match[1] || "";
        $6981e83672fe6c5f$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $6981e83672fe6c5f$var$prefix + name + $6981e83672fe6c5f$var$suffix;
}
var $6981e83672fe6c5f$var$reentry = !1;
function $6981e83672fe6c5f$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $6981e83672fe6c5f$var$reentry) return "";
    $6981e83672fe6c5f$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $6981e83672fe6c5f$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $6981e83672fe6c5f$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $6981e83672fe6c5f$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $6981e83672fe6c5f$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $6981e83672fe6c5f$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $6981e83672fe6c5f$var$describeBuiltInComponentFrame("Suspense Fallback") : $6981e83672fe6c5f$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $6981e83672fe6c5f$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $6981e83672fe6c5f$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $6981e83672fe6c5f$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $6981e83672fe6c5f$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $6981e83672fe6c5f$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $6981e83672fe6c5f$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $6981e83672fe6c5f$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $6981e83672fe6c5f$var$hasOwnProperty = Object.prototype.hasOwnProperty, $6981e83672fe6c5f$var$scheduleCallback$3 = $eHVWl.unstable_scheduleCallback, $6981e83672fe6c5f$var$cancelCallback$1 = $eHVWl.unstable_cancelCallback, $6981e83672fe6c5f$var$shouldYield = $eHVWl.unstable_shouldYield, $6981e83672fe6c5f$var$requestPaint = $eHVWl.unstable_requestPaint, $6981e83672fe6c5f$var$now = $eHVWl.unstable_now, $6981e83672fe6c5f$var$getCurrentPriorityLevel = $eHVWl.unstable_getCurrentPriorityLevel, $6981e83672fe6c5f$var$ImmediatePriority = $eHVWl.unstable_ImmediatePriority, $6981e83672fe6c5f$var$UserBlockingPriority = $eHVWl.unstable_UserBlockingPriority, $6981e83672fe6c5f$var$NormalPriority$1 = $eHVWl.unstable_NormalPriority, $6981e83672fe6c5f$var$LowPriority = $eHVWl.unstable_LowPriority, $6981e83672fe6c5f$var$IdlePriority = $eHVWl.unstable_IdlePriority, $6981e83672fe6c5f$var$log$1 = $eHVWl.log, $6981e83672fe6c5f$var$unstable_setDisableYieldValue = $eHVWl.unstable_setDisableYieldValue, $6981e83672fe6c5f$var$rendererID = null, $6981e83672fe6c5f$var$injectedHook = null;
function $6981e83672fe6c5f$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $6981e83672fe6c5f$var$log$1 && $6981e83672fe6c5f$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($6981e83672fe6c5f$var$injectedHook && "function" === typeof $6981e83672fe6c5f$var$injectedHook.setStrictMode) try {
        $6981e83672fe6c5f$var$injectedHook.setStrictMode($6981e83672fe6c5f$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $6981e83672fe6c5f$var$clz32 = Math.clz32 ? Math.clz32 : $6981e83672fe6c5f$var$clz32Fallback, $6981e83672fe6c5f$var$log = Math.log, $6981e83672fe6c5f$var$LN2 = Math.LN2;
function $6981e83672fe6c5f$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($6981e83672fe6c5f$var$log(x) / $6981e83672fe6c5f$var$LN2 | 0) | 0;
}
var $6981e83672fe6c5f$var$nextTransitionUpdateLane = 256, $6981e83672fe6c5f$var$nextTransitionDeferredLane = 262144, $6981e83672fe6c5f$var$nextRetryLane = 4194304;
function $6981e83672fe6c5f$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $6981e83672fe6c5f$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $6981e83672fe6c5f$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $6981e83672fe6c5f$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $6981e83672fe6c5f$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $6981e83672fe6c5f$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $6981e83672fe6c5f$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $6981e83672fe6c5f$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $6981e83672fe6c5f$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $6981e83672fe6c5f$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $6981e83672fe6c5f$var$claimNextRetryLane() {
    var lane = $6981e83672fe6c5f$var$nextRetryLane;
    $6981e83672fe6c5f$var$nextRetryLane <<= 1;
    0 === ($6981e83672fe6c5f$var$nextRetryLane & 62914560) && ($6981e83672fe6c5f$var$nextRetryLane = 4194304);
    return lane;
}
function $6981e83672fe6c5f$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $6981e83672fe6c5f$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $6981e83672fe6c5f$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $6981e83672fe6c5f$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $6981e83672fe6c5f$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $6981e83672fe6c5f$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $6981e83672fe6c5f$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $6981e83672fe6c5f$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $6981e83672fe6c5f$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $6981e83672fe6c5f$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $6981e83672fe6c5f$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $6981e83672fe6c5f$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $6981e83672fe6c5f$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $6981e83672fe6c5f$var$resolveUpdatePriority() {
    var updatePriority = $6981e83672fe6c5f$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $6981e83672fe6c5f$var$getEventPriority(updatePriority.type);
}
function $6981e83672fe6c5f$var$runWithPriority(priority, fn) {
    var previousPriority = $6981e83672fe6c5f$var$ReactDOMSharedInternals.p;
    try {
        return $6981e83672fe6c5f$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $6981e83672fe6c5f$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $6981e83672fe6c5f$var$randomKey = Math.random().toString(36).slice(2), $6981e83672fe6c5f$var$internalInstanceKey = "__reactFiber$" + $6981e83672fe6c5f$var$randomKey, $6981e83672fe6c5f$var$internalPropsKey = "__reactProps$" + $6981e83672fe6c5f$var$randomKey, $6981e83672fe6c5f$var$internalContainerInstanceKey = "__reactContainer$" + $6981e83672fe6c5f$var$randomKey, $6981e83672fe6c5f$var$internalEventHandlersKey = "__reactEvents$" + $6981e83672fe6c5f$var$randomKey, $6981e83672fe6c5f$var$internalEventHandlerListenersKey = "__reactListeners$" + $6981e83672fe6c5f$var$randomKey, $6981e83672fe6c5f$var$internalEventHandlesSetKey = "__reactHandles$" + $6981e83672fe6c5f$var$randomKey, $6981e83672fe6c5f$var$internalRootNodeResourcesKey = "__reactResources$" + $6981e83672fe6c5f$var$randomKey, $6981e83672fe6c5f$var$internalHoistableMarker = "__reactMarker$" + $6981e83672fe6c5f$var$randomKey;
function $6981e83672fe6c5f$var$detachDeletedInstance(node) {
    delete node[$6981e83672fe6c5f$var$internalInstanceKey];
    delete node[$6981e83672fe6c5f$var$internalPropsKey];
    delete node[$6981e83672fe6c5f$var$internalEventHandlersKey];
    delete node[$6981e83672fe6c5f$var$internalEventHandlerListenersKey];
    delete node[$6981e83672fe6c5f$var$internalEventHandlesSetKey];
}
function $6981e83672fe6c5f$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$6981e83672fe6c5f$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$6981e83672fe6c5f$var$internalContainerInstanceKey] || parentNode[$6981e83672fe6c5f$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $6981e83672fe6c5f$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$6981e83672fe6c5f$var$internalInstanceKey]) return parentNode;
                targetNode = $6981e83672fe6c5f$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $6981e83672fe6c5f$var$getInstanceFromNode(node) {
    if (node = node[$6981e83672fe6c5f$var$internalInstanceKey] || node[$6981e83672fe6c5f$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $6981e83672fe6c5f$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(33));
}
function $6981e83672fe6c5f$var$getResourcesFromRoot(root) {
    var resources = root[$6981e83672fe6c5f$var$internalRootNodeResourcesKey];
    resources || (resources = root[$6981e83672fe6c5f$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $6981e83672fe6c5f$var$markNodeAsHoistable(node) {
    node[$6981e83672fe6c5f$var$internalHoistableMarker] = !0;
}
var $6981e83672fe6c5f$var$allNativeEvents = new Set(), $6981e83672fe6c5f$var$registrationNameDependencies = {};
function $6981e83672fe6c5f$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $6981e83672fe6c5f$var$registerDirectEvent(registrationName, dependencies);
    $6981e83672fe6c5f$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $6981e83672fe6c5f$var$registerDirectEvent(registrationName, dependencies) {
    $6981e83672fe6c5f$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$6981e83672fe6c5f$var$allNativeEvents.add(dependencies[registrationName]);
}
var $6981e83672fe6c5f$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $6981e83672fe6c5f$var$illegalAttributeNameCache = {}, $6981e83672fe6c5f$var$validatedAttributeNameCache = {};
function $6981e83672fe6c5f$var$isAttributeNameSafe(attributeName) {
    if ($6981e83672fe6c5f$var$hasOwnProperty.call($6981e83672fe6c5f$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($6981e83672fe6c5f$var$hasOwnProperty.call($6981e83672fe6c5f$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($6981e83672fe6c5f$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $6981e83672fe6c5f$var$validatedAttributeNameCache[attributeName] = !0;
    $6981e83672fe6c5f$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $6981e83672fe6c5f$var$setValueForAttribute(node, name, value) {
    if ($6981e83672fe6c5f$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $6981e83672fe6c5f$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $6981e83672fe6c5f$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $6981e83672fe6c5f$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $6981e83672fe6c5f$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $6981e83672fe6c5f$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $6981e83672fe6c5f$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $6981e83672fe6c5f$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $6981e83672fe6c5f$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $6981e83672fe6c5f$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $6981e83672fe6c5f$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $6981e83672fe6c5f$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $6981e83672fe6c5f$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $6981e83672fe6c5f$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($6981e83672fe6c5f$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $6981e83672fe6c5f$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $6981e83672fe6c5f$var$getToStringValue(value);
        } else element.value !== "" + $6981e83672fe6c5f$var$getToStringValue(value) && (element.value = "" + $6981e83672fe6c5f$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $6981e83672fe6c5f$var$setDefaultValue(element, type, $6981e83672fe6c5f$var$getToStringValue(value)) : null != defaultValue ? $6981e83672fe6c5f$var$setDefaultValue(element, type, $6981e83672fe6c5f$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $6981e83672fe6c5f$var$getToStringValue(name) : element.removeAttribute("name");
}
function $6981e83672fe6c5f$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $6981e83672fe6c5f$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $6981e83672fe6c5f$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $6981e83672fe6c5f$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $6981e83672fe6c5f$var$track(element);
}
function $6981e83672fe6c5f$var$setDefaultValue(node, type, value) {
    "number" === type && $6981e83672fe6c5f$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $6981e83672fe6c5f$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $6981e83672fe6c5f$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $6981e83672fe6c5f$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $6981e83672fe6c5f$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $6981e83672fe6c5f$var$getToStringValue(defaultValue) : "";
}
function $6981e83672fe6c5f$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(92));
            if ($6981e83672fe6c5f$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $6981e83672fe6c5f$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $6981e83672fe6c5f$var$track(element);
}
function $6981e83672fe6c5f$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $6981e83672fe6c5f$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $6981e83672fe6c5f$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $6981e83672fe6c5f$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $6981e83672fe6c5f$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $6981e83672fe6c5f$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $6981e83672fe6c5f$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $6981e83672fe6c5f$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $6981e83672fe6c5f$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $6981e83672fe6c5f$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $6981e83672fe6c5f$var$sanitizeURL(url) {
    return $6981e83672fe6c5f$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $6981e83672fe6c5f$var$noop$1() {}
var $6981e83672fe6c5f$var$currentReplayingEvent = null;
function $6981e83672fe6c5f$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $6981e83672fe6c5f$var$restoreTarget = null, $6981e83672fe6c5f$var$restoreQueue = null;
function $6981e83672fe6c5f$var$restoreStateOfTarget(target) {
    var internalInstance = $6981e83672fe6c5f$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$6981e83672fe6c5f$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $6981e83672fe6c5f$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $6981e83672fe6c5f$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$6981e83672fe6c5f$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(90));
                            $6981e83672fe6c5f$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $6981e83672fe6c5f$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $6981e83672fe6c5f$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $6981e83672fe6c5f$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $6981e83672fe6c5f$var$isInsideEventHandler = !1;
function $6981e83672fe6c5f$var$batchedUpdates$1(fn, a, b) {
    if ($6981e83672fe6c5f$var$isInsideEventHandler) return fn(a, b);
    $6981e83672fe6c5f$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($6981e83672fe6c5f$var$isInsideEventHandler = !1, null !== $6981e83672fe6c5f$var$restoreTarget || null !== $6981e83672fe6c5f$var$restoreQueue) {
            if ($6981e83672fe6c5f$var$flushSyncWork$1(), $6981e83672fe6c5f$var$restoreTarget && (a = $6981e83672fe6c5f$var$restoreTarget, fn = $6981e83672fe6c5f$var$restoreQueue, $6981e83672fe6c5f$var$restoreQueue = $6981e83672fe6c5f$var$restoreTarget = null, $6981e83672fe6c5f$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$6981e83672fe6c5f$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $6981e83672fe6c5f$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$6981e83672fe6c5f$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $6981e83672fe6c5f$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $6981e83672fe6c5f$var$passiveBrowserEventsSupported = !1;
if ($6981e83672fe6c5f$var$canUseDOM) try {
    var $6981e83672fe6c5f$var$options = {};
    Object.defineProperty($6981e83672fe6c5f$var$options, "passive", {
        get: function() {
            $6981e83672fe6c5f$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $6981e83672fe6c5f$var$options, $6981e83672fe6c5f$var$options);
    window.removeEventListener("test", $6981e83672fe6c5f$var$options, $6981e83672fe6c5f$var$options);
} catch (e) {
    $6981e83672fe6c5f$var$passiveBrowserEventsSupported = !1;
}
var $6981e83672fe6c5f$var$root = null, $6981e83672fe6c5f$var$startText = null, $6981e83672fe6c5f$var$fallbackText = null;
function $6981e83672fe6c5f$var$getData() {
    if ($6981e83672fe6c5f$var$fallbackText) return $6981e83672fe6c5f$var$fallbackText;
    var start, startValue = $6981e83672fe6c5f$var$startText, startLength = startValue.length, end, endValue = "value" in $6981e83672fe6c5f$var$root ? $6981e83672fe6c5f$var$root.value : $6981e83672fe6c5f$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $6981e83672fe6c5f$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $6981e83672fe6c5f$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $6981e83672fe6c5f$var$functionThatReturnsTrue() {
    return !0;
}
function $6981e83672fe6c5f$var$functionThatReturnsFalse() {
    return !1;
}
function $6981e83672fe6c5f$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $6981e83672fe6c5f$var$functionThatReturnsTrue : $6981e83672fe6c5f$var$functionThatReturnsFalse;
        this.isPropagationStopped = $6981e83672fe6c5f$var$functionThatReturnsFalse;
        return this;
    }
    $6981e83672fe6c5f$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $6981e83672fe6c5f$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $6981e83672fe6c5f$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $6981e83672fe6c5f$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $6981e83672fe6c5f$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $6981e83672fe6c5f$var$SyntheticEvent = $6981e83672fe6c5f$var$createSyntheticEvent($6981e83672fe6c5f$var$EventInterface), $6981e83672fe6c5f$var$UIEventInterface = $6981e83672fe6c5f$var$assign({}, $6981e83672fe6c5f$var$EventInterface, {
    view: 0,
    detail: 0
}), $6981e83672fe6c5f$var$SyntheticUIEvent = $6981e83672fe6c5f$var$createSyntheticEvent($6981e83672fe6c5f$var$UIEventInterface), $6981e83672fe6c5f$var$lastMovementX, $6981e83672fe6c5f$var$lastMovementY, $6981e83672fe6c5f$var$lastMouseEvent, $6981e83672fe6c5f$var$MouseEventInterface = $6981e83672fe6c5f$var$assign({}, $6981e83672fe6c5f$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $6981e83672fe6c5f$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $6981e83672fe6c5f$var$lastMouseEvent && ($6981e83672fe6c5f$var$lastMouseEvent && "mousemove" === event.type ? ($6981e83672fe6c5f$var$lastMovementX = event.screenX - $6981e83672fe6c5f$var$lastMouseEvent.screenX, $6981e83672fe6c5f$var$lastMovementY = event.screenY - $6981e83672fe6c5f$var$lastMouseEvent.screenY) : $6981e83672fe6c5f$var$lastMovementY = $6981e83672fe6c5f$var$lastMovementX = 0, $6981e83672fe6c5f$var$lastMouseEvent = event);
        return $6981e83672fe6c5f$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $6981e83672fe6c5f$var$lastMovementY;
    }
}), $6981e83672fe6c5f$var$SyntheticMouseEvent = $6981e83672fe6c5f$var$createSyntheticEvent($6981e83672fe6c5f$var$MouseEventInterface), $6981e83672fe6c5f$var$DragEventInterface = $6981e83672fe6c5f$var$assign({}, $6981e83672fe6c5f$var$MouseEventInterface, {
    dataTransfer: 0
}), $6981e83672fe6c5f$var$SyntheticDragEvent = $6981e83672fe6c5f$var$createSyntheticEvent($6981e83672fe6c5f$var$DragEventInterface), $6981e83672fe6c5f$var$FocusEventInterface = $6981e83672fe6c5f$var$assign({}, $6981e83672fe6c5f$var$UIEventInterface, {
    relatedTarget: 0
}), $6981e83672fe6c5f$var$SyntheticFocusEvent = $6981e83672fe6c5f$var$createSyntheticEvent($6981e83672fe6c5f$var$FocusEventInterface), $6981e83672fe6c5f$var$AnimationEventInterface = $6981e83672fe6c5f$var$assign({}, $6981e83672fe6c5f$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $6981e83672fe6c5f$var$SyntheticAnimationEvent = $6981e83672fe6c5f$var$createSyntheticEvent($6981e83672fe6c5f$var$AnimationEventInterface), $6981e83672fe6c5f$var$ClipboardEventInterface = $6981e83672fe6c5f$var$assign({}, $6981e83672fe6c5f$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $6981e83672fe6c5f$var$SyntheticClipboardEvent = $6981e83672fe6c5f$var$createSyntheticEvent($6981e83672fe6c5f$var$ClipboardEventInterface), $6981e83672fe6c5f$var$CompositionEventInterface = $6981e83672fe6c5f$var$assign({}, $6981e83672fe6c5f$var$EventInterface, {
    data: 0
}), $6981e83672fe6c5f$var$SyntheticCompositionEvent = $6981e83672fe6c5f$var$createSyntheticEvent($6981e83672fe6c5f$var$CompositionEventInterface), $6981e83672fe6c5f$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $6981e83672fe6c5f$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $6981e83672fe6c5f$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $6981e83672fe6c5f$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $6981e83672fe6c5f$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $6981e83672fe6c5f$var$getEventModifierState() {
    return $6981e83672fe6c5f$var$modifierStateGetter;
}
var $6981e83672fe6c5f$var$KeyboardEventInterface = $6981e83672fe6c5f$var$assign({}, $6981e83672fe6c5f$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $6981e83672fe6c5f$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $6981e83672fe6c5f$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $6981e83672fe6c5f$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $6981e83672fe6c5f$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $6981e83672fe6c5f$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $6981e83672fe6c5f$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $6981e83672fe6c5f$var$SyntheticKeyboardEvent = $6981e83672fe6c5f$var$createSyntheticEvent($6981e83672fe6c5f$var$KeyboardEventInterface), $6981e83672fe6c5f$var$PointerEventInterface = $6981e83672fe6c5f$var$assign({}, $6981e83672fe6c5f$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $6981e83672fe6c5f$var$SyntheticPointerEvent = $6981e83672fe6c5f$var$createSyntheticEvent($6981e83672fe6c5f$var$PointerEventInterface), $6981e83672fe6c5f$var$TouchEventInterface = $6981e83672fe6c5f$var$assign({}, $6981e83672fe6c5f$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $6981e83672fe6c5f$var$getEventModifierState
}), $6981e83672fe6c5f$var$SyntheticTouchEvent = $6981e83672fe6c5f$var$createSyntheticEvent($6981e83672fe6c5f$var$TouchEventInterface), $6981e83672fe6c5f$var$TransitionEventInterface = $6981e83672fe6c5f$var$assign({}, $6981e83672fe6c5f$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $6981e83672fe6c5f$var$SyntheticTransitionEvent = $6981e83672fe6c5f$var$createSyntheticEvent($6981e83672fe6c5f$var$TransitionEventInterface), $6981e83672fe6c5f$var$WheelEventInterface = $6981e83672fe6c5f$var$assign({}, $6981e83672fe6c5f$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $6981e83672fe6c5f$var$SyntheticWheelEvent = $6981e83672fe6c5f$var$createSyntheticEvent($6981e83672fe6c5f$var$WheelEventInterface), $6981e83672fe6c5f$var$ToggleEventInterface = $6981e83672fe6c5f$var$assign({}, $6981e83672fe6c5f$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $6981e83672fe6c5f$var$SyntheticToggleEvent = $6981e83672fe6c5f$var$createSyntheticEvent($6981e83672fe6c5f$var$ToggleEventInterface), $6981e83672fe6c5f$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $6981e83672fe6c5f$var$canUseCompositionEvent = $6981e83672fe6c5f$var$canUseDOM && "CompositionEvent" in window, $6981e83672fe6c5f$var$documentMode = null;
$6981e83672fe6c5f$var$canUseDOM && "documentMode" in document && ($6981e83672fe6c5f$var$documentMode = document.documentMode);
var $6981e83672fe6c5f$var$canUseTextInputEvent = $6981e83672fe6c5f$var$canUseDOM && "TextEvent" in window && !$6981e83672fe6c5f$var$documentMode, $6981e83672fe6c5f$var$useFallbackCompositionData = $6981e83672fe6c5f$var$canUseDOM && (!$6981e83672fe6c5f$var$canUseCompositionEvent || $6981e83672fe6c5f$var$documentMode && 8 < $6981e83672fe6c5f$var$documentMode && 11 >= $6981e83672fe6c5f$var$documentMode), $6981e83672fe6c5f$var$SPACEBAR_CHAR = String.fromCharCode(32), $6981e83672fe6c5f$var$hasSpaceKeypress = !1;
function $6981e83672fe6c5f$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $6981e83672fe6c5f$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $6981e83672fe6c5f$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $6981e83672fe6c5f$var$isComposing = !1;
function $6981e83672fe6c5f$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $6981e83672fe6c5f$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $6981e83672fe6c5f$var$hasSpaceKeypress = !0;
            return $6981e83672fe6c5f$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $6981e83672fe6c5f$var$SPACEBAR_CHAR && $6981e83672fe6c5f$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $6981e83672fe6c5f$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($6981e83672fe6c5f$var$isComposing) return "compositionend" === domEventName || !$6981e83672fe6c5f$var$canUseCompositionEvent && $6981e83672fe6c5f$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $6981e83672fe6c5f$var$getData(), $6981e83672fe6c5f$var$fallbackText = $6981e83672fe6c5f$var$startText = $6981e83672fe6c5f$var$root = null, $6981e83672fe6c5f$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $6981e83672fe6c5f$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $6981e83672fe6c5f$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $6981e83672fe6c5f$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$6981e83672fe6c5f$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $6981e83672fe6c5f$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $6981e83672fe6c5f$var$restoreTarget ? $6981e83672fe6c5f$var$restoreQueue ? $6981e83672fe6c5f$var$restoreQueue.push(target) : $6981e83672fe6c5f$var$restoreQueue = [
        target
    ] : $6981e83672fe6c5f$var$restoreTarget = target;
    inst = $6981e83672fe6c5f$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $6981e83672fe6c5f$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $6981e83672fe6c5f$var$activeElement$1 = null, $6981e83672fe6c5f$var$activeElementInst$1 = null;
function $6981e83672fe6c5f$var$runEventInBatch(dispatchQueue) {
    $6981e83672fe6c5f$var$processDispatchQueue(dispatchQueue, 0);
}
function $6981e83672fe6c5f$var$getInstIfValueChanged(targetInst) {
    var targetNode = $6981e83672fe6c5f$var$getNodeFromInstance(targetInst);
    if ($6981e83672fe6c5f$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $6981e83672fe6c5f$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $6981e83672fe6c5f$var$isInputEventSupported = !1;
if ($6981e83672fe6c5f$var$canUseDOM) {
    var $6981e83672fe6c5f$var$JSCompiler_inline_result$jscomp$286;
    if ($6981e83672fe6c5f$var$canUseDOM) {
        var $6981e83672fe6c5f$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$6981e83672fe6c5f$var$isSupported$jscomp$inline_427) {
            var $6981e83672fe6c5f$var$element$jscomp$inline_428 = document.createElement("div");
            $6981e83672fe6c5f$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $6981e83672fe6c5f$var$isSupported$jscomp$inline_427 = "function" === typeof $6981e83672fe6c5f$var$element$jscomp$inline_428.oninput;
        }
        $6981e83672fe6c5f$var$JSCompiler_inline_result$jscomp$286 = $6981e83672fe6c5f$var$isSupported$jscomp$inline_427;
    } else $6981e83672fe6c5f$var$JSCompiler_inline_result$jscomp$286 = !1;
    $6981e83672fe6c5f$var$isInputEventSupported = $6981e83672fe6c5f$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $6981e83672fe6c5f$var$stopWatchingForValueChange() {
    $6981e83672fe6c5f$var$activeElement$1 && ($6981e83672fe6c5f$var$activeElement$1.detachEvent("onpropertychange", $6981e83672fe6c5f$var$handlePropertyChange), $6981e83672fe6c5f$var$activeElementInst$1 = $6981e83672fe6c5f$var$activeElement$1 = null);
}
function $6981e83672fe6c5f$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $6981e83672fe6c5f$var$getInstIfValueChanged($6981e83672fe6c5f$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $6981e83672fe6c5f$var$createAndAccumulateChangeEvent(dispatchQueue, $6981e83672fe6c5f$var$activeElementInst$1, nativeEvent, $6981e83672fe6c5f$var$getEventTarget(nativeEvent));
        $6981e83672fe6c5f$var$batchedUpdates$1($6981e83672fe6c5f$var$runEventInBatch, dispatchQueue);
    }
}
function $6981e83672fe6c5f$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($6981e83672fe6c5f$var$stopWatchingForValueChange(), $6981e83672fe6c5f$var$activeElement$1 = target, $6981e83672fe6c5f$var$activeElementInst$1 = targetInst, $6981e83672fe6c5f$var$activeElement$1.attachEvent("onpropertychange", $6981e83672fe6c5f$var$handlePropertyChange)) : "focusout" === domEventName && $6981e83672fe6c5f$var$stopWatchingForValueChange();
}
function $6981e83672fe6c5f$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $6981e83672fe6c5f$var$getInstIfValueChanged($6981e83672fe6c5f$var$activeElementInst$1);
}
function $6981e83672fe6c5f$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $6981e83672fe6c5f$var$getInstIfValueChanged(targetInst);
}
function $6981e83672fe6c5f$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $6981e83672fe6c5f$var$getInstIfValueChanged(targetInst);
}
function $6981e83672fe6c5f$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $6981e83672fe6c5f$var$objectIs = "function" === typeof Object.is ? Object.is : $6981e83672fe6c5f$var$is;
function $6981e83672fe6c5f$var$shallowEqual(objA, objB) {
    if ($6981e83672fe6c5f$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$6981e83672fe6c5f$var$hasOwnProperty.call(objB, currentKey) || !$6981e83672fe6c5f$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $6981e83672fe6c5f$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $6981e83672fe6c5f$var$getNodeForCharacterOffset(root, offset) {
    var node = $6981e83672fe6c5f$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $6981e83672fe6c5f$var$getLeafNode(node);
    }
}
function $6981e83672fe6c5f$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $6981e83672fe6c5f$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $6981e83672fe6c5f$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $6981e83672fe6c5f$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $6981e83672fe6c5f$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $6981e83672fe6c5f$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $6981e83672fe6c5f$var$skipSelectionChangeEvent = $6981e83672fe6c5f$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $6981e83672fe6c5f$var$activeElement = null, $6981e83672fe6c5f$var$activeElementInst = null, $6981e83672fe6c5f$var$lastSelection = null, $6981e83672fe6c5f$var$mouseDown = !1;
function $6981e83672fe6c5f$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $6981e83672fe6c5f$var$mouseDown || null == $6981e83672fe6c5f$var$activeElement || $6981e83672fe6c5f$var$activeElement !== $6981e83672fe6c5f$var$getActiveElement(doc) || (doc = $6981e83672fe6c5f$var$activeElement, "selectionStart" in doc && $6981e83672fe6c5f$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $6981e83672fe6c5f$var$lastSelection && $6981e83672fe6c5f$var$shallowEqual($6981e83672fe6c5f$var$lastSelection, doc) || ($6981e83672fe6c5f$var$lastSelection = doc, doc = $6981e83672fe6c5f$var$accumulateTwoPhaseListeners($6981e83672fe6c5f$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $6981e83672fe6c5f$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $6981e83672fe6c5f$var$activeElement)));
}
function $6981e83672fe6c5f$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $6981e83672fe6c5f$var$vendorPrefixes = {
    animationend: $6981e83672fe6c5f$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $6981e83672fe6c5f$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $6981e83672fe6c5f$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $6981e83672fe6c5f$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $6981e83672fe6c5f$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $6981e83672fe6c5f$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $6981e83672fe6c5f$var$makePrefixMap("Transition", "TransitionEnd")
}, $6981e83672fe6c5f$var$prefixedEventNames = {}, $6981e83672fe6c5f$var$style = {};
$6981e83672fe6c5f$var$canUseDOM && ($6981e83672fe6c5f$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $6981e83672fe6c5f$var$vendorPrefixes.animationend.animation, delete $6981e83672fe6c5f$var$vendorPrefixes.animationiteration.animation, delete $6981e83672fe6c5f$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $6981e83672fe6c5f$var$vendorPrefixes.transitionend.transition);
function $6981e83672fe6c5f$var$getVendorPrefixedEventName(eventName) {
    if ($6981e83672fe6c5f$var$prefixedEventNames[eventName]) return $6981e83672fe6c5f$var$prefixedEventNames[eventName];
    if (!$6981e83672fe6c5f$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $6981e83672fe6c5f$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $6981e83672fe6c5f$var$style) return $6981e83672fe6c5f$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $6981e83672fe6c5f$var$ANIMATION_END = $6981e83672fe6c5f$var$getVendorPrefixedEventName("animationend"), $6981e83672fe6c5f$var$ANIMATION_ITERATION = $6981e83672fe6c5f$var$getVendorPrefixedEventName("animationiteration"), $6981e83672fe6c5f$var$ANIMATION_START = $6981e83672fe6c5f$var$getVendorPrefixedEventName("animationstart"), $6981e83672fe6c5f$var$TRANSITION_RUN = $6981e83672fe6c5f$var$getVendorPrefixedEventName("transitionrun"), $6981e83672fe6c5f$var$TRANSITION_START = $6981e83672fe6c5f$var$getVendorPrefixedEventName("transitionstart"), $6981e83672fe6c5f$var$TRANSITION_CANCEL = $6981e83672fe6c5f$var$getVendorPrefixedEventName("transitioncancel"), $6981e83672fe6c5f$var$TRANSITION_END = $6981e83672fe6c5f$var$getVendorPrefixedEventName("transitionend"), $6981e83672fe6c5f$var$topLevelEventsToReactNames = new Map(), $6981e83672fe6c5f$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$6981e83672fe6c5f$var$simpleEventPluginEvents.push("scrollEnd");
function $6981e83672fe6c5f$var$registerSimpleEvent(domEventName, reactName) {
    $6981e83672fe6c5f$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $6981e83672fe6c5f$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $6981e83672fe6c5f$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $6981e83672fe6c5f$var$concurrentQueues = [], $6981e83672fe6c5f$var$concurrentQueuesIndex = 0, $6981e83672fe6c5f$var$concurrentlyUpdatedLanes = 0;
function $6981e83672fe6c5f$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $6981e83672fe6c5f$var$concurrentQueuesIndex, i = $6981e83672fe6c5f$var$concurrentlyUpdatedLanes = $6981e83672fe6c5f$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $6981e83672fe6c5f$var$concurrentQueues[i];
        $6981e83672fe6c5f$var$concurrentQueues[i++] = null;
        var queue = $6981e83672fe6c5f$var$concurrentQueues[i];
        $6981e83672fe6c5f$var$concurrentQueues[i++] = null;
        var update = $6981e83672fe6c5f$var$concurrentQueues[i];
        $6981e83672fe6c5f$var$concurrentQueues[i++] = null;
        var lane = $6981e83672fe6c5f$var$concurrentQueues[i];
        $6981e83672fe6c5f$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $6981e83672fe6c5f$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $6981e83672fe6c5f$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $6981e83672fe6c5f$var$concurrentQueues[$6981e83672fe6c5f$var$concurrentQueuesIndex++] = fiber;
    $6981e83672fe6c5f$var$concurrentQueues[$6981e83672fe6c5f$var$concurrentQueuesIndex++] = queue;
    $6981e83672fe6c5f$var$concurrentQueues[$6981e83672fe6c5f$var$concurrentQueuesIndex++] = update;
    $6981e83672fe6c5f$var$concurrentQueues[$6981e83672fe6c5f$var$concurrentQueuesIndex++] = lane;
    $6981e83672fe6c5f$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $6981e83672fe6c5f$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $6981e83672fe6c5f$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $6981e83672fe6c5f$var$getRootForUpdatedFiber(fiber);
}
function $6981e83672fe6c5f$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $6981e83672fe6c5f$var$enqueueUpdate$1(fiber, null, null, lane);
    return $6981e83672fe6c5f$var$getRootForUpdatedFiber(fiber);
}
function $6981e83672fe6c5f$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $6981e83672fe6c5f$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $6981e83672fe6c5f$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $6981e83672fe6c5f$var$nestedUpdateCount) throw $6981e83672fe6c5f$var$nestedUpdateCount = 0, $6981e83672fe6c5f$var$rootWithNestedUpdates = null, Error($6981e83672fe6c5f$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $6981e83672fe6c5f$var$emptyContextObject = {};
function $6981e83672fe6c5f$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $6981e83672fe6c5f$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $6981e83672fe6c5f$var$FiberNode(tag, pendingProps, key, mode);
}
function $6981e83672fe6c5f$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $6981e83672fe6c5f$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $6981e83672fe6c5f$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $6981e83672fe6c5f$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $6981e83672fe6c5f$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $6981e83672fe6c5f$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $6981e83672fe6c5f$var$isHostHoistableType(type, pendingProps, $6981e83672fe6c5f$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $6981e83672fe6c5f$var$REACT_ACTIVITY_TYPE:
            return type = $6981e83672fe6c5f$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $6981e83672fe6c5f$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $6981e83672fe6c5f$var$REACT_FRAGMENT_TYPE:
            return $6981e83672fe6c5f$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $6981e83672fe6c5f$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $6981e83672fe6c5f$var$REACT_PROFILER_TYPE:
            return type = $6981e83672fe6c5f$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $6981e83672fe6c5f$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $6981e83672fe6c5f$var$REACT_SUSPENSE_TYPE:
            return type = $6981e83672fe6c5f$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $6981e83672fe6c5f$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $6981e83672fe6c5f$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $6981e83672fe6c5f$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $6981e83672fe6c5f$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $6981e83672fe6c5f$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $6981e83672fe6c5f$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $6981e83672fe6c5f$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $6981e83672fe6c5f$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $6981e83672fe6c5f$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($6981e83672fe6c5f$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $6981e83672fe6c5f$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $6981e83672fe6c5f$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $6981e83672fe6c5f$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $6981e83672fe6c5f$var$createFiberFromText(content, mode, lanes) {
    content = $6981e83672fe6c5f$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $6981e83672fe6c5f$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $6981e83672fe6c5f$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $6981e83672fe6c5f$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $6981e83672fe6c5f$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $6981e83672fe6c5f$var$CapturedStacks = new WeakMap();
function $6981e83672fe6c5f$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $6981e83672fe6c5f$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $6981e83672fe6c5f$var$getStackByFiberInDevAndProd(source)
        };
        $6981e83672fe6c5f$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $6981e83672fe6c5f$var$getStackByFiberInDevAndProd(source)
    };
}
var $6981e83672fe6c5f$var$forkStack = [], $6981e83672fe6c5f$var$forkStackIndex = 0, $6981e83672fe6c5f$var$treeForkProvider = null, $6981e83672fe6c5f$var$treeForkCount = 0, $6981e83672fe6c5f$var$idStack = [], $6981e83672fe6c5f$var$idStackIndex = 0, $6981e83672fe6c5f$var$treeContextProvider = null, $6981e83672fe6c5f$var$treeContextId = 1, $6981e83672fe6c5f$var$treeContextOverflow = "";
function $6981e83672fe6c5f$var$pushTreeFork(workInProgress, totalChildren) {
    $6981e83672fe6c5f$var$forkStack[$6981e83672fe6c5f$var$forkStackIndex++] = $6981e83672fe6c5f$var$treeForkCount;
    $6981e83672fe6c5f$var$forkStack[$6981e83672fe6c5f$var$forkStackIndex++] = $6981e83672fe6c5f$var$treeForkProvider;
    $6981e83672fe6c5f$var$treeForkProvider = workInProgress;
    $6981e83672fe6c5f$var$treeForkCount = totalChildren;
}
function $6981e83672fe6c5f$var$pushTreeId(workInProgress, totalChildren, index) {
    $6981e83672fe6c5f$var$idStack[$6981e83672fe6c5f$var$idStackIndex++] = $6981e83672fe6c5f$var$treeContextId;
    $6981e83672fe6c5f$var$idStack[$6981e83672fe6c5f$var$idStackIndex++] = $6981e83672fe6c5f$var$treeContextOverflow;
    $6981e83672fe6c5f$var$idStack[$6981e83672fe6c5f$var$idStackIndex++] = $6981e83672fe6c5f$var$treeContextProvider;
    $6981e83672fe6c5f$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $6981e83672fe6c5f$var$treeContextId;
    workInProgress = $6981e83672fe6c5f$var$treeContextOverflow;
    var baseLength = 32 - $6981e83672fe6c5f$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $6981e83672fe6c5f$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $6981e83672fe6c5f$var$treeContextId = 1 << 32 - $6981e83672fe6c5f$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $6981e83672fe6c5f$var$treeContextOverflow = length + workInProgress;
    } else $6981e83672fe6c5f$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $6981e83672fe6c5f$var$treeContextOverflow = workInProgress;
}
function $6981e83672fe6c5f$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($6981e83672fe6c5f$var$pushTreeFork(workInProgress, 1), $6981e83672fe6c5f$var$pushTreeId(workInProgress, 1, 0));
}
function $6981e83672fe6c5f$var$popTreeContext(workInProgress) {
    for(; workInProgress === $6981e83672fe6c5f$var$treeForkProvider;)$6981e83672fe6c5f$var$treeForkProvider = $6981e83672fe6c5f$var$forkStack[--$6981e83672fe6c5f$var$forkStackIndex], $6981e83672fe6c5f$var$forkStack[$6981e83672fe6c5f$var$forkStackIndex] = null, $6981e83672fe6c5f$var$treeForkCount = $6981e83672fe6c5f$var$forkStack[--$6981e83672fe6c5f$var$forkStackIndex], $6981e83672fe6c5f$var$forkStack[$6981e83672fe6c5f$var$forkStackIndex] = null;
    for(; workInProgress === $6981e83672fe6c5f$var$treeContextProvider;)$6981e83672fe6c5f$var$treeContextProvider = $6981e83672fe6c5f$var$idStack[--$6981e83672fe6c5f$var$idStackIndex], $6981e83672fe6c5f$var$idStack[$6981e83672fe6c5f$var$idStackIndex] = null, $6981e83672fe6c5f$var$treeContextOverflow = $6981e83672fe6c5f$var$idStack[--$6981e83672fe6c5f$var$idStackIndex], $6981e83672fe6c5f$var$idStack[$6981e83672fe6c5f$var$idStackIndex] = null, $6981e83672fe6c5f$var$treeContextId = $6981e83672fe6c5f$var$idStack[--$6981e83672fe6c5f$var$idStackIndex], $6981e83672fe6c5f$var$idStack[$6981e83672fe6c5f$var$idStackIndex] = null;
}
function $6981e83672fe6c5f$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $6981e83672fe6c5f$var$idStack[$6981e83672fe6c5f$var$idStackIndex++] = $6981e83672fe6c5f$var$treeContextId;
    $6981e83672fe6c5f$var$idStack[$6981e83672fe6c5f$var$idStackIndex++] = $6981e83672fe6c5f$var$treeContextOverflow;
    $6981e83672fe6c5f$var$idStack[$6981e83672fe6c5f$var$idStackIndex++] = $6981e83672fe6c5f$var$treeContextProvider;
    $6981e83672fe6c5f$var$treeContextId = suspendedContext.id;
    $6981e83672fe6c5f$var$treeContextOverflow = suspendedContext.overflow;
    $6981e83672fe6c5f$var$treeContextProvider = workInProgress;
}
var $6981e83672fe6c5f$var$hydrationParentFiber = null, $6981e83672fe6c5f$var$nextHydratableInstance = null, $6981e83672fe6c5f$var$isHydrating = !1, $6981e83672fe6c5f$var$hydrationErrors = null, $6981e83672fe6c5f$var$rootOrSingletonContext = !1, $6981e83672fe6c5f$var$HydrationMismatchException = Error($6981e83672fe6c5f$var$formatProdErrorMessage(519));
function $6981e83672fe6c5f$var$throwOnHydrationMismatch(fiber) {
    var error = Error($6981e83672fe6c5f$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $6981e83672fe6c5f$var$queueHydrationError($6981e83672fe6c5f$var$createCapturedValueAtFiber(error, fiber));
    throw $6981e83672fe6c5f$var$HydrationMismatchException;
}
function $6981e83672fe6c5f$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$6981e83672fe6c5f$var$internalInstanceKey] = fiber;
    instance[$6981e83672fe6c5f$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("cancel", instance);
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $6981e83672fe6c5f$var$mediaEventTypes.length; type++)$6981e83672fe6c5f$var$listenToNonDelegatedEvent($6981e83672fe6c5f$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("error", instance);
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("invalid", instance);
            $6981e83672fe6c5f$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("invalid", instance), $6981e83672fe6c5f$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $6981e83672fe6c5f$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($6981e83672fe6c5f$var$listenToNonDelegatedEvent("beforetoggle", instance), $6981e83672fe6c5f$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $6981e83672fe6c5f$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $6981e83672fe6c5f$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $6981e83672fe6c5f$var$noop$1), instance = !0) : instance = !1;
    instance || $6981e83672fe6c5f$var$throwOnHydrationMismatch(fiber, !0);
}
function $6981e83672fe6c5f$var$popToNextHostParent(fiber) {
    for($6981e83672fe6c5f$var$hydrationParentFiber = fiber.return; $6981e83672fe6c5f$var$hydrationParentFiber;)switch($6981e83672fe6c5f$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $6981e83672fe6c5f$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $6981e83672fe6c5f$var$rootOrSingletonContext = !0;
            return;
        default:
            $6981e83672fe6c5f$var$hydrationParentFiber = $6981e83672fe6c5f$var$hydrationParentFiber.return;
    }
}
function $6981e83672fe6c5f$var$popHydrationState(fiber) {
    if (fiber !== $6981e83672fe6c5f$var$hydrationParentFiber) return !1;
    if (!$6981e83672fe6c5f$var$isHydrating) return $6981e83672fe6c5f$var$popToNextHostParent(fiber), $6981e83672fe6c5f$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $6981e83672fe6c5f$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $6981e83672fe6c5f$var$nextHydratableInstance && $6981e83672fe6c5f$var$throwOnHydrationMismatch(fiber);
    $6981e83672fe6c5f$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(317));
        $6981e83672fe6c5f$var$nextHydratableInstance = $6981e83672fe6c5f$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(317));
        $6981e83672fe6c5f$var$nextHydratableInstance = $6981e83672fe6c5f$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $6981e83672fe6c5f$var$nextHydratableInstance, $6981e83672fe6c5f$var$isSingletonScope(fiber.type) ? (fiber = $6981e83672fe6c5f$var$previousHydratableOnEnteringScopedSingleton, $6981e83672fe6c5f$var$previousHydratableOnEnteringScopedSingleton = null, $6981e83672fe6c5f$var$nextHydratableInstance = fiber) : $6981e83672fe6c5f$var$nextHydratableInstance = tag) : $6981e83672fe6c5f$var$nextHydratableInstance = $6981e83672fe6c5f$var$hydrationParentFiber ? $6981e83672fe6c5f$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $6981e83672fe6c5f$var$resetHydrationState() {
    $6981e83672fe6c5f$var$nextHydratableInstance = $6981e83672fe6c5f$var$hydrationParentFiber = null;
    $6981e83672fe6c5f$var$isHydrating = !1;
}
function $6981e83672fe6c5f$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $6981e83672fe6c5f$var$hydrationErrors;
    null !== queuedErrors && (null === $6981e83672fe6c5f$var$workInProgressRootRecoverableErrors ? $6981e83672fe6c5f$var$workInProgressRootRecoverableErrors = queuedErrors : $6981e83672fe6c5f$var$workInProgressRootRecoverableErrors.push.apply($6981e83672fe6c5f$var$workInProgressRootRecoverableErrors, queuedErrors), $6981e83672fe6c5f$var$hydrationErrors = null);
    return queuedErrors;
}
function $6981e83672fe6c5f$var$queueHydrationError(error) {
    null === $6981e83672fe6c5f$var$hydrationErrors ? $6981e83672fe6c5f$var$hydrationErrors = [
        error
    ] : $6981e83672fe6c5f$var$hydrationErrors.push(error);
}
var $6981e83672fe6c5f$var$valueCursor = $6981e83672fe6c5f$var$createCursor(null), $6981e83672fe6c5f$var$currentlyRenderingFiber$1 = null, $6981e83672fe6c5f$var$lastContextDependency = null;
function $6981e83672fe6c5f$var$pushProvider(providerFiber, context, nextValue) {
    $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $6981e83672fe6c5f$var$popProvider(context) {
    context._currentValue = $6981e83672fe6c5f$var$valueCursor.current;
    $6981e83672fe6c5f$var$pop($6981e83672fe6c5f$var$valueCursor);
}
function $6981e83672fe6c5f$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $6981e83672fe6c5f$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $6981e83672fe6c5f$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $6981e83672fe6c5f$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $6981e83672fe6c5f$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $6981e83672fe6c5f$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $6981e83672fe6c5f$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($6981e83672fe6c5f$var$HostTransitionContext) : current = [
                $6981e83672fe6c5f$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $6981e83672fe6c5f$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $6981e83672fe6c5f$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$6981e83672fe6c5f$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $6981e83672fe6c5f$var$prepareToReadContext(workInProgress) {
    $6981e83672fe6c5f$var$currentlyRenderingFiber$1 = workInProgress;
    $6981e83672fe6c5f$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $6981e83672fe6c5f$var$readContext(context) {
    return $6981e83672fe6c5f$var$readContextForConsumer($6981e83672fe6c5f$var$currentlyRenderingFiber$1, context);
}
function $6981e83672fe6c5f$var$readContextDuringReconciliation(consumer, context) {
    null === $6981e83672fe6c5f$var$currentlyRenderingFiber$1 && $6981e83672fe6c5f$var$prepareToReadContext(consumer);
    return $6981e83672fe6c5f$var$readContextForConsumer(consumer, context);
}
function $6981e83672fe6c5f$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $6981e83672fe6c5f$var$lastContextDependency) {
        if (null === consumer) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(308));
        $6981e83672fe6c5f$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $6981e83672fe6c5f$var$lastContextDependency = $6981e83672fe6c5f$var$lastContextDependency.next = context;
    return value;
}
var $6981e83672fe6c5f$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $6981e83672fe6c5f$var$scheduleCallback$2 = $eHVWl.unstable_scheduleCallback, $6981e83672fe6c5f$var$NormalPriority = $eHVWl.unstable_NormalPriority, $6981e83672fe6c5f$var$CacheContext = {
    $$typeof: $6981e83672fe6c5f$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $6981e83672fe6c5f$var$createCache() {
    return {
        controller: new $6981e83672fe6c5f$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $6981e83672fe6c5f$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $6981e83672fe6c5f$var$scheduleCallback$2($6981e83672fe6c5f$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $6981e83672fe6c5f$var$currentEntangledListeners = null, $6981e83672fe6c5f$var$currentEntangledPendingCount = 0, $6981e83672fe6c5f$var$currentEntangledLane = 0, $6981e83672fe6c5f$var$currentEntangledActionThenable = null;
function $6981e83672fe6c5f$var$entangleAsyncAction(transition, thenable) {
    if (null === $6981e83672fe6c5f$var$currentEntangledListeners) {
        var entangledListeners = $6981e83672fe6c5f$var$currentEntangledListeners = [];
        $6981e83672fe6c5f$var$currentEntangledPendingCount = 0;
        $6981e83672fe6c5f$var$currentEntangledLane = $6981e83672fe6c5f$var$requestTransitionLane();
        $6981e83672fe6c5f$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $6981e83672fe6c5f$var$currentEntangledPendingCount++;
    thenable.then($6981e83672fe6c5f$var$pingEngtangledActionScope, $6981e83672fe6c5f$var$pingEngtangledActionScope);
    return thenable;
}
function $6981e83672fe6c5f$var$pingEngtangledActionScope() {
    if (0 === --$6981e83672fe6c5f$var$currentEntangledPendingCount && null !== $6981e83672fe6c5f$var$currentEntangledListeners) {
        null !== $6981e83672fe6c5f$var$currentEntangledActionThenable && ($6981e83672fe6c5f$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $6981e83672fe6c5f$var$currentEntangledListeners;
        $6981e83672fe6c5f$var$currentEntangledListeners = null;
        $6981e83672fe6c5f$var$currentEntangledLane = 0;
        $6981e83672fe6c5f$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $6981e83672fe6c5f$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $6981e83672fe6c5f$var$prevOnStartTransitionFinish = $6981e83672fe6c5f$var$ReactSharedInternals.S;
$6981e83672fe6c5f$var$ReactSharedInternals.S = function(transition, returnValue) {
    $6981e83672fe6c5f$var$globalMostRecentTransitionTime = $6981e83672fe6c5f$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $6981e83672fe6c5f$var$entangleAsyncAction(transition, returnValue);
    null !== $6981e83672fe6c5f$var$prevOnStartTransitionFinish && $6981e83672fe6c5f$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $6981e83672fe6c5f$var$resumedCache = $6981e83672fe6c5f$var$createCursor(null);
function $6981e83672fe6c5f$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $6981e83672fe6c5f$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $6981e83672fe6c5f$var$workInProgressRoot.pooledCache;
}
function $6981e83672fe6c5f$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$resumedCache, $6981e83672fe6c5f$var$resumedCache.current) : $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$resumedCache, prevCachePool.pool);
}
function $6981e83672fe6c5f$var$getSuspendedCache() {
    var cacheFromPool = $6981e83672fe6c5f$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $6981e83672fe6c5f$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $6981e83672fe6c5f$var$SuspenseException = Error($6981e83672fe6c5f$var$formatProdErrorMessage(460)), $6981e83672fe6c5f$var$SuspenseyCommitException = Error($6981e83672fe6c5f$var$formatProdErrorMessage(474)), $6981e83672fe6c5f$var$SuspenseActionException = Error($6981e83672fe6c5f$var$formatProdErrorMessage(542)), $6981e83672fe6c5f$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $6981e83672fe6c5f$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $6981e83672fe6c5f$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($6981e83672fe6c5f$var$noop$1, $6981e83672fe6c5f$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $6981e83672fe6c5f$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($6981e83672fe6c5f$var$noop$1, $6981e83672fe6c5f$var$noop$1);
            else {
                thenableState = $6981e83672fe6c5f$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $6981e83672fe6c5f$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $6981e83672fe6c5f$var$suspendedThenable = thenable;
            throw $6981e83672fe6c5f$var$SuspenseException;
    }
}
function $6981e83672fe6c5f$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $6981e83672fe6c5f$var$suspendedThenable = x, $6981e83672fe6c5f$var$SuspenseException;
        throw x;
    }
}
var $6981e83672fe6c5f$var$suspendedThenable = null;
function $6981e83672fe6c5f$var$getSuspendedThenable() {
    if (null === $6981e83672fe6c5f$var$suspendedThenable) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(459));
    var thenable = $6981e83672fe6c5f$var$suspendedThenable;
    $6981e83672fe6c5f$var$suspendedThenable = null;
    return thenable;
}
function $6981e83672fe6c5f$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $6981e83672fe6c5f$var$SuspenseException || rejectedReason === $6981e83672fe6c5f$var$SuspenseActionException) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(483));
}
var $6981e83672fe6c5f$var$thenableState$1 = null, $6981e83672fe6c5f$var$thenableIndexCounter$1 = 0;
function $6981e83672fe6c5f$var$unwrapThenable(thenable) {
    var index = $6981e83672fe6c5f$var$thenableIndexCounter$1;
    $6981e83672fe6c5f$var$thenableIndexCounter$1 += 1;
    null === $6981e83672fe6c5f$var$thenableState$1 && ($6981e83672fe6c5f$var$thenableState$1 = []);
    return $6981e83672fe6c5f$var$trackUsedThenable($6981e83672fe6c5f$var$thenableState$1, thenable, index);
}
function $6981e83672fe6c5f$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $6981e83672fe6c5f$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $6981e83672fe6c5f$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $6981e83672fe6c5f$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $6981e83672fe6c5f$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $6981e83672fe6c5f$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $6981e83672fe6c5f$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $6981e83672fe6c5f$var$REACT_LAZY_TYPE && $6981e83672fe6c5f$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $6981e83672fe6c5f$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $6981e83672fe6c5f$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $6981e83672fe6c5f$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $6981e83672fe6c5f$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $6981e83672fe6c5f$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $6981e83672fe6c5f$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $6981e83672fe6c5f$var$REACT_ELEMENT_TYPE:
                    return lanes = $6981e83672fe6c5f$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $6981e83672fe6c5f$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $6981e83672fe6c5f$var$REACT_PORTAL_TYPE:
                    return newChild = $6981e83672fe6c5f$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $6981e83672fe6c5f$var$REACT_LAZY_TYPE:
                    return newChild = $6981e83672fe6c5f$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($6981e83672fe6c5f$var$isArrayImpl(newChild) || $6981e83672fe6c5f$var$getIteratorFn(newChild)) return newChild = $6981e83672fe6c5f$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $6981e83672fe6c5f$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $6981e83672fe6c5f$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $6981e83672fe6c5f$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $6981e83672fe6c5f$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $6981e83672fe6c5f$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $6981e83672fe6c5f$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $6981e83672fe6c5f$var$REACT_LAZY_TYPE:
                    return newChild = $6981e83672fe6c5f$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($6981e83672fe6c5f$var$isArrayImpl(newChild) || $6981e83672fe6c5f$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $6981e83672fe6c5f$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $6981e83672fe6c5f$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $6981e83672fe6c5f$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $6981e83672fe6c5f$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $6981e83672fe6c5f$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $6981e83672fe6c5f$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $6981e83672fe6c5f$var$REACT_LAZY_TYPE:
                    return newChild = $6981e83672fe6c5f$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($6981e83672fe6c5f$var$isArrayImpl(newChild) || $6981e83672fe6c5f$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $6981e83672fe6c5f$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $6981e83672fe6c5f$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $6981e83672fe6c5f$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $6981e83672fe6c5f$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $6981e83672fe6c5f$var$isHydrating && $6981e83672fe6c5f$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $6981e83672fe6c5f$var$isHydrating && $6981e83672fe6c5f$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $6981e83672fe6c5f$var$isHydrating && $6981e83672fe6c5f$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $6981e83672fe6c5f$var$isHydrating && $6981e83672fe6c5f$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $6981e83672fe6c5f$var$isHydrating && $6981e83672fe6c5f$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $6981e83672fe6c5f$var$isHydrating && $6981e83672fe6c5f$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $6981e83672fe6c5f$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $6981e83672fe6c5f$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $6981e83672fe6c5f$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $6981e83672fe6c5f$var$REACT_LAZY_TYPE && $6981e83672fe6c5f$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $6981e83672fe6c5f$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $6981e83672fe6c5f$var$REACT_FRAGMENT_TYPE ? (lanes = $6981e83672fe6c5f$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $6981e83672fe6c5f$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $6981e83672fe6c5f$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $6981e83672fe6c5f$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $6981e83672fe6c5f$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $6981e83672fe6c5f$var$REACT_LAZY_TYPE:
                    return newChild = $6981e83672fe6c5f$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($6981e83672fe6c5f$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($6981e83672fe6c5f$var$getIteratorFn(newChild)) {
                key = $6981e83672fe6c5f$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $6981e83672fe6c5f$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $6981e83672fe6c5f$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $6981e83672fe6c5f$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $6981e83672fe6c5f$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $6981e83672fe6c5f$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $6981e83672fe6c5f$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $6981e83672fe6c5f$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $6981e83672fe6c5f$var$SuspenseException || x === $6981e83672fe6c5f$var$SuspenseActionException) throw x;
            var fiber = $6981e83672fe6c5f$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $6981e83672fe6c5f$var$reconcileChildFibers = $6981e83672fe6c5f$var$createChildReconciler(!0), $6981e83672fe6c5f$var$mountChildFibers = $6981e83672fe6c5f$var$createChildReconciler(!1), $6981e83672fe6c5f$var$hasForceUpdate = !1;
function $6981e83672fe6c5f$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $6981e83672fe6c5f$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $6981e83672fe6c5f$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $6981e83672fe6c5f$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($6981e83672fe6c5f$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $6981e83672fe6c5f$var$getRootForUpdatedFiber(fiber);
        $6981e83672fe6c5f$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $6981e83672fe6c5f$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $6981e83672fe6c5f$var$getRootForUpdatedFiber(fiber);
}
function $6981e83672fe6c5f$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $6981e83672fe6c5f$var$markRootEntangled(root, lane);
    }
}
function $6981e83672fe6c5f$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $6981e83672fe6c5f$var$didReadFromEntangledAsyncAction = !1;
function $6981e83672fe6c5f$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($6981e83672fe6c5f$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $6981e83672fe6c5f$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $6981e83672fe6c5f$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $6981e83672fe6c5f$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $6981e83672fe6c5f$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($6981e83672fe6c5f$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $6981e83672fe6c5f$var$currentEntangledLane && ($6981e83672fe6c5f$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $6981e83672fe6c5f$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $6981e83672fe6c5f$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $6981e83672fe6c5f$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $6981e83672fe6c5f$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $6981e83672fe6c5f$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$6981e83672fe6c5f$var$callCallback(callbacks[updateQueue], context);
}
var $6981e83672fe6c5f$var$currentTreeHiddenStackCursor = $6981e83672fe6c5f$var$createCursor(null), $6981e83672fe6c5f$var$prevEntangledRenderLanesCursor = $6981e83672fe6c5f$var$createCursor(0);
function $6981e83672fe6c5f$var$pushHiddenContext(fiber, context) {
    fiber = $6981e83672fe6c5f$var$entangledRenderLanes;
    $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$prevEntangledRenderLanesCursor, fiber);
    $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$currentTreeHiddenStackCursor, context);
    $6981e83672fe6c5f$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $6981e83672fe6c5f$var$reuseHiddenContextOnStack() {
    $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$prevEntangledRenderLanesCursor, $6981e83672fe6c5f$var$entangledRenderLanes);
    $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$currentTreeHiddenStackCursor, $6981e83672fe6c5f$var$currentTreeHiddenStackCursor.current);
}
function $6981e83672fe6c5f$var$popHiddenContext() {
    $6981e83672fe6c5f$var$entangledRenderLanes = $6981e83672fe6c5f$var$prevEntangledRenderLanesCursor.current;
    $6981e83672fe6c5f$var$pop($6981e83672fe6c5f$var$currentTreeHiddenStackCursor);
    $6981e83672fe6c5f$var$pop($6981e83672fe6c5f$var$prevEntangledRenderLanesCursor);
}
var $6981e83672fe6c5f$var$suspenseHandlerStackCursor = $6981e83672fe6c5f$var$createCursor(null), $6981e83672fe6c5f$var$shellBoundary = null;
function $6981e83672fe6c5f$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$suspenseStackCursor, $6981e83672fe6c5f$var$suspenseStackCursor.current & 1);
    $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$suspenseHandlerStackCursor, handler);
    null === $6981e83672fe6c5f$var$shellBoundary && (null === current || null !== $6981e83672fe6c5f$var$currentTreeHiddenStackCursor.current ? $6981e83672fe6c5f$var$shellBoundary = handler : null !== current.memoizedState && ($6981e83672fe6c5f$var$shellBoundary = handler));
}
function $6981e83672fe6c5f$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$suspenseStackCursor, $6981e83672fe6c5f$var$suspenseStackCursor.current);
    $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$suspenseHandlerStackCursor, fiber);
    null === $6981e83672fe6c5f$var$shellBoundary && ($6981e83672fe6c5f$var$shellBoundary = fiber);
}
function $6981e83672fe6c5f$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$suspenseStackCursor, $6981e83672fe6c5f$var$suspenseStackCursor.current), $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$suspenseHandlerStackCursor, fiber), null === $6981e83672fe6c5f$var$shellBoundary && ($6981e83672fe6c5f$var$shellBoundary = fiber)) : $6981e83672fe6c5f$var$reuseSuspenseHandlerOnStack(fiber);
}
function $6981e83672fe6c5f$var$reuseSuspenseHandlerOnStack() {
    $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$suspenseStackCursor, $6981e83672fe6c5f$var$suspenseStackCursor.current);
    $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$suspenseHandlerStackCursor, $6981e83672fe6c5f$var$suspenseHandlerStackCursor.current);
}
function $6981e83672fe6c5f$var$popSuspenseHandler(fiber) {
    $6981e83672fe6c5f$var$pop($6981e83672fe6c5f$var$suspenseHandlerStackCursor);
    $6981e83672fe6c5f$var$shellBoundary === fiber && ($6981e83672fe6c5f$var$shellBoundary = null);
    $6981e83672fe6c5f$var$pop($6981e83672fe6c5f$var$suspenseStackCursor);
}
var $6981e83672fe6c5f$var$suspenseStackCursor = $6981e83672fe6c5f$var$createCursor(0);
function $6981e83672fe6c5f$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $6981e83672fe6c5f$var$isSuspenseInstancePending(state) || $6981e83672fe6c5f$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $6981e83672fe6c5f$var$renderLanes = 0, $6981e83672fe6c5f$var$currentlyRenderingFiber = null, $6981e83672fe6c5f$var$currentHook = null, $6981e83672fe6c5f$var$workInProgressHook = null, $6981e83672fe6c5f$var$didScheduleRenderPhaseUpdate = !1, $6981e83672fe6c5f$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $6981e83672fe6c5f$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $6981e83672fe6c5f$var$localIdCounter = 0, $6981e83672fe6c5f$var$thenableIndexCounter = 0, $6981e83672fe6c5f$var$thenableState = null, $6981e83672fe6c5f$var$globalClientIdCounter = 0;
function $6981e83672fe6c5f$var$throwInvalidHookError() {
    throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(321));
}
function $6981e83672fe6c5f$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$6981e83672fe6c5f$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $6981e83672fe6c5f$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $6981e83672fe6c5f$var$renderLanes = nextRenderLanes;
    $6981e83672fe6c5f$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $6981e83672fe6c5f$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $6981e83672fe6c5f$var$HooksDispatcherOnMount : $6981e83672fe6c5f$var$HooksDispatcherOnUpdate;
    $6981e83672fe6c5f$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $6981e83672fe6c5f$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $6981e83672fe6c5f$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $6981e83672fe6c5f$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $6981e83672fe6c5f$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $6981e83672fe6c5f$var$finishRenderingHooks(current) {
    $6981e83672fe6c5f$var$ReactSharedInternals.H = $6981e83672fe6c5f$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $6981e83672fe6c5f$var$currentHook && null !== $6981e83672fe6c5f$var$currentHook.next;
    $6981e83672fe6c5f$var$renderLanes = 0;
    $6981e83672fe6c5f$var$workInProgressHook = $6981e83672fe6c5f$var$currentHook = $6981e83672fe6c5f$var$currentlyRenderingFiber = null;
    $6981e83672fe6c5f$var$didScheduleRenderPhaseUpdate = !1;
    $6981e83672fe6c5f$var$thenableIndexCounter = 0;
    $6981e83672fe6c5f$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(300));
    null === current || $6981e83672fe6c5f$var$didReceiveUpdate || (current = current.dependencies, null !== current && $6981e83672fe6c5f$var$checkIfContextChanged(current) && ($6981e83672fe6c5f$var$didReceiveUpdate = !0));
}
function $6981e83672fe6c5f$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $6981e83672fe6c5f$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $6981e83672fe6c5f$var$didScheduleRenderPhaseUpdateDuringThisPass && ($6981e83672fe6c5f$var$thenableState = null);
        $6981e83672fe6c5f$var$thenableIndexCounter = 0;
        $6981e83672fe6c5f$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $6981e83672fe6c5f$var$workInProgressHook = $6981e83672fe6c5f$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $6981e83672fe6c5f$var$ReactSharedInternals.H = $6981e83672fe6c5f$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($6981e83672fe6c5f$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $6981e83672fe6c5f$var$TransitionAwareHostComponent() {
    var dispatcher = $6981e83672fe6c5f$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $6981e83672fe6c5f$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $6981e83672fe6c5f$var$currentHook ? $6981e83672fe6c5f$var$currentHook.memoizedState : null) !== dispatcher && ($6981e83672fe6c5f$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $6981e83672fe6c5f$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $6981e83672fe6c5f$var$localIdCounter;
    $6981e83672fe6c5f$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $6981e83672fe6c5f$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $6981e83672fe6c5f$var$resetHooksOnUnwind(workInProgress) {
    if ($6981e83672fe6c5f$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $6981e83672fe6c5f$var$didScheduleRenderPhaseUpdate = !1;
    }
    $6981e83672fe6c5f$var$renderLanes = 0;
    $6981e83672fe6c5f$var$workInProgressHook = $6981e83672fe6c5f$var$currentHook = $6981e83672fe6c5f$var$currentlyRenderingFiber = null;
    $6981e83672fe6c5f$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $6981e83672fe6c5f$var$thenableIndexCounter = $6981e83672fe6c5f$var$localIdCounter = 0;
    $6981e83672fe6c5f$var$thenableState = null;
}
function $6981e83672fe6c5f$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $6981e83672fe6c5f$var$workInProgressHook ? $6981e83672fe6c5f$var$currentlyRenderingFiber.memoizedState = $6981e83672fe6c5f$var$workInProgressHook = hook : $6981e83672fe6c5f$var$workInProgressHook = $6981e83672fe6c5f$var$workInProgressHook.next = hook;
    return $6981e83672fe6c5f$var$workInProgressHook;
}
function $6981e83672fe6c5f$var$updateWorkInProgressHook() {
    if (null === $6981e83672fe6c5f$var$currentHook) {
        var nextCurrentHook = $6981e83672fe6c5f$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $6981e83672fe6c5f$var$currentHook.next;
    var nextWorkInProgressHook = null === $6981e83672fe6c5f$var$workInProgressHook ? $6981e83672fe6c5f$var$currentlyRenderingFiber.memoizedState : $6981e83672fe6c5f$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $6981e83672fe6c5f$var$workInProgressHook = nextWorkInProgressHook, $6981e83672fe6c5f$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $6981e83672fe6c5f$var$currentlyRenderingFiber.alternate) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(467));
            throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(310));
        }
        $6981e83672fe6c5f$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $6981e83672fe6c5f$var$currentHook.memoizedState,
            baseState: $6981e83672fe6c5f$var$currentHook.baseState,
            baseQueue: $6981e83672fe6c5f$var$currentHook.baseQueue,
            queue: $6981e83672fe6c5f$var$currentHook.queue,
            next: null
        };
        null === $6981e83672fe6c5f$var$workInProgressHook ? $6981e83672fe6c5f$var$currentlyRenderingFiber.memoizedState = $6981e83672fe6c5f$var$workInProgressHook = nextCurrentHook : $6981e83672fe6c5f$var$workInProgressHook = $6981e83672fe6c5f$var$workInProgressHook.next = nextCurrentHook;
    }
    return $6981e83672fe6c5f$var$workInProgressHook;
}
function $6981e83672fe6c5f$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $6981e83672fe6c5f$var$useThenable(thenable) {
    var index = $6981e83672fe6c5f$var$thenableIndexCounter;
    $6981e83672fe6c5f$var$thenableIndexCounter += 1;
    null === $6981e83672fe6c5f$var$thenableState && ($6981e83672fe6c5f$var$thenableState = []);
    thenable = $6981e83672fe6c5f$var$trackUsedThenable($6981e83672fe6c5f$var$thenableState, thenable, index);
    index = $6981e83672fe6c5f$var$currentlyRenderingFiber;
    null === (null === $6981e83672fe6c5f$var$workInProgressHook ? index.memoizedState : $6981e83672fe6c5f$var$workInProgressHook.next) && (index = index.alternate, $6981e83672fe6c5f$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $6981e83672fe6c5f$var$HooksDispatcherOnMount : $6981e83672fe6c5f$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $6981e83672fe6c5f$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $6981e83672fe6c5f$var$useThenable(usable);
        if (usable.$$typeof === $6981e83672fe6c5f$var$REACT_CONTEXT_TYPE) return $6981e83672fe6c5f$var$readContext(usable);
    }
    throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(438, String(usable)));
}
function $6981e83672fe6c5f$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $6981e83672fe6c5f$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $6981e83672fe6c5f$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $6981e83672fe6c5f$var$createFunctionComponentUpdateQueue(), $6981e83672fe6c5f$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $6981e83672fe6c5f$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $6981e83672fe6c5f$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $6981e83672fe6c5f$var$updateReducer(reducer) {
    var hook = $6981e83672fe6c5f$var$updateWorkInProgressHook();
    return $6981e83672fe6c5f$var$updateReducerImpl(hook, $6981e83672fe6c5f$var$currentHook, reducer);
}
function $6981e83672fe6c5f$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($6981e83672fe6c5f$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($6981e83672fe6c5f$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $6981e83672fe6c5f$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($6981e83672fe6c5f$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $6981e83672fe6c5f$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $6981e83672fe6c5f$var$currentlyRenderingFiber.lanes |= revertLane, $6981e83672fe6c5f$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $6981e83672fe6c5f$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $6981e83672fe6c5f$var$currentlyRenderingFiber.lanes |= updateLane, $6981e83672fe6c5f$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$6981e83672fe6c5f$var$objectIs(pendingQueue, hook.memoizedState) && ($6981e83672fe6c5f$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $6981e83672fe6c5f$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $6981e83672fe6c5f$var$rerenderReducer(reducer) {
    var hook = $6981e83672fe6c5f$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $6981e83672fe6c5f$var$objectIs(newState, hook.memoizedState) || ($6981e83672fe6c5f$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $6981e83672fe6c5f$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $6981e83672fe6c5f$var$currentlyRenderingFiber, hook = $6981e83672fe6c5f$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $6981e83672fe6c5f$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$6981e83672fe6c5f$var$objectIs(($6981e83672fe6c5f$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $6981e83672fe6c5f$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $6981e83672fe6c5f$var$updateEffect($6981e83672fe6c5f$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $6981e83672fe6c5f$var$workInProgressHook && $6981e83672fe6c5f$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $6981e83672fe6c5f$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $6981e83672fe6c5f$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $6981e83672fe6c5f$var$workInProgressRoot) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($6981e83672fe6c5f$var$renderLanes & 127) || $6981e83672fe6c5f$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $6981e83672fe6c5f$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $6981e83672fe6c5f$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $6981e83672fe6c5f$var$createFunctionComponentUpdateQueue(), $6981e83672fe6c5f$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $6981e83672fe6c5f$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $6981e83672fe6c5f$var$checkIfSnapshotChanged(inst) && $6981e83672fe6c5f$var$forceStoreRerender(fiber);
}
function $6981e83672fe6c5f$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $6981e83672fe6c5f$var$checkIfSnapshotChanged(inst) && $6981e83672fe6c5f$var$forceStoreRerender(fiber);
    });
}
function $6981e83672fe6c5f$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$6981e83672fe6c5f$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $6981e83672fe6c5f$var$forceStoreRerender(fiber) {
    var root = $6981e83672fe6c5f$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $6981e83672fe6c5f$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $6981e83672fe6c5f$var$mountStateImpl(initialState) {
    var hook = $6981e83672fe6c5f$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($6981e83672fe6c5f$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $6981e83672fe6c5f$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $6981e83672fe6c5f$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $6981e83672fe6c5f$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $6981e83672fe6c5f$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $6981e83672fe6c5f$var$updateReducerImpl(hook, $6981e83672fe6c5f$var$currentHook, "function" === typeof reducer ? reducer : $6981e83672fe6c5f$var$basicStateReducer);
}
function $6981e83672fe6c5f$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($6981e83672fe6c5f$var$isRenderPhaseUpdate(fiber)) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $6981e83672fe6c5f$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $6981e83672fe6c5f$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $6981e83672fe6c5f$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $6981e83672fe6c5f$var$ReactSharedInternals.T, currentTransition = {};
        $6981e83672fe6c5f$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $6981e83672fe6c5f$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $6981e83672fe6c5f$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $6981e83672fe6c5f$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $6981e83672fe6c5f$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $6981e83672fe6c5f$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $6981e83672fe6c5f$var$onActionError(actionQueue, node, error$66);
    }
}
function $6981e83672fe6c5f$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $6981e83672fe6c5f$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $6981e83672fe6c5f$var$onActionError(actionQueue, node, error);
    }) : $6981e83672fe6c5f$var$onActionSuccess(actionQueue, node, returnValue);
}
function $6981e83672fe6c5f$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $6981e83672fe6c5f$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $6981e83672fe6c5f$var$runActionStateAction(actionQueue, nextState)));
}
function $6981e83672fe6c5f$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $6981e83672fe6c5f$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $6981e83672fe6c5f$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $6981e83672fe6c5f$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $6981e83672fe6c5f$var$mountActionState(action, initialStateProp) {
    if ($6981e83672fe6c5f$var$isHydrating) {
        var ssrFormState = $6981e83672fe6c5f$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $6981e83672fe6c5f$var$currentlyRenderingFiber;
                if ($6981e83672fe6c5f$var$isHydrating) {
                    if ($6981e83672fe6c5f$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $6981e83672fe6c5f$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $6981e83672fe6c5f$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $6981e83672fe6c5f$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $6981e83672fe6c5f$var$nextHydratableInstance = $6981e83672fe6c5f$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $6981e83672fe6c5f$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $6981e83672fe6c5f$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $6981e83672fe6c5f$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $6981e83672fe6c5f$var$dispatchSetState.bind(null, $6981e83672fe6c5f$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $6981e83672fe6c5f$var$mountStateImpl(!1);
    inRootOrSingleton = $6981e83672fe6c5f$var$dispatchOptimisticSetState.bind(null, $6981e83672fe6c5f$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $6981e83672fe6c5f$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $6981e83672fe6c5f$var$dispatchActionState.bind(null, $6981e83672fe6c5f$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $6981e83672fe6c5f$var$updateActionState(action) {
    var stateHook = $6981e83672fe6c5f$var$updateWorkInProgressHook();
    return $6981e83672fe6c5f$var$updateActionStateImpl(stateHook, $6981e83672fe6c5f$var$currentHook, action);
}
function $6981e83672fe6c5f$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $6981e83672fe6c5f$var$updateReducerImpl(stateHook, currentStateHook, $6981e83672fe6c5f$var$actionStateReducer)[0];
    stateHook = $6981e83672fe6c5f$var$updateReducer($6981e83672fe6c5f$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $6981e83672fe6c5f$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $6981e83672fe6c5f$var$SuspenseException) throw $6981e83672fe6c5f$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $6981e83672fe6c5f$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($6981e83672fe6c5f$var$currentlyRenderingFiber.flags |= 2048, $6981e83672fe6c5f$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $6981e83672fe6c5f$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $6981e83672fe6c5f$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $6981e83672fe6c5f$var$rerenderActionState(action) {
    var stateHook = $6981e83672fe6c5f$var$updateWorkInProgressHook(), currentStateHook = $6981e83672fe6c5f$var$currentHook;
    if (null !== currentStateHook) return $6981e83672fe6c5f$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $6981e83672fe6c5f$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $6981e83672fe6c5f$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $6981e83672fe6c5f$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $6981e83672fe6c5f$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $6981e83672fe6c5f$var$createFunctionComponentUpdateQueue(), $6981e83672fe6c5f$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $6981e83672fe6c5f$var$updateRef() {
    return $6981e83672fe6c5f$var$updateWorkInProgressHook().memoizedState;
}
function $6981e83672fe6c5f$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $6981e83672fe6c5f$var$mountWorkInProgressHook();
    $6981e83672fe6c5f$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $6981e83672fe6c5f$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $6981e83672fe6c5f$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $6981e83672fe6c5f$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $6981e83672fe6c5f$var$currentHook && null !== deps && $6981e83672fe6c5f$var$areHookInputsEqual(deps, $6981e83672fe6c5f$var$currentHook.memoizedState.deps) ? hook.memoizedState = $6981e83672fe6c5f$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($6981e83672fe6c5f$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $6981e83672fe6c5f$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $6981e83672fe6c5f$var$mountEffect(create, deps) {
    $6981e83672fe6c5f$var$mountEffectImpl(8390656, 8, create, deps);
}
function $6981e83672fe6c5f$var$updateEffect(create, deps) {
    $6981e83672fe6c5f$var$updateEffectImpl(2048, 8, create, deps);
}
function $6981e83672fe6c5f$var$useEffectEventImpl(payload) {
    $6981e83672fe6c5f$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $6981e83672fe6c5f$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $6981e83672fe6c5f$var$createFunctionComponentUpdateQueue(), $6981e83672fe6c5f$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $6981e83672fe6c5f$var$updateEvent(callback) {
    var ref = $6981e83672fe6c5f$var$updateWorkInProgressHook().memoizedState;
    $6981e83672fe6c5f$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($6981e83672fe6c5f$var$executionContext & 2)) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $6981e83672fe6c5f$var$updateInsertionEffect(create, deps) {
    return $6981e83672fe6c5f$var$updateEffectImpl(4, 2, create, deps);
}
function $6981e83672fe6c5f$var$updateLayoutEffect(create, deps) {
    return $6981e83672fe6c5f$var$updateEffectImpl(4, 4, create, deps);
}
function $6981e83672fe6c5f$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $6981e83672fe6c5f$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $6981e83672fe6c5f$var$updateEffectImpl(4, 4, $6981e83672fe6c5f$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $6981e83672fe6c5f$var$mountDebugValue() {}
function $6981e83672fe6c5f$var$updateCallback(callback, deps) {
    var hook = $6981e83672fe6c5f$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $6981e83672fe6c5f$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $6981e83672fe6c5f$var$updateMemo(nextCreate, deps) {
    var hook = $6981e83672fe6c5f$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $6981e83672fe6c5f$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($6981e83672fe6c5f$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $6981e83672fe6c5f$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $6981e83672fe6c5f$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $6981e83672fe6c5f$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($6981e83672fe6c5f$var$renderLanes & 1073741824) && 0 === ($6981e83672fe6c5f$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $6981e83672fe6c5f$var$requestDeferredLane();
    $6981e83672fe6c5f$var$currentlyRenderingFiber.lanes |= hook;
    $6981e83672fe6c5f$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $6981e83672fe6c5f$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($6981e83672fe6c5f$var$objectIs(value, prevValue)) return value;
    if (null !== $6981e83672fe6c5f$var$currentTreeHiddenStackCursor.current) return hook = $6981e83672fe6c5f$var$mountDeferredValueImpl(hook, value, initialValue), $6981e83672fe6c5f$var$objectIs(hook, prevValue) || ($6981e83672fe6c5f$var$didReceiveUpdate = !0), hook;
    if (0 === ($6981e83672fe6c5f$var$renderLanes & 42) || 0 !== ($6981e83672fe6c5f$var$renderLanes & 1073741824) && 0 === ($6981e83672fe6c5f$var$workInProgressRootRenderLanes & 261930)) return $6981e83672fe6c5f$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $6981e83672fe6c5f$var$requestDeferredLane();
    $6981e83672fe6c5f$var$currentlyRenderingFiber.lanes |= hook;
    $6981e83672fe6c5f$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $6981e83672fe6c5f$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $6981e83672fe6c5f$var$ReactDOMSharedInternals.p;
    $6981e83672fe6c5f$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $6981e83672fe6c5f$var$ReactSharedInternals.T, currentTransition = {};
    $6981e83672fe6c5f$var$ReactSharedInternals.T = currentTransition;
    $6981e83672fe6c5f$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $6981e83672fe6c5f$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $6981e83672fe6c5f$var$chainThenableValue(returnValue, finishedState);
            $6981e83672fe6c5f$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $6981e83672fe6c5f$var$requestUpdateLane(fiber));
        } else $6981e83672fe6c5f$var$dispatchSetStateInternal(fiber, queue, finishedState, $6981e83672fe6c5f$var$requestUpdateLane(fiber));
    } catch (error) {
        $6981e83672fe6c5f$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $6981e83672fe6c5f$var$requestUpdateLane());
    } finally{
        $6981e83672fe6c5f$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $6981e83672fe6c5f$var$ReactSharedInternals.T = prevTransition;
    }
}
function $6981e83672fe6c5f$var$noop() {}
function $6981e83672fe6c5f$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(476));
    var queue = $6981e83672fe6c5f$var$ensureFormComponentIsStateful(formFiber).queue;
    $6981e83672fe6c5f$var$startTransition(formFiber, queue, pendingState, $6981e83672fe6c5f$var$sharedNotPendingObject, null === action ? $6981e83672fe6c5f$var$noop : function() {
        $6981e83672fe6c5f$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $6981e83672fe6c5f$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $6981e83672fe6c5f$var$sharedNotPendingObject,
        baseState: $6981e83672fe6c5f$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $6981e83672fe6c5f$var$basicStateReducer,
            lastRenderedState: $6981e83672fe6c5f$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $6981e83672fe6c5f$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $6981e83672fe6c5f$var$requestFormReset$1(formFiber) {
    var stateHook = $6981e83672fe6c5f$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $6981e83672fe6c5f$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $6981e83672fe6c5f$var$requestUpdateLane());
}
function $6981e83672fe6c5f$var$useHostTransitionStatus() {
    return $6981e83672fe6c5f$var$readContext($6981e83672fe6c5f$var$HostTransitionContext);
}
function $6981e83672fe6c5f$var$updateId() {
    return $6981e83672fe6c5f$var$updateWorkInProgressHook().memoizedState;
}
function $6981e83672fe6c5f$var$updateRefresh() {
    return $6981e83672fe6c5f$var$updateWorkInProgressHook().memoizedState;
}
function $6981e83672fe6c5f$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $6981e83672fe6c5f$var$requestUpdateLane();
                fiber = $6981e83672fe6c5f$var$createUpdate(lane);
                var root$69 = $6981e83672fe6c5f$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($6981e83672fe6c5f$var$scheduleUpdateOnFiber(root$69, provider, lane), $6981e83672fe6c5f$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $6981e83672fe6c5f$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $6981e83672fe6c5f$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $6981e83672fe6c5f$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $6981e83672fe6c5f$var$isRenderPhaseUpdate(fiber) ? $6981e83672fe6c5f$var$enqueueRenderPhaseUpdate(queue, action) : (action = $6981e83672fe6c5f$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($6981e83672fe6c5f$var$scheduleUpdateOnFiber(action, fiber, lane), $6981e83672fe6c5f$var$entangleTransitionUpdate(action, queue, lane)));
}
function $6981e83672fe6c5f$var$dispatchSetState(fiber, queue, action) {
    var lane = $6981e83672fe6c5f$var$requestUpdateLane();
    $6981e83672fe6c5f$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $6981e83672fe6c5f$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($6981e83672fe6c5f$var$isRenderPhaseUpdate(fiber)) $6981e83672fe6c5f$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($6981e83672fe6c5f$var$objectIs(eagerState, currentState)) return $6981e83672fe6c5f$var$enqueueUpdate$1(fiber, queue, update, 0), null === $6981e83672fe6c5f$var$workInProgressRoot && $6981e83672fe6c5f$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $6981e83672fe6c5f$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $6981e83672fe6c5f$var$scheduleUpdateOnFiber(action, fiber, lane), $6981e83672fe6c5f$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $6981e83672fe6c5f$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $6981e83672fe6c5f$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($6981e83672fe6c5f$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $6981e83672fe6c5f$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $6981e83672fe6c5f$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $6981e83672fe6c5f$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $6981e83672fe6c5f$var$currentlyRenderingFiber || null !== alternate && alternate === $6981e83672fe6c5f$var$currentlyRenderingFiber;
}
function $6981e83672fe6c5f$var$enqueueRenderPhaseUpdate(queue, update) {
    $6981e83672fe6c5f$var$didScheduleRenderPhaseUpdateDuringThisPass = $6981e83672fe6c5f$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $6981e83672fe6c5f$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $6981e83672fe6c5f$var$markRootEntangled(root, lane);
    }
}
var $6981e83672fe6c5f$var$ContextOnlyDispatcher = {
    readContext: $6981e83672fe6c5f$var$readContext,
    use: $6981e83672fe6c5f$var$use,
    useCallback: $6981e83672fe6c5f$var$throwInvalidHookError,
    useContext: $6981e83672fe6c5f$var$throwInvalidHookError,
    useEffect: $6981e83672fe6c5f$var$throwInvalidHookError,
    useImperativeHandle: $6981e83672fe6c5f$var$throwInvalidHookError,
    useLayoutEffect: $6981e83672fe6c5f$var$throwInvalidHookError,
    useInsertionEffect: $6981e83672fe6c5f$var$throwInvalidHookError,
    useMemo: $6981e83672fe6c5f$var$throwInvalidHookError,
    useReducer: $6981e83672fe6c5f$var$throwInvalidHookError,
    useRef: $6981e83672fe6c5f$var$throwInvalidHookError,
    useState: $6981e83672fe6c5f$var$throwInvalidHookError,
    useDebugValue: $6981e83672fe6c5f$var$throwInvalidHookError,
    useDeferredValue: $6981e83672fe6c5f$var$throwInvalidHookError,
    useTransition: $6981e83672fe6c5f$var$throwInvalidHookError,
    useSyncExternalStore: $6981e83672fe6c5f$var$throwInvalidHookError,
    useId: $6981e83672fe6c5f$var$throwInvalidHookError,
    useHostTransitionStatus: $6981e83672fe6c5f$var$throwInvalidHookError,
    useFormState: $6981e83672fe6c5f$var$throwInvalidHookError,
    useActionState: $6981e83672fe6c5f$var$throwInvalidHookError,
    useOptimistic: $6981e83672fe6c5f$var$throwInvalidHookError,
    useMemoCache: $6981e83672fe6c5f$var$throwInvalidHookError,
    useCacheRefresh: $6981e83672fe6c5f$var$throwInvalidHookError
};
$6981e83672fe6c5f$var$ContextOnlyDispatcher.useEffectEvent = $6981e83672fe6c5f$var$throwInvalidHookError;
var $6981e83672fe6c5f$var$HooksDispatcherOnMount = {
    readContext: $6981e83672fe6c5f$var$readContext,
    use: $6981e83672fe6c5f$var$use,
    useCallback: function(callback, deps) {
        $6981e83672fe6c5f$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $6981e83672fe6c5f$var$readContext,
    useEffect: $6981e83672fe6c5f$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $6981e83672fe6c5f$var$mountEffectImpl(4194308, 4, $6981e83672fe6c5f$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $6981e83672fe6c5f$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $6981e83672fe6c5f$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $6981e83672fe6c5f$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($6981e83672fe6c5f$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $6981e83672fe6c5f$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $6981e83672fe6c5f$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $6981e83672fe6c5f$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($6981e83672fe6c5f$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $6981e83672fe6c5f$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $6981e83672fe6c5f$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $6981e83672fe6c5f$var$dispatchReducerAction.bind(null, $6981e83672fe6c5f$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $6981e83672fe6c5f$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $6981e83672fe6c5f$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $6981e83672fe6c5f$var$dispatchSetState.bind(null, $6981e83672fe6c5f$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $6981e83672fe6c5f$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $6981e83672fe6c5f$var$mountWorkInProgressHook();
        return $6981e83672fe6c5f$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $6981e83672fe6c5f$var$mountStateImpl(!1);
        stateHook = $6981e83672fe6c5f$var$startTransition.bind(null, $6981e83672fe6c5f$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $6981e83672fe6c5f$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $6981e83672fe6c5f$var$currentlyRenderingFiber, hook = $6981e83672fe6c5f$var$mountWorkInProgressHook();
        if ($6981e83672fe6c5f$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $6981e83672fe6c5f$var$workInProgressRoot) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(349));
            0 !== ($6981e83672fe6c5f$var$workInProgressRootRenderLanes & 127) || $6981e83672fe6c5f$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $6981e83672fe6c5f$var$mountEffect($6981e83672fe6c5f$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $6981e83672fe6c5f$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $6981e83672fe6c5f$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $6981e83672fe6c5f$var$mountWorkInProgressHook(), identifierPrefix = $6981e83672fe6c5f$var$workInProgressRoot.identifierPrefix;
        if ($6981e83672fe6c5f$var$isHydrating) {
            var JSCompiler_inline_result = $6981e83672fe6c5f$var$treeContextOverflow;
            var idWithLeadingBit = $6981e83672fe6c5f$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $6981e83672fe6c5f$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $6981e83672fe6c5f$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $6981e83672fe6c5f$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $6981e83672fe6c5f$var$useHostTransitionStatus,
    useFormState: $6981e83672fe6c5f$var$mountActionState,
    useActionState: $6981e83672fe6c5f$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $6981e83672fe6c5f$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $6981e83672fe6c5f$var$dispatchOptimisticSetState.bind(null, $6981e83672fe6c5f$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $6981e83672fe6c5f$var$useMemoCache,
    useCacheRefresh: function() {
        return $6981e83672fe6c5f$var$mountWorkInProgressHook().memoizedState = $6981e83672fe6c5f$var$refreshCache.bind(null, $6981e83672fe6c5f$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $6981e83672fe6c5f$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($6981e83672fe6c5f$var$executionContext & 2)) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $6981e83672fe6c5f$var$HooksDispatcherOnUpdate = {
    readContext: $6981e83672fe6c5f$var$readContext,
    use: $6981e83672fe6c5f$var$use,
    useCallback: $6981e83672fe6c5f$var$updateCallback,
    useContext: $6981e83672fe6c5f$var$readContext,
    useEffect: $6981e83672fe6c5f$var$updateEffect,
    useImperativeHandle: $6981e83672fe6c5f$var$updateImperativeHandle,
    useInsertionEffect: $6981e83672fe6c5f$var$updateInsertionEffect,
    useLayoutEffect: $6981e83672fe6c5f$var$updateLayoutEffect,
    useMemo: $6981e83672fe6c5f$var$updateMemo,
    useReducer: $6981e83672fe6c5f$var$updateReducer,
    useRef: $6981e83672fe6c5f$var$updateRef,
    useState: function() {
        return $6981e83672fe6c5f$var$updateReducer($6981e83672fe6c5f$var$basicStateReducer);
    },
    useDebugValue: $6981e83672fe6c5f$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $6981e83672fe6c5f$var$updateWorkInProgressHook();
        return $6981e83672fe6c5f$var$updateDeferredValueImpl(hook, $6981e83672fe6c5f$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $6981e83672fe6c5f$var$updateReducer($6981e83672fe6c5f$var$basicStateReducer)[0], start = $6981e83672fe6c5f$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $6981e83672fe6c5f$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $6981e83672fe6c5f$var$updateSyncExternalStore,
    useId: $6981e83672fe6c5f$var$updateId,
    useHostTransitionStatus: $6981e83672fe6c5f$var$useHostTransitionStatus,
    useFormState: $6981e83672fe6c5f$var$updateActionState,
    useActionState: $6981e83672fe6c5f$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $6981e83672fe6c5f$var$updateWorkInProgressHook();
        return $6981e83672fe6c5f$var$updateOptimisticImpl(hook, $6981e83672fe6c5f$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $6981e83672fe6c5f$var$useMemoCache,
    useCacheRefresh: $6981e83672fe6c5f$var$updateRefresh
};
$6981e83672fe6c5f$var$HooksDispatcherOnUpdate.useEffectEvent = $6981e83672fe6c5f$var$updateEvent;
var $6981e83672fe6c5f$var$HooksDispatcherOnRerender = {
    readContext: $6981e83672fe6c5f$var$readContext,
    use: $6981e83672fe6c5f$var$use,
    useCallback: $6981e83672fe6c5f$var$updateCallback,
    useContext: $6981e83672fe6c5f$var$readContext,
    useEffect: $6981e83672fe6c5f$var$updateEffect,
    useImperativeHandle: $6981e83672fe6c5f$var$updateImperativeHandle,
    useInsertionEffect: $6981e83672fe6c5f$var$updateInsertionEffect,
    useLayoutEffect: $6981e83672fe6c5f$var$updateLayoutEffect,
    useMemo: $6981e83672fe6c5f$var$updateMemo,
    useReducer: $6981e83672fe6c5f$var$rerenderReducer,
    useRef: $6981e83672fe6c5f$var$updateRef,
    useState: function() {
        return $6981e83672fe6c5f$var$rerenderReducer($6981e83672fe6c5f$var$basicStateReducer);
    },
    useDebugValue: $6981e83672fe6c5f$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $6981e83672fe6c5f$var$updateWorkInProgressHook();
        return null === $6981e83672fe6c5f$var$currentHook ? $6981e83672fe6c5f$var$mountDeferredValueImpl(hook, value, initialValue) : $6981e83672fe6c5f$var$updateDeferredValueImpl(hook, $6981e83672fe6c5f$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $6981e83672fe6c5f$var$rerenderReducer($6981e83672fe6c5f$var$basicStateReducer)[0], start = $6981e83672fe6c5f$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $6981e83672fe6c5f$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $6981e83672fe6c5f$var$updateSyncExternalStore,
    useId: $6981e83672fe6c5f$var$updateId,
    useHostTransitionStatus: $6981e83672fe6c5f$var$useHostTransitionStatus,
    useFormState: $6981e83672fe6c5f$var$rerenderActionState,
    useActionState: $6981e83672fe6c5f$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $6981e83672fe6c5f$var$updateWorkInProgressHook();
        if (null !== $6981e83672fe6c5f$var$currentHook) return $6981e83672fe6c5f$var$updateOptimisticImpl(hook, $6981e83672fe6c5f$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $6981e83672fe6c5f$var$useMemoCache,
    useCacheRefresh: $6981e83672fe6c5f$var$updateRefresh
};
$6981e83672fe6c5f$var$HooksDispatcherOnRerender.useEffectEvent = $6981e83672fe6c5f$var$updateEvent;
function $6981e83672fe6c5f$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $6981e83672fe6c5f$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $6981e83672fe6c5f$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $6981e83672fe6c5f$var$requestUpdateLane(), update = $6981e83672fe6c5f$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $6981e83672fe6c5f$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($6981e83672fe6c5f$var$scheduleUpdateOnFiber(payload, inst, lane), $6981e83672fe6c5f$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $6981e83672fe6c5f$var$requestUpdateLane(), update = $6981e83672fe6c5f$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $6981e83672fe6c5f$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($6981e83672fe6c5f$var$scheduleUpdateOnFiber(payload, inst, lane), $6981e83672fe6c5f$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $6981e83672fe6c5f$var$requestUpdateLane(), update = $6981e83672fe6c5f$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $6981e83672fe6c5f$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($6981e83672fe6c5f$var$scheduleUpdateOnFiber(callback, inst, lane), $6981e83672fe6c5f$var$entangleTransitions(callback, inst, lane));
    }
};
function $6981e83672fe6c5f$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$6981e83672fe6c5f$var$shallowEqual(oldProps, newProps) || !$6981e83672fe6c5f$var$shallowEqual(oldState, newState) : !0;
}
function $6981e83672fe6c5f$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $6981e83672fe6c5f$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $6981e83672fe6c5f$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $6981e83672fe6c5f$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $6981e83672fe6c5f$var$defaultOnUncaughtError(error) {
    $6981e83672fe6c5f$var$reportGlobalError(error);
}
function $6981e83672fe6c5f$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $6981e83672fe6c5f$var$defaultOnRecoverableError(error) {
    $6981e83672fe6c5f$var$reportGlobalError(error);
}
function $6981e83672fe6c5f$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $6981e83672fe6c5f$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $6981e83672fe6c5f$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $6981e83672fe6c5f$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $6981e83672fe6c5f$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $6981e83672fe6c5f$var$createClassErrorUpdate(lane) {
    lane = $6981e83672fe6c5f$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $6981e83672fe6c5f$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $6981e83672fe6c5f$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $6981e83672fe6c5f$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $6981e83672fe6c5f$var$legacyErrorBoundariesThatAlreadyFailed ? $6981e83672fe6c5f$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $6981e83672fe6c5f$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $6981e83672fe6c5f$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $6981e83672fe6c5f$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $6981e83672fe6c5f$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $6981e83672fe6c5f$var$shellBoundary ? $6981e83672fe6c5f$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $6981e83672fe6c5f$var$workInProgressRootExitStatus && ($6981e83672fe6c5f$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $6981e83672fe6c5f$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $6981e83672fe6c5f$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $6981e83672fe6c5f$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $6981e83672fe6c5f$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $6981e83672fe6c5f$var$attachPingListener(root, value, rootRenderLanes);
        $6981e83672fe6c5f$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($6981e83672fe6c5f$var$isHydrating) return returnFiber = $6981e83672fe6c5f$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $6981e83672fe6c5f$var$HydrationMismatchException && (root = Error($6981e83672fe6c5f$var$formatProdErrorMessage(422), {
        cause: value
    }), $6981e83672fe6c5f$var$queueHydrationError($6981e83672fe6c5f$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $6981e83672fe6c5f$var$HydrationMismatchException && (returnFiber = Error($6981e83672fe6c5f$var$formatProdErrorMessage(423), {
        cause: value
    }), $6981e83672fe6c5f$var$queueHydrationError($6981e83672fe6c5f$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $6981e83672fe6c5f$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $6981e83672fe6c5f$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $6981e83672fe6c5f$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $6981e83672fe6c5f$var$workInProgressRootExitStatus && ($6981e83672fe6c5f$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($6981e83672fe6c5f$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $6981e83672fe6c5f$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $6981e83672fe6c5f$var$workInProgressRootConcurrentErrors ? $6981e83672fe6c5f$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $6981e83672fe6c5f$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $6981e83672fe6c5f$var$workInProgressRootExitStatus && ($6981e83672fe6c5f$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $6981e83672fe6c5f$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $6981e83672fe6c5f$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $6981e83672fe6c5f$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $6981e83672fe6c5f$var$legacyErrorBoundariesThatAlreadyFailed || !$6981e83672fe6c5f$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $6981e83672fe6c5f$var$createClassErrorUpdate(rootRenderLanes), $6981e83672fe6c5f$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $6981e83672fe6c5f$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $6981e83672fe6c5f$var$SelectiveHydrationException = Error($6981e83672fe6c5f$var$formatProdErrorMessage(461)), $6981e83672fe6c5f$var$didReceiveUpdate = !1;
function $6981e83672fe6c5f$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $6981e83672fe6c5f$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $6981e83672fe6c5f$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $6981e83672fe6c5f$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $6981e83672fe6c5f$var$prepareToReadContext(workInProgress);
    nextProps = $6981e83672fe6c5f$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $6981e83672fe6c5f$var$checkDidRenderIdHook();
    if (null !== current && !$6981e83672fe6c5f$var$didReceiveUpdate) return $6981e83672fe6c5f$var$bailoutHooks(current, workInProgress, renderLanes), $6981e83672fe6c5f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $6981e83672fe6c5f$var$isHydrating && key && $6981e83672fe6c5f$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $6981e83672fe6c5f$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $6981e83672fe6c5f$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$6981e83672fe6c5f$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $6981e83672fe6c5f$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $6981e83672fe6c5f$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$6981e83672fe6c5f$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $6981e83672fe6c5f$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $6981e83672fe6c5f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $6981e83672fe6c5f$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $6981e83672fe6c5f$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($6981e83672fe6c5f$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($6981e83672fe6c5f$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $6981e83672fe6c5f$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($6981e83672fe6c5f$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $6981e83672fe6c5f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $6981e83672fe6c5f$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $6981e83672fe6c5f$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $6981e83672fe6c5f$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $6981e83672fe6c5f$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $6981e83672fe6c5f$var$pushHiddenContext(workInProgress, prevState) : $6981e83672fe6c5f$var$reuseHiddenContextOnStack(), $6981e83672fe6c5f$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $6981e83672fe6c5f$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($6981e83672fe6c5f$var$pushTransition(workInProgress, prevState.cachePool), $6981e83672fe6c5f$var$pushHiddenContext(workInProgress, prevState), $6981e83672fe6c5f$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $6981e83672fe6c5f$var$pushTransition(workInProgress, null), $6981e83672fe6c5f$var$reuseHiddenContextOnStack(), $6981e83672fe6c5f$var$reuseSuspenseHandlerOnStack(workInProgress));
    $6981e83672fe6c5f$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $6981e83672fe6c5f$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $6981e83672fe6c5f$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $6981e83672fe6c5f$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $6981e83672fe6c5f$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $6981e83672fe6c5f$var$pushTransition(workInProgress, null);
    $6981e83672fe6c5f$var$reuseHiddenContextOnStack();
    $6981e83672fe6c5f$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $6981e83672fe6c5f$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $6981e83672fe6c5f$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $6981e83672fe6c5f$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $6981e83672fe6c5f$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $6981e83672fe6c5f$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $6981e83672fe6c5f$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $6981e83672fe6c5f$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $6981e83672fe6c5f$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($6981e83672fe6c5f$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $6981e83672fe6c5f$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $6981e83672fe6c5f$var$bailoutOffscreenComponent(null, current);
            $6981e83672fe6c5f$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $6981e83672fe6c5f$var$nextHydratableInstance) ? (current = $6981e83672fe6c5f$var$canHydrateHydrationBoundary(current, $6981e83672fe6c5f$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $6981e83672fe6c5f$var$treeContextProvider ? {
                    id: $6981e83672fe6c5f$var$treeContextId,
                    overflow: $6981e83672fe6c5f$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $6981e83672fe6c5f$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $6981e83672fe6c5f$var$hydrationParentFiber = workInProgress, $6981e83672fe6c5f$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $6981e83672fe6c5f$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $6981e83672fe6c5f$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $6981e83672fe6c5f$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $6981e83672fe6c5f$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(558));
        } else if ($6981e83672fe6c5f$var$didReceiveUpdate || $6981e83672fe6c5f$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $6981e83672fe6c5f$var$didReceiveUpdate || didSuspend) {
            nextProps = $6981e83672fe6c5f$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $6981e83672fe6c5f$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $6981e83672fe6c5f$var$enqueueConcurrentRenderForLane(current, dehydrated), $6981e83672fe6c5f$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $6981e83672fe6c5f$var$SelectiveHydrationException;
            $6981e83672fe6c5f$var$renderDidSuspendDelayIfPossible();
            workInProgress = $6981e83672fe6c5f$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $6981e83672fe6c5f$var$nextHydratableInstance = $6981e83672fe6c5f$var$getNextHydratable(dehydrated.nextSibling), $6981e83672fe6c5f$var$hydrationParentFiber = workInProgress, $6981e83672fe6c5f$var$isHydrating = !0, $6981e83672fe6c5f$var$hydrationErrors = null, $6981e83672fe6c5f$var$rootOrSingletonContext = !1, null !== current && $6981e83672fe6c5f$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $6981e83672fe6c5f$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $6981e83672fe6c5f$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $6981e83672fe6c5f$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $6981e83672fe6c5f$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $6981e83672fe6c5f$var$prepareToReadContext(workInProgress);
    Component = $6981e83672fe6c5f$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $6981e83672fe6c5f$var$checkDidRenderIdHook();
    if (null !== current && !$6981e83672fe6c5f$var$didReceiveUpdate) return $6981e83672fe6c5f$var$bailoutHooks(current, workInProgress, renderLanes), $6981e83672fe6c5f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $6981e83672fe6c5f$var$isHydrating && nextProps && $6981e83672fe6c5f$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $6981e83672fe6c5f$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $6981e83672fe6c5f$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $6981e83672fe6c5f$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $6981e83672fe6c5f$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $6981e83672fe6c5f$var$finishRenderingHooks(current);
    Component = $6981e83672fe6c5f$var$checkDidRenderIdHook();
    if (null !== current && !$6981e83672fe6c5f$var$didReceiveUpdate) return $6981e83672fe6c5f$var$bailoutHooks(current, workInProgress, renderLanes), $6981e83672fe6c5f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $6981e83672fe6c5f$var$isHydrating && Component && $6981e83672fe6c5f$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $6981e83672fe6c5f$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $6981e83672fe6c5f$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $6981e83672fe6c5f$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $6981e83672fe6c5f$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $6981e83672fe6c5f$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $6981e83672fe6c5f$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $6981e83672fe6c5f$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $6981e83672fe6c5f$var$readContext(contextType) : $6981e83672fe6c5f$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($6981e83672fe6c5f$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $6981e83672fe6c5f$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $6981e83672fe6c5f$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $6981e83672fe6c5f$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $6981e83672fe6c5f$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $6981e83672fe6c5f$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $6981e83672fe6c5f$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $6981e83672fe6c5f$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $6981e83672fe6c5f$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $6981e83672fe6c5f$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $6981e83672fe6c5f$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $6981e83672fe6c5f$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($6981e83672fe6c5f$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $6981e83672fe6c5f$var$hasForceUpdate || $6981e83672fe6c5f$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $6981e83672fe6c5f$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $6981e83672fe6c5f$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $6981e83672fe6c5f$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $6981e83672fe6c5f$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $6981e83672fe6c5f$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $6981e83672fe6c5f$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $6981e83672fe6c5f$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $6981e83672fe6c5f$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $6981e83672fe6c5f$var$hasForceUpdate || null !== current && null !== current.dependencies && $6981e83672fe6c5f$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($6981e83672fe6c5f$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $6981e83672fe6c5f$var$hasForceUpdate || $6981e83672fe6c5f$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $6981e83672fe6c5f$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $6981e83672fe6c5f$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $6981e83672fe6c5f$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $6981e83672fe6c5f$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $6981e83672fe6c5f$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $6981e83672fe6c5f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $6981e83672fe6c5f$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $6981e83672fe6c5f$var$resetHydrationState();
    workInProgress.flags |= 256;
    $6981e83672fe6c5f$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $6981e83672fe6c5f$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $6981e83672fe6c5f$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $6981e83672fe6c5f$var$getSuspendedCache()
    };
}
function $6981e83672fe6c5f$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $6981e83672fe6c5f$var$workInProgressDeferredLane);
    return current;
}
function $6981e83672fe6c5f$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($6981e83672fe6c5f$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($6981e83672fe6c5f$var$isHydrating) {
            showFallback ? $6981e83672fe6c5f$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $6981e83672fe6c5f$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $6981e83672fe6c5f$var$nextHydratableInstance) ? (current = $6981e83672fe6c5f$var$canHydrateHydrationBoundary(current, $6981e83672fe6c5f$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $6981e83672fe6c5f$var$treeContextProvider ? {
                    id: $6981e83672fe6c5f$var$treeContextId,
                    overflow: $6981e83672fe6c5f$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $6981e83672fe6c5f$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $6981e83672fe6c5f$var$hydrationParentFiber = workInProgress, $6981e83672fe6c5f$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $6981e83672fe6c5f$var$throwOnHydrationMismatch(workInProgress);
            $6981e83672fe6c5f$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $6981e83672fe6c5f$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $6981e83672fe6c5f$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $6981e83672fe6c5f$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $6981e83672fe6c5f$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $6981e83672fe6c5f$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $6981e83672fe6c5f$var$SUSPENDED_MARKER, $6981e83672fe6c5f$var$bailoutOffscreenComponent(null, nextProps);
        $6981e83672fe6c5f$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $6981e83672fe6c5f$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($6981e83672fe6c5f$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $6981e83672fe6c5f$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($6981e83672fe6c5f$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($6981e83672fe6c5f$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $6981e83672fe6c5f$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $6981e83672fe6c5f$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $6981e83672fe6c5f$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $6981e83672fe6c5f$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $6981e83672fe6c5f$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $6981e83672fe6c5f$var$SUSPENDED_MARKER, workInProgress = $6981e83672fe6c5f$var$bailoutOffscreenComponent(null, nextProps));
        else if ($6981e83672fe6c5f$var$pushPrimaryTreeSuspenseHandler(workInProgress), $6981e83672fe6c5f$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($6981e83672fe6c5f$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $6981e83672fe6c5f$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $6981e83672fe6c5f$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($6981e83672fe6c5f$var$didReceiveUpdate || $6981e83672fe6c5f$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $6981e83672fe6c5f$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $6981e83672fe6c5f$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $6981e83672fe6c5f$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $6981e83672fe6c5f$var$enqueueConcurrentRenderForLane(current, nextProps), $6981e83672fe6c5f$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $6981e83672fe6c5f$var$SelectiveHydrationException;
            $6981e83672fe6c5f$var$isSuspenseInstancePending(nextPrimaryChildren) || $6981e83672fe6c5f$var$renderDidSuspendDelayIfPossible();
            workInProgress = $6981e83672fe6c5f$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $6981e83672fe6c5f$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $6981e83672fe6c5f$var$nextHydratableInstance = $6981e83672fe6c5f$var$getNextHydratable(nextPrimaryChildren.nextSibling), $6981e83672fe6c5f$var$hydrationParentFiber = workInProgress, $6981e83672fe6c5f$var$isHydrating = !0, $6981e83672fe6c5f$var$hydrationErrors = null, $6981e83672fe6c5f$var$rootOrSingletonContext = !1, null !== current && $6981e83672fe6c5f$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $6981e83672fe6c5f$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $6981e83672fe6c5f$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $6981e83672fe6c5f$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $6981e83672fe6c5f$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $6981e83672fe6c5f$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $6981e83672fe6c5f$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $6981e83672fe6c5f$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $6981e83672fe6c5f$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $6981e83672fe6c5f$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $6981e83672fe6c5f$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $6981e83672fe6c5f$var$SUSPENDED_MARKER, $6981e83672fe6c5f$var$bailoutOffscreenComponent(current.child, nextProps);
    $6981e83672fe6c5f$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $6981e83672fe6c5f$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $6981e83672fe6c5f$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $6981e83672fe6c5f$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $6981e83672fe6c5f$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $6981e83672fe6c5f$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $6981e83672fe6c5f$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $6981e83672fe6c5f$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $6981e83672fe6c5f$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $6981e83672fe6c5f$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $6981e83672fe6c5f$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $6981e83672fe6c5f$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $6981e83672fe6c5f$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $6981e83672fe6c5f$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$suspenseStackCursor, suspenseContext);
    $6981e83672fe6c5f$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $6981e83672fe6c5f$var$isHydrating ? $6981e83672fe6c5f$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $6981e83672fe6c5f$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $6981e83672fe6c5f$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $6981e83672fe6c5f$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $6981e83672fe6c5f$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $6981e83672fe6c5f$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $6981e83672fe6c5f$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $6981e83672fe6c5f$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $6981e83672fe6c5f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $6981e83672fe6c5f$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($6981e83672fe6c5f$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $6981e83672fe6c5f$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $6981e83672fe6c5f$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $6981e83672fe6c5f$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $6981e83672fe6c5f$var$checkIfContextChanged(current) ? !0 : !1;
}
function $6981e83672fe6c5f$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $6981e83672fe6c5f$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $6981e83672fe6c5f$var$pushProvider(workInProgress, $6981e83672fe6c5f$var$CacheContext, current.memoizedState.cache);
            $6981e83672fe6c5f$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $6981e83672fe6c5f$var$pushHostContext(workInProgress);
            break;
        case 4:
            $6981e83672fe6c5f$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $6981e83672fe6c5f$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $6981e83672fe6c5f$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $6981e83672fe6c5f$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $6981e83672fe6c5f$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $6981e83672fe6c5f$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $6981e83672fe6c5f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $6981e83672fe6c5f$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($6981e83672fe6c5f$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $6981e83672fe6c5f$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$suspenseStackCursor, $6981e83672fe6c5f$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $6981e83672fe6c5f$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $6981e83672fe6c5f$var$pushProvider(workInProgress, $6981e83672fe6c5f$var$CacheContext, current.memoizedState.cache);
    }
    return $6981e83672fe6c5f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $6981e83672fe6c5f$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $6981e83672fe6c5f$var$didReceiveUpdate = !0;
        else {
            if (!$6981e83672fe6c5f$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $6981e83672fe6c5f$var$didReceiveUpdate = !1, $6981e83672fe6c5f$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $6981e83672fe6c5f$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $6981e83672fe6c5f$var$didReceiveUpdate = !1, $6981e83672fe6c5f$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $6981e83672fe6c5f$var$pushTreeId(workInProgress, $6981e83672fe6c5f$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $6981e83672fe6c5f$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $6981e83672fe6c5f$var$shouldConstruct(current) ? (props = $6981e83672fe6c5f$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $6981e83672fe6c5f$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $6981e83672fe6c5f$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $6981e83672fe6c5f$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $6981e83672fe6c5f$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $6981e83672fe6c5f$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $6981e83672fe6c5f$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $6981e83672fe6c5f$var$getComponentNameFromType(current) || current;
                    throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $6981e83672fe6c5f$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $6981e83672fe6c5f$var$resolveClassComponentProps(props, workInProgress.pendingProps), $6981e83672fe6c5f$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $6981e83672fe6c5f$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $6981e83672fe6c5f$var$cloneUpdateQueue(current, workInProgress);
                $6981e83672fe6c5f$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $6981e83672fe6c5f$var$pushProvider(workInProgress, $6981e83672fe6c5f$var$CacheContext, props);
                props !== prevState.cache && $6981e83672fe6c5f$var$propagateContextChanges(workInProgress, [
                    $6981e83672fe6c5f$var$CacheContext
                ], renderLanes, !0);
                $6981e83672fe6c5f$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $6981e83672fe6c5f$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $6981e83672fe6c5f$var$createCapturedValueAtFiber(Error($6981e83672fe6c5f$var$formatProdErrorMessage(424)), workInProgress);
                        $6981e83672fe6c5f$var$queueHydrationError($$typeof);
                        workInProgress = $6981e83672fe6c5f$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $6981e83672fe6c5f$var$nextHydratableInstance = $6981e83672fe6c5f$var$getNextHydratable(current.firstChild);
                        $6981e83672fe6c5f$var$hydrationParentFiber = workInProgress;
                        $6981e83672fe6c5f$var$isHydrating = !0;
                        $6981e83672fe6c5f$var$hydrationErrors = null;
                        $6981e83672fe6c5f$var$rootOrSingletonContext = !0;
                        renderLanes = $6981e83672fe6c5f$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $6981e83672fe6c5f$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $6981e83672fe6c5f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $6981e83672fe6c5f$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $6981e83672fe6c5f$var$markRef(current, workInProgress), null === current ? (renderLanes = $6981e83672fe6c5f$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $6981e83672fe6c5f$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $6981e83672fe6c5f$var$getOwnerDocumentFromRootContainer($6981e83672fe6c5f$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$6981e83672fe6c5f$var$internalInstanceKey] = workInProgress, props[$6981e83672fe6c5f$var$internalPropsKey] = current, $6981e83672fe6c5f$var$setInitialProperties(props, renderLanes, current), $6981e83672fe6c5f$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $6981e83672fe6c5f$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $6981e83672fe6c5f$var$pushHostContext(workInProgress), null === current && $6981e83672fe6c5f$var$isHydrating && (props = workInProgress.stateNode = $6981e83672fe6c5f$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $6981e83672fe6c5f$var$rootInstanceStackCursor.current), $6981e83672fe6c5f$var$hydrationParentFiber = workInProgress, $6981e83672fe6c5f$var$rootOrSingletonContext = !0, $$typeof = $6981e83672fe6c5f$var$nextHydratableInstance, $6981e83672fe6c5f$var$isSingletonScope(workInProgress.type) ? ($6981e83672fe6c5f$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $6981e83672fe6c5f$var$nextHydratableInstance = $6981e83672fe6c5f$var$getNextHydratable(props.firstChild)) : $6981e83672fe6c5f$var$nextHydratableInstance = $$typeof), $6981e83672fe6c5f$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $6981e83672fe6c5f$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $6981e83672fe6c5f$var$isHydrating) {
                if ($$typeof = props = $6981e83672fe6c5f$var$nextHydratableInstance) props = $6981e83672fe6c5f$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $6981e83672fe6c5f$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $6981e83672fe6c5f$var$hydrationParentFiber = workInProgress, $6981e83672fe6c5f$var$nextHydratableInstance = $6981e83672fe6c5f$var$getNextHydratable(props.firstChild), $6981e83672fe6c5f$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $6981e83672fe6c5f$var$throwOnHydrationMismatch(workInProgress);
            }
            $6981e83672fe6c5f$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $6981e83672fe6c5f$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $6981e83672fe6c5f$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $6981e83672fe6c5f$var$renderWithHooks(current, workInProgress, $6981e83672fe6c5f$var$TransitionAwareHostComponent, null, null, renderLanes), $6981e83672fe6c5f$var$HostTransitionContext._currentValue = $$typeof);
            $6981e83672fe6c5f$var$markRef(current, workInProgress);
            $6981e83672fe6c5f$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $6981e83672fe6c5f$var$isHydrating) {
                if (current = renderLanes = $6981e83672fe6c5f$var$nextHydratableInstance) renderLanes = $6981e83672fe6c5f$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $6981e83672fe6c5f$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $6981e83672fe6c5f$var$hydrationParentFiber = workInProgress, $6981e83672fe6c5f$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $6981e83672fe6c5f$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $6981e83672fe6c5f$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $6981e83672fe6c5f$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $6981e83672fe6c5f$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $6981e83672fe6c5f$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $6981e83672fe6c5f$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $6981e83672fe6c5f$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $6981e83672fe6c5f$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $6981e83672fe6c5f$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $6981e83672fe6c5f$var$pushProvider(workInProgress, workInProgress.type, props.value), $6981e83672fe6c5f$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $6981e83672fe6c5f$var$prepareToReadContext(workInProgress), $$typeof = $6981e83672fe6c5f$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $6981e83672fe6c5f$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $6981e83672fe6c5f$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $6981e83672fe6c5f$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $6981e83672fe6c5f$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $6981e83672fe6c5f$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $6981e83672fe6c5f$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $6981e83672fe6c5f$var$prepareToReadContext(workInProgress), props = $6981e83672fe6c5f$var$readContext($6981e83672fe6c5f$var$CacheContext), null === current ? ($$typeof = $6981e83672fe6c5f$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $6981e83672fe6c5f$var$workInProgressRoot, prevState = $6981e83672fe6c5f$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $6981e83672fe6c5f$var$initializeUpdateQueue(workInProgress), $6981e83672fe6c5f$var$pushProvider(workInProgress, $6981e83672fe6c5f$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($6981e83672fe6c5f$var$cloneUpdateQueue(current, workInProgress), $6981e83672fe6c5f$var$processUpdateQueue(workInProgress, null, null, renderLanes), $6981e83672fe6c5f$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $6981e83672fe6c5f$var$pushProvider(workInProgress, $6981e83672fe6c5f$var$CacheContext, props)) : (props = prevState.cache, $6981e83672fe6c5f$var$pushProvider(workInProgress, $6981e83672fe6c5f$var$CacheContext, props), props !== $$typeof.cache && $6981e83672fe6c5f$var$propagateContextChanges(workInProgress, [
                $6981e83672fe6c5f$var$CacheContext
            ], renderLanes, !0))), $6981e83672fe6c5f$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $6981e83672fe6c5f$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $6981e83672fe6c5f$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($6981e83672fe6c5f$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $6981e83672fe6c5f$var$suspendedThenable = $6981e83672fe6c5f$var$noopSuspenseyCommitThenable, $6981e83672fe6c5f$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $6981e83672fe6c5f$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$6981e83672fe6c5f$var$preloadResource(resource)) {
        if ($6981e83672fe6c5f$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $6981e83672fe6c5f$var$suspendedThenable = $6981e83672fe6c5f$var$noopSuspenseyCommitThenable, $6981e83672fe6c5f$var$SuspenseyCommitException;
    }
}
function $6981e83672fe6c5f$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $6981e83672fe6c5f$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $6981e83672fe6c5f$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $6981e83672fe6c5f$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$6981e83672fe6c5f$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $6981e83672fe6c5f$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $6981e83672fe6c5f$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $6981e83672fe6c5f$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $6981e83672fe6c5f$var$bubbleProperties(workInProgress), null;
        case 1:
            return $6981e83672fe6c5f$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $6981e83672fe6c5f$var$popProvider($6981e83672fe6c5f$var$CacheContext);
            $6981e83672fe6c5f$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $6981e83672fe6c5f$var$popHydrationState(workInProgress) ? $6981e83672fe6c5f$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $6981e83672fe6c5f$var$upgradeHydrationErrorsToRecoverable());
            $6981e83672fe6c5f$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($6981e83672fe6c5f$var$markUpdate(workInProgress), null !== nextResource ? ($6981e83672fe6c5f$var$bubbleProperties(workInProgress), $6981e83672fe6c5f$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($6981e83672fe6c5f$var$bubbleProperties(workInProgress), $6981e83672fe6c5f$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($6981e83672fe6c5f$var$markUpdate(workInProgress), $6981e83672fe6c5f$var$bubbleProperties(workInProgress), $6981e83672fe6c5f$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($6981e83672fe6c5f$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $6981e83672fe6c5f$var$markUpdate(workInProgress), $6981e83672fe6c5f$var$bubbleProperties(workInProgress), $6981e83672fe6c5f$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $6981e83672fe6c5f$var$popHostContext(workInProgress);
            renderLanes = $6981e83672fe6c5f$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $6981e83672fe6c5f$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(166));
                    $6981e83672fe6c5f$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $6981e83672fe6c5f$var$contextStackCursor.current;
                $6981e83672fe6c5f$var$popHydrationState(workInProgress) ? $6981e83672fe6c5f$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $6981e83672fe6c5f$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $6981e83672fe6c5f$var$markUpdate(workInProgress));
            }
            $6981e83672fe6c5f$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $6981e83672fe6c5f$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $6981e83672fe6c5f$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(166));
                    $6981e83672fe6c5f$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $6981e83672fe6c5f$var$contextStackCursor.current;
                if ($6981e83672fe6c5f$var$popHydrationState(workInProgress)) $6981e83672fe6c5f$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $6981e83672fe6c5f$var$getOwnerDocumentFromRootContainer($6981e83672fe6c5f$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$6981e83672fe6c5f$var$internalInstanceKey] = workInProgress;
                    nextResource[$6981e83672fe6c5f$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($6981e83672fe6c5f$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $6981e83672fe6c5f$var$markUpdate(workInProgress);
                }
            }
            $6981e83672fe6c5f$var$bubbleProperties(workInProgress);
            $6981e83672fe6c5f$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $6981e83672fe6c5f$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(166));
                current = $6981e83672fe6c5f$var$rootInstanceStackCursor.current;
                if ($6981e83672fe6c5f$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $6981e83672fe6c5f$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$6981e83672fe6c5f$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $6981e83672fe6c5f$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $6981e83672fe6c5f$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $6981e83672fe6c5f$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$6981e83672fe6c5f$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $6981e83672fe6c5f$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $6981e83672fe6c5f$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(557));
                        current[$6981e83672fe6c5f$var$internalInstanceKey] = workInProgress;
                    } else $6981e83672fe6c5f$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $6981e83672fe6c5f$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $6981e83672fe6c5f$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $6981e83672fe6c5f$var$popSuspenseHandler(workInProgress), workInProgress;
                    $6981e83672fe6c5f$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(558));
            }
            $6981e83672fe6c5f$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $6981e83672fe6c5f$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(317));
                        type[$6981e83672fe6c5f$var$internalInstanceKey] = workInProgress;
                    } else $6981e83672fe6c5f$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $6981e83672fe6c5f$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $6981e83672fe6c5f$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $6981e83672fe6c5f$var$popSuspenseHandler(workInProgress), workInProgress;
                    $6981e83672fe6c5f$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $6981e83672fe6c5f$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $6981e83672fe6c5f$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $6981e83672fe6c5f$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $6981e83672fe6c5f$var$popHostContainer(), null === current && $6981e83672fe6c5f$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $6981e83672fe6c5f$var$bubbleProperties(workInProgress), null;
        case 10:
            return $6981e83672fe6c5f$var$popProvider(workInProgress.type), $6981e83672fe6c5f$var$bubbleProperties(workInProgress), null;
        case 19:
            $6981e83672fe6c5f$var$pop($6981e83672fe6c5f$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $6981e83672fe6c5f$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $6981e83672fe6c5f$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $6981e83672fe6c5f$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $6981e83672fe6c5f$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $6981e83672fe6c5f$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $6981e83672fe6c5f$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$6981e83672fe6c5f$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$suspenseStackCursor, $6981e83672fe6c5f$var$suspenseStackCursor.current & 1 | 2);
                            $6981e83672fe6c5f$var$isHydrating && $6981e83672fe6c5f$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $6981e83672fe6c5f$var$now() > $6981e83672fe6c5f$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $6981e83672fe6c5f$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $6981e83672fe6c5f$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $6981e83672fe6c5f$var$scheduleRetryEffect(workInProgress, current), $6981e83672fe6c5f$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$6981e83672fe6c5f$var$isHydrating) return $6981e83672fe6c5f$var$bubbleProperties(workInProgress), null;
                    } else 2 * $6981e83672fe6c5f$var$now() - newProps.renderingStartTime > $6981e83672fe6c5f$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $6981e83672fe6c5f$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $6981e83672fe6c5f$var$now(), current.sibling = null, renderLanes = $6981e83672fe6c5f$var$suspenseStackCursor.current, $6981e83672fe6c5f$var$push($6981e83672fe6c5f$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $6981e83672fe6c5f$var$isHydrating && $6981e83672fe6c5f$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $6981e83672fe6c5f$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $6981e83672fe6c5f$var$popSuspenseHandler(workInProgress), $6981e83672fe6c5f$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($6981e83672fe6c5f$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $6981e83672fe6c5f$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $6981e83672fe6c5f$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $6981e83672fe6c5f$var$pop($6981e83672fe6c5f$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $6981e83672fe6c5f$var$popProvider($6981e83672fe6c5f$var$CacheContext), $6981e83672fe6c5f$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $6981e83672fe6c5f$var$unwindWork(current, workInProgress) {
    $6981e83672fe6c5f$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $6981e83672fe6c5f$var$popProvider($6981e83672fe6c5f$var$CacheContext), $6981e83672fe6c5f$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $6981e83672fe6c5f$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $6981e83672fe6c5f$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(340));
                $6981e83672fe6c5f$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $6981e83672fe6c5f$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(340));
                $6981e83672fe6c5f$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $6981e83672fe6c5f$var$pop($6981e83672fe6c5f$var$suspenseStackCursor), null;
        case 4:
            return $6981e83672fe6c5f$var$popHostContainer(), null;
        case 10:
            return $6981e83672fe6c5f$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $6981e83672fe6c5f$var$popSuspenseHandler(workInProgress), $6981e83672fe6c5f$var$popHiddenContext(), null !== current && $6981e83672fe6c5f$var$pop($6981e83672fe6c5f$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $6981e83672fe6c5f$var$popProvider($6981e83672fe6c5f$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $6981e83672fe6c5f$var$unwindInterruptedWork(current, interruptedWork) {
    $6981e83672fe6c5f$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $6981e83672fe6c5f$var$popProvider($6981e83672fe6c5f$var$CacheContext);
            $6981e83672fe6c5f$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $6981e83672fe6c5f$var$popHostContext(interruptedWork);
            break;
        case 4:
            $6981e83672fe6c5f$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $6981e83672fe6c5f$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $6981e83672fe6c5f$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $6981e83672fe6c5f$var$pop($6981e83672fe6c5f$var$suspenseStackCursor);
            break;
        case 10:
            $6981e83672fe6c5f$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $6981e83672fe6c5f$var$popSuspenseHandler(interruptedWork);
            $6981e83672fe6c5f$var$popHiddenContext();
            null !== current && $6981e83672fe6c5f$var$pop($6981e83672fe6c5f$var$resumedCache);
            break;
        case 24:
            $6981e83672fe6c5f$var$popProvider($6981e83672fe6c5f$var$CacheContext);
    }
}
function $6981e83672fe6c5f$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $6981e83672fe6c5f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $6981e83672fe6c5f$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $6981e83672fe6c5f$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $6981e83672fe6c5f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $6981e83672fe6c5f$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $6981e83672fe6c5f$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $6981e83672fe6c5f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $6981e83672fe6c5f$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $6981e83672fe6c5f$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $6981e83672fe6c5f$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $6981e83672fe6c5f$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $6981e83672fe6c5f$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $6981e83672fe6c5f$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $6981e83672fe6c5f$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $6981e83672fe6c5f$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $6981e83672fe6c5f$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $6981e83672fe6c5f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $6981e83672fe6c5f$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $6981e83672fe6c5f$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$6981e83672fe6c5f$var$internalPropsKey] = newProps;
    } catch (error) {
        $6981e83672fe6c5f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $6981e83672fe6c5f$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $6981e83672fe6c5f$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $6981e83672fe6c5f$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $6981e83672fe6c5f$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $6981e83672fe6c5f$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $6981e83672fe6c5f$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $6981e83672fe6c5f$var$noop$1));
    else if (4 !== tag && (27 === tag && $6981e83672fe6c5f$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($6981e83672fe6c5f$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$6981e83672fe6c5f$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $6981e83672fe6c5f$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $6981e83672fe6c5f$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($6981e83672fe6c5f$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$6981e83672fe6c5f$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $6981e83672fe6c5f$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $6981e83672fe6c5f$var$setInitialProperties(singleton, type, props);
        singleton[$6981e83672fe6c5f$var$internalInstanceKey] = finishedWork;
        singleton[$6981e83672fe6c5f$var$internalPropsKey] = props;
    } catch (error) {
        $6981e83672fe6c5f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $6981e83672fe6c5f$var$offscreenSubtreeIsHidden = !1, $6981e83672fe6c5f$var$offscreenSubtreeWasHidden = !1, $6981e83672fe6c5f$var$needsFormReset = !1, $6981e83672fe6c5f$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $6981e83672fe6c5f$var$nextEffect = null;
function $6981e83672fe6c5f$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $6981e83672fe6c5f$var$eventsEnabled = $6981e83672fe6c5f$var$_enabled;
    root = $6981e83672fe6c5f$var$getActiveElementDeep(root);
    if ($6981e83672fe6c5f$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $6981e83672fe6c5f$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $6981e83672fe6c5f$var$_enabled = !1;
    for($6981e83672fe6c5f$var$nextEffect = firstChild; null !== $6981e83672fe6c5f$var$nextEffect;)if (firstChild = $6981e83672fe6c5f$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $6981e83672fe6c5f$var$nextEffect = root;
    else for(; null !== $6981e83672fe6c5f$var$nextEffect;){
        firstChild = $6981e83672fe6c5f$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $6981e83672fe6c5f$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $6981e83672fe6c5f$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $6981e83672fe6c5f$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $6981e83672fe6c5f$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $6981e83672fe6c5f$var$nextEffect = root;
            break;
        }
        $6981e83672fe6c5f$var$nextEffect = firstChild.return;
    }
}
function $6981e83672fe6c5f$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $6981e83672fe6c5f$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $6981e83672fe6c5f$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $6981e83672fe6c5f$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $6981e83672fe6c5f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $6981e83672fe6c5f$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $6981e83672fe6c5f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $6981e83672fe6c5f$var$commitClassCallbacks(finishedWork);
            flags & 512 && $6981e83672fe6c5f$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $6981e83672fe6c5f$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $6981e83672fe6c5f$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $6981e83672fe6c5f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $6981e83672fe6c5f$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $6981e83672fe6c5f$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $6981e83672fe6c5f$var$commitHostMount(finishedWork);
            flags & 512 && $6981e83672fe6c5f$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $6981e83672fe6c5f$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $6981e83672fe6c5f$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $6981e83672fe6c5f$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $6981e83672fe6c5f$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $6981e83672fe6c5f$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $6981e83672fe6c5f$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $6981e83672fe6c5f$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $6981e83672fe6c5f$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $6981e83672fe6c5f$var$offscreenSubtreeWasHidden;
                prevProps = $6981e83672fe6c5f$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $6981e83672fe6c5f$var$offscreenSubtreeWasHidden;
                $6981e83672fe6c5f$var$offscreenSubtreeIsHidden = flags;
                ($6981e83672fe6c5f$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $6981e83672fe6c5f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $6981e83672fe6c5f$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $6981e83672fe6c5f$var$offscreenSubtreeIsHidden = prevProps;
                $6981e83672fe6c5f$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $6981e83672fe6c5f$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $6981e83672fe6c5f$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $6981e83672fe6c5f$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $6981e83672fe6c5f$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $6981e83672fe6c5f$var$hostParent = null, $6981e83672fe6c5f$var$hostParentIsContainer = !1;
function $6981e83672fe6c5f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$6981e83672fe6c5f$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $6981e83672fe6c5f$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($6981e83672fe6c5f$var$injectedHook && "function" === typeof $6981e83672fe6c5f$var$injectedHook.onCommitFiberUnmount) try {
        $6981e83672fe6c5f$var$injectedHook.onCommitFiberUnmount($6981e83672fe6c5f$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $6981e83672fe6c5f$var$offscreenSubtreeWasHidden || $6981e83672fe6c5f$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $6981e83672fe6c5f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $6981e83672fe6c5f$var$offscreenSubtreeWasHidden || $6981e83672fe6c5f$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $6981e83672fe6c5f$var$hostParent, prevHostParentIsContainer = $6981e83672fe6c5f$var$hostParentIsContainer;
            $6981e83672fe6c5f$var$isSingletonScope(deletedFiber.type) && ($6981e83672fe6c5f$var$hostParent = deletedFiber.stateNode, $6981e83672fe6c5f$var$hostParentIsContainer = !1);
            $6981e83672fe6c5f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $6981e83672fe6c5f$var$releaseSingletonInstance(deletedFiber.stateNode);
            $6981e83672fe6c5f$var$hostParent = prevHostParent;
            $6981e83672fe6c5f$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $6981e83672fe6c5f$var$offscreenSubtreeWasHidden || $6981e83672fe6c5f$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $6981e83672fe6c5f$var$hostParent;
            prevHostParentIsContainer = $6981e83672fe6c5f$var$hostParentIsContainer;
            $6981e83672fe6c5f$var$hostParent = null;
            $6981e83672fe6c5f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $6981e83672fe6c5f$var$hostParent = prevHostParent;
            $6981e83672fe6c5f$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $6981e83672fe6c5f$var$hostParent) {
                if ($6981e83672fe6c5f$var$hostParentIsContainer) try {
                    (9 === $6981e83672fe6c5f$var$hostParent.nodeType ? $6981e83672fe6c5f$var$hostParent.body : "HTML" === $6981e83672fe6c5f$var$hostParent.nodeName ? $6981e83672fe6c5f$var$hostParent.ownerDocument.body : $6981e83672fe6c5f$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $6981e83672fe6c5f$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $6981e83672fe6c5f$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $6981e83672fe6c5f$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $6981e83672fe6c5f$var$hostParent && ($6981e83672fe6c5f$var$hostParentIsContainer ? (finishedRoot = $6981e83672fe6c5f$var$hostParent, $6981e83672fe6c5f$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $6981e83672fe6c5f$var$retryIfBlockedOn(finishedRoot)) : $6981e83672fe6c5f$var$clearHydrationBoundary($6981e83672fe6c5f$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $6981e83672fe6c5f$var$hostParent;
            prevHostParentIsContainer = $6981e83672fe6c5f$var$hostParentIsContainer;
            $6981e83672fe6c5f$var$hostParent = deletedFiber.stateNode.containerInfo;
            $6981e83672fe6c5f$var$hostParentIsContainer = !0;
            $6981e83672fe6c5f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $6981e83672fe6c5f$var$hostParent = prevHostParent;
            $6981e83672fe6c5f$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $6981e83672fe6c5f$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $6981e83672fe6c5f$var$offscreenSubtreeWasHidden || $6981e83672fe6c5f$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $6981e83672fe6c5f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $6981e83672fe6c5f$var$offscreenSubtreeWasHidden || ($6981e83672fe6c5f$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $6981e83672fe6c5f$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $6981e83672fe6c5f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $6981e83672fe6c5f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $6981e83672fe6c5f$var$offscreenSubtreeWasHidden = (prevHostParent = $6981e83672fe6c5f$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $6981e83672fe6c5f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $6981e83672fe6c5f$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $6981e83672fe6c5f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $6981e83672fe6c5f$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $6981e83672fe6c5f$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $6981e83672fe6c5f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $6981e83672fe6c5f$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $6981e83672fe6c5f$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $6981e83672fe6c5f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $6981e83672fe6c5f$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $6981e83672fe6c5f$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $6981e83672fe6c5f$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $6981e83672fe6c5f$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $6981e83672fe6c5f$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $6981e83672fe6c5f$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $6981e83672fe6c5f$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($6981e83672fe6c5f$var$isSingletonScope(parent.type)) {
                        $6981e83672fe6c5f$var$hostParent = parent.stateNode;
                        $6981e83672fe6c5f$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $6981e83672fe6c5f$var$hostParent = parent.stateNode;
                    $6981e83672fe6c5f$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $6981e83672fe6c5f$var$hostParent = parent.stateNode.containerInfo;
                    $6981e83672fe6c5f$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $6981e83672fe6c5f$var$hostParent) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(160));
        $6981e83672fe6c5f$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $6981e83672fe6c5f$var$hostParent = null;
        $6981e83672fe6c5f$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$6981e83672fe6c5f$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $6981e83672fe6c5f$var$currentHoistableRoot = null;
function $6981e83672fe6c5f$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $6981e83672fe6c5f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6981e83672fe6c5f$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($6981e83672fe6c5f$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $6981e83672fe6c5f$var$commitHookEffectListMount(3, finishedWork), $6981e83672fe6c5f$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $6981e83672fe6c5f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6981e83672fe6c5f$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($6981e83672fe6c5f$var$offscreenSubtreeWasHidden || null === current || $6981e83672fe6c5f$var$safelyDetachRef(current, current.return));
            flags & 64 && $6981e83672fe6c5f$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $6981e83672fe6c5f$var$currentHoistableRoot;
            $6981e83672fe6c5f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6981e83672fe6c5f$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($6981e83672fe6c5f$var$offscreenSubtreeWasHidden || null === current || $6981e83672fe6c5f$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$6981e83672fe6c5f$var$internalHoistableMarker] || currentResource[$6981e83672fe6c5f$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $6981e83672fe6c5f$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$6981e83672fe6c5f$var$internalInstanceKey] = finishedWork;
                                        $6981e83672fe6c5f$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $6981e83672fe6c5f$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $6981e83672fe6c5f$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $6981e83672fe6c5f$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $6981e83672fe6c5f$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$6981e83672fe6c5f$var$internalInstanceKey] = finishedWork;
                                $6981e83672fe6c5f$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $6981e83672fe6c5f$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $6981e83672fe6c5f$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $6981e83672fe6c5f$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $6981e83672fe6c5f$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $6981e83672fe6c5f$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $6981e83672fe6c5f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6981e83672fe6c5f$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($6981e83672fe6c5f$var$offscreenSubtreeWasHidden || null === current || $6981e83672fe6c5f$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $6981e83672fe6c5f$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $6981e83672fe6c5f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6981e83672fe6c5f$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($6981e83672fe6c5f$var$offscreenSubtreeWasHidden || null === current || $6981e83672fe6c5f$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $6981e83672fe6c5f$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $6981e83672fe6c5f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $6981e83672fe6c5f$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($6981e83672fe6c5f$var$needsFormReset = !0);
            break;
        case 6:
            $6981e83672fe6c5f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6981e83672fe6c5f$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $6981e83672fe6c5f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $6981e83672fe6c5f$var$tagCaches = null;
            hoistableRoot = $6981e83672fe6c5f$var$currentHoistableRoot;
            $6981e83672fe6c5f$var$currentHoistableRoot = $6981e83672fe6c5f$var$getHoistableRoot(root.containerInfo);
            $6981e83672fe6c5f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6981e83672fe6c5f$var$currentHoistableRoot = hoistableRoot;
            $6981e83672fe6c5f$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $6981e83672fe6c5f$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $6981e83672fe6c5f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $6981e83672fe6c5f$var$needsFormReset && ($6981e83672fe6c5f$var$needsFormReset = !1, $6981e83672fe6c5f$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $6981e83672fe6c5f$var$currentHoistableRoot;
            $6981e83672fe6c5f$var$currentHoistableRoot = $6981e83672fe6c5f$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $6981e83672fe6c5f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6981e83672fe6c5f$var$commitReconciliationEffects(finishedWork);
            $6981e83672fe6c5f$var$currentHoistableRoot = flags;
            break;
        case 12:
            $6981e83672fe6c5f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6981e83672fe6c5f$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $6981e83672fe6c5f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6981e83672fe6c5f$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $6981e83672fe6c5f$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $6981e83672fe6c5f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6981e83672fe6c5f$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($6981e83672fe6c5f$var$globalMostRecentFallbackTime = $6981e83672fe6c5f$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $6981e83672fe6c5f$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $6981e83672fe6c5f$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $6981e83672fe6c5f$var$offscreenSubtreeWasHidden;
            $6981e83672fe6c5f$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $6981e83672fe6c5f$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $6981e83672fe6c5f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6981e83672fe6c5f$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $6981e83672fe6c5f$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $6981e83672fe6c5f$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $6981e83672fe6c5f$var$offscreenSubtreeIsHidden || $6981e83672fe6c5f$var$offscreenSubtreeWasHidden || $6981e83672fe6c5f$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $6981e83672fe6c5f$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $6981e83672fe6c5f$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $6981e83672fe6c5f$var$hideOrUnhideDehydratedBoundary(instance, !0) : $6981e83672fe6c5f$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $6981e83672fe6c5f$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $6981e83672fe6c5f$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $6981e83672fe6c5f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6981e83672fe6c5f$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $6981e83672fe6c5f$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $6981e83672fe6c5f$var$recursivelyTraverseMutationEffects(root, finishedWork), $6981e83672fe6c5f$var$commitReconciliationEffects(finishedWork);
    }
}
function $6981e83672fe6c5f$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($6981e83672fe6c5f$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $6981e83672fe6c5f$var$getHostSibling(finishedWork);
                    $6981e83672fe6c5f$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($6981e83672fe6c5f$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $6981e83672fe6c5f$var$getHostSibling(finishedWork);
                    $6981e83672fe6c5f$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $6981e83672fe6c5f$var$getHostSibling(finishedWork);
                    $6981e83672fe6c5f$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $6981e83672fe6c5f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $6981e83672fe6c5f$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $6981e83672fe6c5f$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $6981e83672fe6c5f$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$6981e83672fe6c5f$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $6981e83672fe6c5f$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $6981e83672fe6c5f$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $6981e83672fe6c5f$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $6981e83672fe6c5f$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $6981e83672fe6c5f$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $6981e83672fe6c5f$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $6981e83672fe6c5f$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $6981e83672fe6c5f$var$safelyDetachRef(finishedWork, finishedWork.return);
                $6981e83672fe6c5f$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $6981e83672fe6c5f$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $6981e83672fe6c5f$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $6981e83672fe6c5f$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $6981e83672fe6c5f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $6981e83672fe6c5f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $6981e83672fe6c5f$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $6981e83672fe6c5f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $6981e83672fe6c5f$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$6981e83672fe6c5f$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $6981e83672fe6c5f$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $6981e83672fe6c5f$var$commitClassCallbacks(finishedWork);
                $6981e83672fe6c5f$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $6981e83672fe6c5f$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $6981e83672fe6c5f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $6981e83672fe6c5f$var$commitHostMount(finishedWork);
                $6981e83672fe6c5f$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $6981e83672fe6c5f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $6981e83672fe6c5f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $6981e83672fe6c5f$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $6981e83672fe6c5f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $6981e83672fe6c5f$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $6981e83672fe6c5f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $6981e83672fe6c5f$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $6981e83672fe6c5f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $6981e83672fe6c5f$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $6981e83672fe6c5f$var$releaseCache(previousCache));
}
function $6981e83672fe6c5f$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $6981e83672fe6c5f$var$releaseCache(current));
}
function $6981e83672fe6c5f$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$6981e83672fe6c5f$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $6981e83672fe6c5f$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $6981e83672fe6c5f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $6981e83672fe6c5f$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $6981e83672fe6c5f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $6981e83672fe6c5f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $6981e83672fe6c5f$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $6981e83672fe6c5f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $6981e83672fe6c5f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $6981e83672fe6c5f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $6981e83672fe6c5f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $6981e83672fe6c5f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $6981e83672fe6c5f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $6981e83672fe6c5f$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $6981e83672fe6c5f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $6981e83672fe6c5f$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $6981e83672fe6c5f$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $6981e83672fe6c5f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $6981e83672fe6c5f$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $6981e83672fe6c5f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $6981e83672fe6c5f$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $6981e83672fe6c5f$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $6981e83672fe6c5f$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $6981e83672fe6c5f$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $6981e83672fe6c5f$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $6981e83672fe6c5f$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $6981e83672fe6c5f$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $6981e83672fe6c5f$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $6981e83672fe6c5f$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $6981e83672fe6c5f$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $6981e83672fe6c5f$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $6981e83672fe6c5f$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $6981e83672fe6c5f$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $6981e83672fe6c5f$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $6981e83672fe6c5f$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $6981e83672fe6c5f$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $6981e83672fe6c5f$var$suspenseyCommitFlag = 8192;
function $6981e83672fe6c5f$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $6981e83672fe6c5f$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$6981e83672fe6c5f$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $6981e83672fe6c5f$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $6981e83672fe6c5f$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $6981e83672fe6c5f$var$suspenseyCommitFlag && null !== fiber.memoizedState && $6981e83672fe6c5f$var$suspendResource(suspendedState, $6981e83672fe6c5f$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $6981e83672fe6c5f$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $6981e83672fe6c5f$var$currentHoistableRoot;
            $6981e83672fe6c5f$var$currentHoistableRoot = $6981e83672fe6c5f$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $6981e83672fe6c5f$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $6981e83672fe6c5f$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $6981e83672fe6c5f$var$suspenseyCommitFlag, $6981e83672fe6c5f$var$suspenseyCommitFlag = 16777216, $6981e83672fe6c5f$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $6981e83672fe6c5f$var$suspenseyCommitFlag = previousHoistableRoot) : $6981e83672fe6c5f$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $6981e83672fe6c5f$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $6981e83672fe6c5f$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $6981e83672fe6c5f$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $6981e83672fe6c5f$var$nextEffect = childToDelete;
            $6981e83672fe6c5f$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $6981e83672fe6c5f$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$6981e83672fe6c5f$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $6981e83672fe6c5f$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $6981e83672fe6c5f$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $6981e83672fe6c5f$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $6981e83672fe6c5f$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $6981e83672fe6c5f$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $6981e83672fe6c5f$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $6981e83672fe6c5f$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $6981e83672fe6c5f$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $6981e83672fe6c5f$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $6981e83672fe6c5f$var$nextEffect = childToDelete;
            $6981e83672fe6c5f$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $6981e83672fe6c5f$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $6981e83672fe6c5f$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $6981e83672fe6c5f$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $6981e83672fe6c5f$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $6981e83672fe6c5f$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $6981e83672fe6c5f$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $6981e83672fe6c5f$var$nextEffect;){
        var fiber = $6981e83672fe6c5f$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $6981e83672fe6c5f$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $6981e83672fe6c5f$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $6981e83672fe6c5f$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $6981e83672fe6c5f$var$nextEffect;){
            cache = $6981e83672fe6c5f$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $6981e83672fe6c5f$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $6981e83672fe6c5f$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $6981e83672fe6c5f$var$nextEffect = sibling;
                break a;
            }
            $6981e83672fe6c5f$var$nextEffect = returnFiber;
        }
    }
}
var $6981e83672fe6c5f$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $6981e83672fe6c5f$var$readContext($6981e83672fe6c5f$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $6981e83672fe6c5f$var$readContext($6981e83672fe6c5f$var$CacheContext).controller.signal;
    }
}, $6981e83672fe6c5f$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $6981e83672fe6c5f$var$executionContext = 0, $6981e83672fe6c5f$var$workInProgressRoot = null, $6981e83672fe6c5f$var$workInProgress = null, $6981e83672fe6c5f$var$workInProgressRootRenderLanes = 0, $6981e83672fe6c5f$var$workInProgressSuspendedReason = 0, $6981e83672fe6c5f$var$workInProgressThrownValue = null, $6981e83672fe6c5f$var$workInProgressRootDidSkipSuspendedSiblings = !1, $6981e83672fe6c5f$var$workInProgressRootIsPrerendering = !1, $6981e83672fe6c5f$var$workInProgressRootDidAttachPingListener = !1, $6981e83672fe6c5f$var$entangledRenderLanes = 0, $6981e83672fe6c5f$var$workInProgressRootExitStatus = 0, $6981e83672fe6c5f$var$workInProgressRootSkippedLanes = 0, $6981e83672fe6c5f$var$workInProgressRootInterleavedUpdatedLanes = 0, $6981e83672fe6c5f$var$workInProgressRootPingedLanes = 0, $6981e83672fe6c5f$var$workInProgressDeferredLane = 0, $6981e83672fe6c5f$var$workInProgressSuspendedRetryLanes = 0, $6981e83672fe6c5f$var$workInProgressRootConcurrentErrors = null, $6981e83672fe6c5f$var$workInProgressRootRecoverableErrors = null, $6981e83672fe6c5f$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $6981e83672fe6c5f$var$globalMostRecentFallbackTime = 0, $6981e83672fe6c5f$var$globalMostRecentTransitionTime = 0, $6981e83672fe6c5f$var$workInProgressRootRenderTargetTime = Infinity, $6981e83672fe6c5f$var$workInProgressTransitions = null, $6981e83672fe6c5f$var$legacyErrorBoundariesThatAlreadyFailed = null, $6981e83672fe6c5f$var$pendingEffectsStatus = 0, $6981e83672fe6c5f$var$pendingEffectsRoot = null, $6981e83672fe6c5f$var$pendingFinishedWork = null, $6981e83672fe6c5f$var$pendingEffectsLanes = 0, $6981e83672fe6c5f$var$pendingEffectsRemainingLanes = 0, $6981e83672fe6c5f$var$pendingPassiveTransitions = null, $6981e83672fe6c5f$var$pendingRecoverableErrors = null, $6981e83672fe6c5f$var$nestedUpdateCount = 0, $6981e83672fe6c5f$var$rootWithNestedUpdates = null;
function $6981e83672fe6c5f$var$requestUpdateLane() {
    return 0 !== ($6981e83672fe6c5f$var$executionContext & 2) && 0 !== $6981e83672fe6c5f$var$workInProgressRootRenderLanes ? $6981e83672fe6c5f$var$workInProgressRootRenderLanes & -$6981e83672fe6c5f$var$workInProgressRootRenderLanes : null !== $6981e83672fe6c5f$var$ReactSharedInternals.T ? $6981e83672fe6c5f$var$requestTransitionLane() : $6981e83672fe6c5f$var$resolveUpdatePriority();
}
function $6981e83672fe6c5f$var$requestDeferredLane() {
    if (0 === $6981e83672fe6c5f$var$workInProgressDeferredLane) {
        if (0 === ($6981e83672fe6c5f$var$workInProgressRootRenderLanes & 536870912) || $6981e83672fe6c5f$var$isHydrating) {
            var lane = $6981e83672fe6c5f$var$nextTransitionDeferredLane;
            $6981e83672fe6c5f$var$nextTransitionDeferredLane <<= 1;
            0 === ($6981e83672fe6c5f$var$nextTransitionDeferredLane & 3932160) && ($6981e83672fe6c5f$var$nextTransitionDeferredLane = 262144);
            $6981e83672fe6c5f$var$workInProgressDeferredLane = lane;
        } else $6981e83672fe6c5f$var$workInProgressDeferredLane = 536870912;
    }
    lane = $6981e83672fe6c5f$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $6981e83672fe6c5f$var$workInProgressDeferredLane;
}
function $6981e83672fe6c5f$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $6981e83672fe6c5f$var$workInProgressRoot && (2 === $6981e83672fe6c5f$var$workInProgressSuspendedReason || 9 === $6981e83672fe6c5f$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $6981e83672fe6c5f$var$prepareFreshStack(root, 0), $6981e83672fe6c5f$var$markRootSuspended(root, $6981e83672fe6c5f$var$workInProgressRootRenderLanes, $6981e83672fe6c5f$var$workInProgressDeferredLane, !1);
    $6981e83672fe6c5f$var$markRootUpdated$1(root, lane);
    if (0 === ($6981e83672fe6c5f$var$executionContext & 2) || root !== $6981e83672fe6c5f$var$workInProgressRoot) root === $6981e83672fe6c5f$var$workInProgressRoot && (0 === ($6981e83672fe6c5f$var$executionContext & 2) && ($6981e83672fe6c5f$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $6981e83672fe6c5f$var$workInProgressRootExitStatus && $6981e83672fe6c5f$var$markRootSuspended(root, $6981e83672fe6c5f$var$workInProgressRootRenderLanes, $6981e83672fe6c5f$var$workInProgressDeferredLane, !1)), $6981e83672fe6c5f$var$ensureRootIsScheduled(root);
}
function $6981e83672fe6c5f$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($6981e83672fe6c5f$var$executionContext & 6)) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $6981e83672fe6c5f$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $6981e83672fe6c5f$var$renderRootConcurrent(root$jscomp$0, lanes) : $6981e83672fe6c5f$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $6981e83672fe6c5f$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $6981e83672fe6c5f$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$6981e83672fe6c5f$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $6981e83672fe6c5f$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $6981e83672fe6c5f$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($6981e83672fe6c5f$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $6981e83672fe6c5f$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($6981e83672fe6c5f$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $6981e83672fe6c5f$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $6981e83672fe6c5f$var$workInProgressRootRecoverableErrors;
                            $6981e83672fe6c5f$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $6981e83672fe6c5f$var$workInProgressRootRecoverableErrors ? $6981e83672fe6c5f$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $6981e83672fe6c5f$var$workInProgressRootRecoverableErrors.push.apply($6981e83672fe6c5f$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $6981e83672fe6c5f$var$prepareFreshStack(root$jscomp$0, 0);
                $6981e83672fe6c5f$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $6981e83672fe6c5f$var$markRootSuspended(shouldTimeSlice, lanes, $6981e83672fe6c5f$var$workInProgressDeferredLane, !$6981e83672fe6c5f$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $6981e83672fe6c5f$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $6981e83672fe6c5f$var$globalMostRecentFallbackTime + 300 - $6981e83672fe6c5f$var$now(), 10 < exitStatus)) {
                    $6981e83672fe6c5f$var$markRootSuspended(shouldTimeSlice, lanes, $6981e83672fe6c5f$var$workInProgressDeferredLane, !$6981e83672fe6c5f$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $6981e83672fe6c5f$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $6981e83672fe6c5f$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $6981e83672fe6c5f$var$scheduleTimeout($6981e83672fe6c5f$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $6981e83672fe6c5f$var$workInProgressRootRecoverableErrors, $6981e83672fe6c5f$var$workInProgressTransitions, $6981e83672fe6c5f$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $6981e83672fe6c5f$var$workInProgressDeferredLane, $6981e83672fe6c5f$var$workInProgressRootInterleavedUpdatedLanes, $6981e83672fe6c5f$var$workInProgressSuspendedRetryLanes, $6981e83672fe6c5f$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $6981e83672fe6c5f$var$commitRootWhenReady(shouldTimeSlice, forceSync, $6981e83672fe6c5f$var$workInProgressRootRecoverableErrors, $6981e83672fe6c5f$var$workInProgressTransitions, $6981e83672fe6c5f$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $6981e83672fe6c5f$var$workInProgressDeferredLane, $6981e83672fe6c5f$var$workInProgressRootInterleavedUpdatedLanes, $6981e83672fe6c5f$var$workInProgressSuspendedRetryLanes, $6981e83672fe6c5f$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $6981e83672fe6c5f$var$ensureRootIsScheduled(root$jscomp$0);
}
function $6981e83672fe6c5f$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $6981e83672fe6c5f$var$noop$1
        };
        $6981e83672fe6c5f$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $6981e83672fe6c5f$var$globalMostRecentFallbackTime - $6981e83672fe6c5f$var$now() : (lanes & 4194048) === lanes ? $6981e83672fe6c5f$var$globalMostRecentTransitionTime - $6981e83672fe6c5f$var$now() : 0;
        timeoutOffset = $6981e83672fe6c5f$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $6981e83672fe6c5f$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($6981e83672fe6c5f$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $6981e83672fe6c5f$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $6981e83672fe6c5f$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $6981e83672fe6c5f$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$6981e83672fe6c5f$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $6981e83672fe6c5f$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$6981e83672fe6c5f$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$6981e83672fe6c5f$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $6981e83672fe6c5f$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $6981e83672fe6c5f$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $6981e83672fe6c5f$var$flushSyncWork$1() {
    return 0 === ($6981e83672fe6c5f$var$executionContext & 6) ? ($6981e83672fe6c5f$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $6981e83672fe6c5f$var$resetWorkInProgressStack() {
    if (null !== $6981e83672fe6c5f$var$workInProgress) {
        if (0 === $6981e83672fe6c5f$var$workInProgressSuspendedReason) var interruptedWork = $6981e83672fe6c5f$var$workInProgress.return;
        else interruptedWork = $6981e83672fe6c5f$var$workInProgress, $6981e83672fe6c5f$var$lastContextDependency = $6981e83672fe6c5f$var$currentlyRenderingFiber$1 = null, $6981e83672fe6c5f$var$resetHooksOnUnwind(interruptedWork), $6981e83672fe6c5f$var$thenableState$1 = null, $6981e83672fe6c5f$var$thenableIndexCounter$1 = 0, interruptedWork = $6981e83672fe6c5f$var$workInProgress;
        for(; null !== interruptedWork;)$6981e83672fe6c5f$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $6981e83672fe6c5f$var$workInProgress = null;
    }
}
function $6981e83672fe6c5f$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $6981e83672fe6c5f$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $6981e83672fe6c5f$var$pendingEffectsLanes = 0;
    $6981e83672fe6c5f$var$resetWorkInProgressStack();
    $6981e83672fe6c5f$var$workInProgressRoot = root;
    $6981e83672fe6c5f$var$workInProgress = timeoutHandle = $6981e83672fe6c5f$var$createWorkInProgress(root.current, null);
    $6981e83672fe6c5f$var$workInProgressRootRenderLanes = lanes;
    $6981e83672fe6c5f$var$workInProgressSuspendedReason = 0;
    $6981e83672fe6c5f$var$workInProgressThrownValue = null;
    $6981e83672fe6c5f$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $6981e83672fe6c5f$var$workInProgressRootIsPrerendering = $6981e83672fe6c5f$var$checkIfRootIsPrerendering(root, lanes);
    $6981e83672fe6c5f$var$workInProgressRootDidAttachPingListener = !1;
    $6981e83672fe6c5f$var$workInProgressSuspendedRetryLanes = $6981e83672fe6c5f$var$workInProgressDeferredLane = $6981e83672fe6c5f$var$workInProgressRootPingedLanes = $6981e83672fe6c5f$var$workInProgressRootInterleavedUpdatedLanes = $6981e83672fe6c5f$var$workInProgressRootSkippedLanes = $6981e83672fe6c5f$var$workInProgressRootExitStatus = 0;
    $6981e83672fe6c5f$var$workInProgressRootRecoverableErrors = $6981e83672fe6c5f$var$workInProgressRootConcurrentErrors = null;
    $6981e83672fe6c5f$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $6981e83672fe6c5f$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $6981e83672fe6c5f$var$entangledRenderLanes = lanes;
    $6981e83672fe6c5f$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $6981e83672fe6c5f$var$handleThrow(root, thrownValue) {
    $6981e83672fe6c5f$var$currentlyRenderingFiber = null;
    $6981e83672fe6c5f$var$ReactSharedInternals.H = $6981e83672fe6c5f$var$ContextOnlyDispatcher;
    thrownValue === $6981e83672fe6c5f$var$SuspenseException || thrownValue === $6981e83672fe6c5f$var$SuspenseActionException ? (thrownValue = $6981e83672fe6c5f$var$getSuspendedThenable(), $6981e83672fe6c5f$var$workInProgressSuspendedReason = 3) : thrownValue === $6981e83672fe6c5f$var$SuspenseyCommitException ? (thrownValue = $6981e83672fe6c5f$var$getSuspendedThenable(), $6981e83672fe6c5f$var$workInProgressSuspendedReason = 4) : $6981e83672fe6c5f$var$workInProgressSuspendedReason = thrownValue === $6981e83672fe6c5f$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $6981e83672fe6c5f$var$workInProgressThrownValue = thrownValue;
    null === $6981e83672fe6c5f$var$workInProgress && ($6981e83672fe6c5f$var$workInProgressRootExitStatus = 1, $6981e83672fe6c5f$var$logUncaughtError(root, $6981e83672fe6c5f$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $6981e83672fe6c5f$var$shouldRemainOnPreviousScreen() {
    var handler = $6981e83672fe6c5f$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($6981e83672fe6c5f$var$workInProgressRootRenderLanes & 4194048) === $6981e83672fe6c5f$var$workInProgressRootRenderLanes ? null === $6981e83672fe6c5f$var$shellBoundary ? !0 : !1 : ($6981e83672fe6c5f$var$workInProgressRootRenderLanes & 62914560) === $6981e83672fe6c5f$var$workInProgressRootRenderLanes || 0 !== ($6981e83672fe6c5f$var$workInProgressRootRenderLanes & 536870912) ? handler === $6981e83672fe6c5f$var$shellBoundary : !1;
}
function $6981e83672fe6c5f$var$pushDispatcher() {
    var prevDispatcher = $6981e83672fe6c5f$var$ReactSharedInternals.H;
    $6981e83672fe6c5f$var$ReactSharedInternals.H = $6981e83672fe6c5f$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $6981e83672fe6c5f$var$ContextOnlyDispatcher : prevDispatcher;
}
function $6981e83672fe6c5f$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $6981e83672fe6c5f$var$ReactSharedInternals.A;
    $6981e83672fe6c5f$var$ReactSharedInternals.A = $6981e83672fe6c5f$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $6981e83672fe6c5f$var$renderDidSuspendDelayIfPossible() {
    $6981e83672fe6c5f$var$workInProgressRootExitStatus = 4;
    $6981e83672fe6c5f$var$workInProgressRootDidSkipSuspendedSiblings || ($6981e83672fe6c5f$var$workInProgressRootRenderLanes & 4194048) !== $6981e83672fe6c5f$var$workInProgressRootRenderLanes && null !== $6981e83672fe6c5f$var$suspenseHandlerStackCursor.current || ($6981e83672fe6c5f$var$workInProgressRootIsPrerendering = !0);
    0 === ($6981e83672fe6c5f$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($6981e83672fe6c5f$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $6981e83672fe6c5f$var$workInProgressRoot || $6981e83672fe6c5f$var$markRootSuspended($6981e83672fe6c5f$var$workInProgressRoot, $6981e83672fe6c5f$var$workInProgressRootRenderLanes, $6981e83672fe6c5f$var$workInProgressDeferredLane, !1);
}
function $6981e83672fe6c5f$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $6981e83672fe6c5f$var$executionContext;
    $6981e83672fe6c5f$var$executionContext |= 2;
    var prevDispatcher = $6981e83672fe6c5f$var$pushDispatcher(), prevAsyncDispatcher = $6981e83672fe6c5f$var$pushAsyncDispatcher();
    if ($6981e83672fe6c5f$var$workInProgressRoot !== root || $6981e83672fe6c5f$var$workInProgressRootRenderLanes !== lanes) $6981e83672fe6c5f$var$workInProgressTransitions = null, $6981e83672fe6c5f$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $6981e83672fe6c5f$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $6981e83672fe6c5f$var$workInProgressSuspendedReason && null !== $6981e83672fe6c5f$var$workInProgress) {
            var unitOfWork = $6981e83672fe6c5f$var$workInProgress, thrownValue = $6981e83672fe6c5f$var$workInProgressThrownValue;
            switch($6981e83672fe6c5f$var$workInProgressSuspendedReason){
                case 8:
                    $6981e83672fe6c5f$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $6981e83672fe6c5f$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $6981e83672fe6c5f$var$workInProgressSuspendedReason;
                    $6981e83672fe6c5f$var$workInProgressSuspendedReason = 0;
                    $6981e83672fe6c5f$var$workInProgressThrownValue = null;
                    $6981e83672fe6c5f$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $6981e83672fe6c5f$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $6981e83672fe6c5f$var$workInProgressSuspendedReason, $6981e83672fe6c5f$var$workInProgressSuspendedReason = 0, $6981e83672fe6c5f$var$workInProgressThrownValue = null, $6981e83672fe6c5f$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $6981e83672fe6c5f$var$workLoopSync();
        exitStatus = $6981e83672fe6c5f$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $6981e83672fe6c5f$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $6981e83672fe6c5f$var$lastContextDependency = $6981e83672fe6c5f$var$currentlyRenderingFiber$1 = null;
    $6981e83672fe6c5f$var$executionContext = prevExecutionContext;
    $6981e83672fe6c5f$var$ReactSharedInternals.H = prevDispatcher;
    $6981e83672fe6c5f$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $6981e83672fe6c5f$var$workInProgress && ($6981e83672fe6c5f$var$workInProgressRoot = null, $6981e83672fe6c5f$var$workInProgressRootRenderLanes = 0, $6981e83672fe6c5f$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $6981e83672fe6c5f$var$workLoopSync() {
    for(; null !== $6981e83672fe6c5f$var$workInProgress;)$6981e83672fe6c5f$var$performUnitOfWork($6981e83672fe6c5f$var$workInProgress);
}
function $6981e83672fe6c5f$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $6981e83672fe6c5f$var$executionContext;
    $6981e83672fe6c5f$var$executionContext |= 2;
    var prevDispatcher = $6981e83672fe6c5f$var$pushDispatcher(), prevAsyncDispatcher = $6981e83672fe6c5f$var$pushAsyncDispatcher();
    $6981e83672fe6c5f$var$workInProgressRoot !== root || $6981e83672fe6c5f$var$workInProgressRootRenderLanes !== lanes ? ($6981e83672fe6c5f$var$workInProgressTransitions = null, $6981e83672fe6c5f$var$workInProgressRootRenderTargetTime = $6981e83672fe6c5f$var$now() + 500, $6981e83672fe6c5f$var$prepareFreshStack(root, lanes)) : $6981e83672fe6c5f$var$workInProgressRootIsPrerendering = $6981e83672fe6c5f$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $6981e83672fe6c5f$var$workInProgressSuspendedReason && null !== $6981e83672fe6c5f$var$workInProgress) {
            lanes = $6981e83672fe6c5f$var$workInProgress;
            var thrownValue = $6981e83672fe6c5f$var$workInProgressThrownValue;
            b: switch($6981e83672fe6c5f$var$workInProgressSuspendedReason){
                case 1:
                    $6981e83672fe6c5f$var$workInProgressSuspendedReason = 0;
                    $6981e83672fe6c5f$var$workInProgressThrownValue = null;
                    $6981e83672fe6c5f$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($6981e83672fe6c5f$var$isThenableResolved(thrownValue)) {
                        $6981e83672fe6c5f$var$workInProgressSuspendedReason = 0;
                        $6981e83672fe6c5f$var$workInProgressThrownValue = null;
                        $6981e83672fe6c5f$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $6981e83672fe6c5f$var$workInProgressSuspendedReason && 9 !== $6981e83672fe6c5f$var$workInProgressSuspendedReason || $6981e83672fe6c5f$var$workInProgressRoot !== root || ($6981e83672fe6c5f$var$workInProgressSuspendedReason = 7);
                        $6981e83672fe6c5f$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $6981e83672fe6c5f$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $6981e83672fe6c5f$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $6981e83672fe6c5f$var$isThenableResolved(thrownValue) ? ($6981e83672fe6c5f$var$workInProgressSuspendedReason = 0, $6981e83672fe6c5f$var$workInProgressThrownValue = null, $6981e83672fe6c5f$var$replaySuspendedUnitOfWork(lanes)) : ($6981e83672fe6c5f$var$workInProgressSuspendedReason = 0, $6981e83672fe6c5f$var$workInProgressThrownValue = null, $6981e83672fe6c5f$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($6981e83672fe6c5f$var$workInProgress.tag){
                        case 26:
                            resource = $6981e83672fe6c5f$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $6981e83672fe6c5f$var$workInProgress;
                            if (resource ? $6981e83672fe6c5f$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $6981e83672fe6c5f$var$workInProgressSuspendedReason = 0;
                                $6981e83672fe6c5f$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $6981e83672fe6c5f$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($6981e83672fe6c5f$var$workInProgress = returnFiber, $6981e83672fe6c5f$var$completeUnitOfWork(returnFiber)) : $6981e83672fe6c5f$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $6981e83672fe6c5f$var$workInProgressSuspendedReason = 0;
                    $6981e83672fe6c5f$var$workInProgressThrownValue = null;
                    $6981e83672fe6c5f$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $6981e83672fe6c5f$var$workInProgressSuspendedReason = 0;
                    $6981e83672fe6c5f$var$workInProgressThrownValue = null;
                    $6981e83672fe6c5f$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $6981e83672fe6c5f$var$resetWorkInProgressStack();
                    $6981e83672fe6c5f$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(462));
            }
        }
        $6981e83672fe6c5f$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $6981e83672fe6c5f$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $6981e83672fe6c5f$var$lastContextDependency = $6981e83672fe6c5f$var$currentlyRenderingFiber$1 = null;
    $6981e83672fe6c5f$var$ReactSharedInternals.H = prevDispatcher;
    $6981e83672fe6c5f$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $6981e83672fe6c5f$var$executionContext = prevExecutionContext;
    if (null !== $6981e83672fe6c5f$var$workInProgress) return 0;
    $6981e83672fe6c5f$var$workInProgressRoot = null;
    $6981e83672fe6c5f$var$workInProgressRootRenderLanes = 0;
    $6981e83672fe6c5f$var$finishQueueingConcurrentUpdates();
    return $6981e83672fe6c5f$var$workInProgressRootExitStatus;
}
function $6981e83672fe6c5f$var$workLoopConcurrentByScheduler() {
    for(; null !== $6981e83672fe6c5f$var$workInProgress && !$6981e83672fe6c5f$var$shouldYield();)$6981e83672fe6c5f$var$performUnitOfWork($6981e83672fe6c5f$var$workInProgress);
}
function $6981e83672fe6c5f$var$performUnitOfWork(unitOfWork) {
    var next = $6981e83672fe6c5f$var$beginWork(unitOfWork.alternate, unitOfWork, $6981e83672fe6c5f$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $6981e83672fe6c5f$var$completeUnitOfWork(unitOfWork) : $6981e83672fe6c5f$var$workInProgress = next;
}
function $6981e83672fe6c5f$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $6981e83672fe6c5f$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $6981e83672fe6c5f$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $6981e83672fe6c5f$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $6981e83672fe6c5f$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $6981e83672fe6c5f$var$resetHooksOnUnwind(next);
        default:
            $6981e83672fe6c5f$var$unwindInterruptedWork(current, next), next = $6981e83672fe6c5f$var$workInProgress = $6981e83672fe6c5f$var$resetWorkInProgress(next, $6981e83672fe6c5f$var$entangledRenderLanes), next = $6981e83672fe6c5f$var$beginWork(current, next, $6981e83672fe6c5f$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $6981e83672fe6c5f$var$completeUnitOfWork(unitOfWork) : $6981e83672fe6c5f$var$workInProgress = next;
}
function $6981e83672fe6c5f$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $6981e83672fe6c5f$var$lastContextDependency = $6981e83672fe6c5f$var$currentlyRenderingFiber$1 = null;
    $6981e83672fe6c5f$var$resetHooksOnUnwind(unitOfWork);
    $6981e83672fe6c5f$var$thenableState$1 = null;
    $6981e83672fe6c5f$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($6981e83672fe6c5f$var$throwException(root, returnFiber, unitOfWork, thrownValue, $6981e83672fe6c5f$var$workInProgressRootRenderLanes)) {
            $6981e83672fe6c5f$var$workInProgressRootExitStatus = 1;
            $6981e83672fe6c5f$var$logUncaughtError(root, $6981e83672fe6c5f$var$createCapturedValueAtFiber(thrownValue, root.current));
            $6981e83672fe6c5f$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $6981e83672fe6c5f$var$workInProgress = returnFiber, error;
        $6981e83672fe6c5f$var$workInProgressRootExitStatus = 1;
        $6981e83672fe6c5f$var$logUncaughtError(root, $6981e83672fe6c5f$var$createCapturedValueAtFiber(thrownValue, root.current));
        $6981e83672fe6c5f$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($6981e83672fe6c5f$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($6981e83672fe6c5f$var$workInProgressRootIsPrerendering || 0 !== ($6981e83672fe6c5f$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($6981e83672fe6c5f$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $6981e83672fe6c5f$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $6981e83672fe6c5f$var$unwindUnitOfWork(unitOfWork, root);
    } else $6981e83672fe6c5f$var$completeUnitOfWork(unitOfWork);
}
function $6981e83672fe6c5f$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $6981e83672fe6c5f$var$unwindUnitOfWork(completedWork, $6981e83672fe6c5f$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $6981e83672fe6c5f$var$completeWork(completedWork.alternate, completedWork, $6981e83672fe6c5f$var$entangledRenderLanes);
        if (null !== next) {
            $6981e83672fe6c5f$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $6981e83672fe6c5f$var$workInProgress = completedWork;
            return;
        }
        $6981e83672fe6c5f$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $6981e83672fe6c5f$var$workInProgressRootExitStatus && ($6981e83672fe6c5f$var$workInProgressRootExitStatus = 5);
}
function $6981e83672fe6c5f$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $6981e83672fe6c5f$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $6981e83672fe6c5f$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $6981e83672fe6c5f$var$workInProgress = unitOfWork;
            return;
        }
        $6981e83672fe6c5f$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $6981e83672fe6c5f$var$workInProgressRootExitStatus = 6;
    $6981e83672fe6c5f$var$workInProgress = null;
}
function $6981e83672fe6c5f$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $6981e83672fe6c5f$var$flushPendingEffects();
    while (0 !== $6981e83672fe6c5f$var$pendingEffectsStatus);
    if (0 !== ($6981e83672fe6c5f$var$executionContext & 6)) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $6981e83672fe6c5f$var$concurrentlyUpdatedLanes;
        $6981e83672fe6c5f$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $6981e83672fe6c5f$var$workInProgressRoot && ($6981e83672fe6c5f$var$workInProgress = $6981e83672fe6c5f$var$workInProgressRoot = null, $6981e83672fe6c5f$var$workInProgressRootRenderLanes = 0);
        $6981e83672fe6c5f$var$pendingFinishedWork = finishedWork;
        $6981e83672fe6c5f$var$pendingEffectsRoot = root;
        $6981e83672fe6c5f$var$pendingEffectsLanes = lanes;
        $6981e83672fe6c5f$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $6981e83672fe6c5f$var$pendingPassiveTransitions = transitions;
        $6981e83672fe6c5f$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $6981e83672fe6c5f$var$scheduleCallback$1($6981e83672fe6c5f$var$NormalPriority$1, function() {
            $6981e83672fe6c5f$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $6981e83672fe6c5f$var$ReactSharedInternals.T;
            $6981e83672fe6c5f$var$ReactSharedInternals.T = null;
            transitions = $6981e83672fe6c5f$var$ReactDOMSharedInternals.p;
            $6981e83672fe6c5f$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $6981e83672fe6c5f$var$executionContext;
            $6981e83672fe6c5f$var$executionContext |= 4;
            try {
                $6981e83672fe6c5f$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $6981e83672fe6c5f$var$executionContext = spawnedLane, $6981e83672fe6c5f$var$ReactDOMSharedInternals.p = transitions, $6981e83672fe6c5f$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $6981e83672fe6c5f$var$pendingEffectsStatus = 1;
        $6981e83672fe6c5f$var$flushMutationEffects();
        $6981e83672fe6c5f$var$flushLayoutEffects();
        $6981e83672fe6c5f$var$flushSpawnedWork();
    }
}
function $6981e83672fe6c5f$var$flushMutationEffects() {
    if (1 === $6981e83672fe6c5f$var$pendingEffectsStatus) {
        $6981e83672fe6c5f$var$pendingEffectsStatus = 0;
        var root = $6981e83672fe6c5f$var$pendingEffectsRoot, finishedWork = $6981e83672fe6c5f$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $6981e83672fe6c5f$var$ReactSharedInternals.T;
            $6981e83672fe6c5f$var$ReactSharedInternals.T = null;
            var previousPriority = $6981e83672fe6c5f$var$ReactDOMSharedInternals.p;
            $6981e83672fe6c5f$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $6981e83672fe6c5f$var$executionContext;
            $6981e83672fe6c5f$var$executionContext |= 4;
            try {
                $6981e83672fe6c5f$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $6981e83672fe6c5f$var$selectionInformation, curFocusedElem = $6981e83672fe6c5f$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $6981e83672fe6c5f$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $6981e83672fe6c5f$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $6981e83672fe6c5f$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $6981e83672fe6c5f$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $6981e83672fe6c5f$var$_enabled = !!$6981e83672fe6c5f$var$eventsEnabled;
                $6981e83672fe6c5f$var$selectionInformation = $6981e83672fe6c5f$var$eventsEnabled = null;
            } finally{
                $6981e83672fe6c5f$var$executionContext = prevExecutionContext, $6981e83672fe6c5f$var$ReactDOMSharedInternals.p = previousPriority, $6981e83672fe6c5f$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $6981e83672fe6c5f$var$pendingEffectsStatus = 2;
    }
}
function $6981e83672fe6c5f$var$flushLayoutEffects() {
    if (2 === $6981e83672fe6c5f$var$pendingEffectsStatus) {
        $6981e83672fe6c5f$var$pendingEffectsStatus = 0;
        var root = $6981e83672fe6c5f$var$pendingEffectsRoot, finishedWork = $6981e83672fe6c5f$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $6981e83672fe6c5f$var$ReactSharedInternals.T;
            $6981e83672fe6c5f$var$ReactSharedInternals.T = null;
            var previousPriority = $6981e83672fe6c5f$var$ReactDOMSharedInternals.p;
            $6981e83672fe6c5f$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $6981e83672fe6c5f$var$executionContext;
            $6981e83672fe6c5f$var$executionContext |= 4;
            try {
                $6981e83672fe6c5f$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $6981e83672fe6c5f$var$executionContext = prevExecutionContext, $6981e83672fe6c5f$var$ReactDOMSharedInternals.p = previousPriority, $6981e83672fe6c5f$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $6981e83672fe6c5f$var$pendingEffectsStatus = 3;
    }
}
function $6981e83672fe6c5f$var$flushSpawnedWork() {
    if (4 === $6981e83672fe6c5f$var$pendingEffectsStatus || 3 === $6981e83672fe6c5f$var$pendingEffectsStatus) {
        $6981e83672fe6c5f$var$pendingEffectsStatus = 0;
        $6981e83672fe6c5f$var$requestPaint();
        var root = $6981e83672fe6c5f$var$pendingEffectsRoot, finishedWork = $6981e83672fe6c5f$var$pendingFinishedWork, lanes = $6981e83672fe6c5f$var$pendingEffectsLanes, recoverableErrors = $6981e83672fe6c5f$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $6981e83672fe6c5f$var$pendingEffectsStatus = 5 : ($6981e83672fe6c5f$var$pendingEffectsStatus = 0, $6981e83672fe6c5f$var$pendingFinishedWork = $6981e83672fe6c5f$var$pendingEffectsRoot = null, $6981e83672fe6c5f$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($6981e83672fe6c5f$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $6981e83672fe6c5f$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($6981e83672fe6c5f$var$injectedHook && "function" === typeof $6981e83672fe6c5f$var$injectedHook.onCommitFiberRoot) try {
            $6981e83672fe6c5f$var$injectedHook.onCommitFiberRoot($6981e83672fe6c5f$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $6981e83672fe6c5f$var$ReactSharedInternals.T;
            remainingLanes = $6981e83672fe6c5f$var$ReactDOMSharedInternals.p;
            $6981e83672fe6c5f$var$ReactDOMSharedInternals.p = 2;
            $6981e83672fe6c5f$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $6981e83672fe6c5f$var$ReactSharedInternals.T = finishedWork, $6981e83672fe6c5f$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($6981e83672fe6c5f$var$pendingEffectsLanes & 3) && $6981e83672fe6c5f$var$flushPendingEffects();
        $6981e83672fe6c5f$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $6981e83672fe6c5f$var$rootWithNestedUpdates ? $6981e83672fe6c5f$var$nestedUpdateCount++ : ($6981e83672fe6c5f$var$nestedUpdateCount = 0, $6981e83672fe6c5f$var$rootWithNestedUpdates = root) : $6981e83672fe6c5f$var$nestedUpdateCount = 0;
        $6981e83672fe6c5f$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $6981e83672fe6c5f$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $6981e83672fe6c5f$var$releaseCache(remainingLanes)));
}
function $6981e83672fe6c5f$var$flushPendingEffects() {
    $6981e83672fe6c5f$var$flushMutationEffects();
    $6981e83672fe6c5f$var$flushLayoutEffects();
    $6981e83672fe6c5f$var$flushSpawnedWork();
    return $6981e83672fe6c5f$var$flushPassiveEffects();
}
function $6981e83672fe6c5f$var$flushPassiveEffects() {
    if (5 !== $6981e83672fe6c5f$var$pendingEffectsStatus) return !1;
    var root = $6981e83672fe6c5f$var$pendingEffectsRoot, remainingLanes = $6981e83672fe6c5f$var$pendingEffectsRemainingLanes;
    $6981e83672fe6c5f$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $6981e83672fe6c5f$var$lanesToEventPriority($6981e83672fe6c5f$var$pendingEffectsLanes), prevTransition = $6981e83672fe6c5f$var$ReactSharedInternals.T, previousPriority = $6981e83672fe6c5f$var$ReactDOMSharedInternals.p;
    try {
        $6981e83672fe6c5f$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $6981e83672fe6c5f$var$ReactSharedInternals.T = null;
        renderPriority = $6981e83672fe6c5f$var$pendingPassiveTransitions;
        $6981e83672fe6c5f$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $6981e83672fe6c5f$var$pendingEffectsRoot, lanes = $6981e83672fe6c5f$var$pendingEffectsLanes;
        $6981e83672fe6c5f$var$pendingEffectsStatus = 0;
        $6981e83672fe6c5f$var$pendingFinishedWork = $6981e83672fe6c5f$var$pendingEffectsRoot = null;
        $6981e83672fe6c5f$var$pendingEffectsLanes = 0;
        if (0 !== ($6981e83672fe6c5f$var$executionContext & 6)) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(331));
        var prevExecutionContext = $6981e83672fe6c5f$var$executionContext;
        $6981e83672fe6c5f$var$executionContext |= 4;
        $6981e83672fe6c5f$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $6981e83672fe6c5f$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $6981e83672fe6c5f$var$executionContext = prevExecutionContext;
        $6981e83672fe6c5f$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($6981e83672fe6c5f$var$injectedHook && "function" === typeof $6981e83672fe6c5f$var$injectedHook.onPostCommitFiberRoot) try {
            $6981e83672fe6c5f$var$injectedHook.onPostCommitFiberRoot($6981e83672fe6c5f$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $6981e83672fe6c5f$var$ReactDOMSharedInternals.p = previousPriority, $6981e83672fe6c5f$var$ReactSharedInternals.T = prevTransition, $6981e83672fe6c5f$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $6981e83672fe6c5f$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $6981e83672fe6c5f$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $6981e83672fe6c5f$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $6981e83672fe6c5f$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($6981e83672fe6c5f$var$markRootUpdated$1(rootFiber, 2), $6981e83672fe6c5f$var$ensureRootIsScheduled(rootFiber));
}
function $6981e83672fe6c5f$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $6981e83672fe6c5f$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $6981e83672fe6c5f$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $6981e83672fe6c5f$var$legacyErrorBoundariesThatAlreadyFailed || !$6981e83672fe6c5f$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $6981e83672fe6c5f$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $6981e83672fe6c5f$var$createClassErrorUpdate(2);
                instance = $6981e83672fe6c5f$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($6981e83672fe6c5f$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $6981e83672fe6c5f$var$markRootUpdated$1(instance, 2), $6981e83672fe6c5f$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $6981e83672fe6c5f$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $6981e83672fe6c5f$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($6981e83672fe6c5f$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $6981e83672fe6c5f$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $6981e83672fe6c5f$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $6981e83672fe6c5f$var$workInProgressRoot === root && ($6981e83672fe6c5f$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $6981e83672fe6c5f$var$workInProgressRootExitStatus || 3 === $6981e83672fe6c5f$var$workInProgressRootExitStatus && ($6981e83672fe6c5f$var$workInProgressRootRenderLanes & 62914560) === $6981e83672fe6c5f$var$workInProgressRootRenderLanes && 300 > $6981e83672fe6c5f$var$now() - $6981e83672fe6c5f$var$globalMostRecentFallbackTime ? 0 === ($6981e83672fe6c5f$var$executionContext & 2) && $6981e83672fe6c5f$var$prepareFreshStack(root, 0) : $6981e83672fe6c5f$var$workInProgressRootPingedLanes |= pingedLanes, $6981e83672fe6c5f$var$workInProgressSuspendedRetryLanes === $6981e83672fe6c5f$var$workInProgressRootRenderLanes && ($6981e83672fe6c5f$var$workInProgressSuspendedRetryLanes = 0));
    $6981e83672fe6c5f$var$ensureRootIsScheduled(root);
}
function $6981e83672fe6c5f$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $6981e83672fe6c5f$var$claimNextRetryLane());
    boundaryFiber = $6981e83672fe6c5f$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($6981e83672fe6c5f$var$markRootUpdated$1(boundaryFiber, retryLane), $6981e83672fe6c5f$var$ensureRootIsScheduled(boundaryFiber));
}
function $6981e83672fe6c5f$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $6981e83672fe6c5f$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $6981e83672fe6c5f$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $6981e83672fe6c5f$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $6981e83672fe6c5f$var$scheduleCallback$1(priorityLevel, callback) {
    return $6981e83672fe6c5f$var$scheduleCallback$3(priorityLevel, callback);
}
var $6981e83672fe6c5f$var$firstScheduledRoot = null, $6981e83672fe6c5f$var$lastScheduledRoot = null, $6981e83672fe6c5f$var$didScheduleMicrotask = !1, $6981e83672fe6c5f$var$mightHavePendingSyncWork = !1, $6981e83672fe6c5f$var$isFlushingWork = !1, $6981e83672fe6c5f$var$currentEventTransitionLane = 0;
function $6981e83672fe6c5f$var$ensureRootIsScheduled(root) {
    root !== $6981e83672fe6c5f$var$lastScheduledRoot && null === root.next && (null === $6981e83672fe6c5f$var$lastScheduledRoot ? $6981e83672fe6c5f$var$firstScheduledRoot = $6981e83672fe6c5f$var$lastScheduledRoot = root : $6981e83672fe6c5f$var$lastScheduledRoot = $6981e83672fe6c5f$var$lastScheduledRoot.next = root);
    $6981e83672fe6c5f$var$mightHavePendingSyncWork = !0;
    $6981e83672fe6c5f$var$didScheduleMicrotask || ($6981e83672fe6c5f$var$didScheduleMicrotask = !0, $6981e83672fe6c5f$var$scheduleImmediateRootScheduleTask());
}
function $6981e83672fe6c5f$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$6981e83672fe6c5f$var$isFlushingWork && $6981e83672fe6c5f$var$mightHavePendingSyncWork) {
        $6981e83672fe6c5f$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $6981e83672fe6c5f$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $6981e83672fe6c5f$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $6981e83672fe6c5f$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $6981e83672fe6c5f$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $6981e83672fe6c5f$var$getNextLanes(root$170, root$170 === $6981e83672fe6c5f$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $6981e83672fe6c5f$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $6981e83672fe6c5f$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $6981e83672fe6c5f$var$isFlushingWork = !1;
    }
}
function $6981e83672fe6c5f$var$processRootScheduleInImmediateTask() {
    $6981e83672fe6c5f$var$processRootScheduleInMicrotask();
}
function $6981e83672fe6c5f$var$processRootScheduleInMicrotask() {
    $6981e83672fe6c5f$var$mightHavePendingSyncWork = $6981e83672fe6c5f$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $6981e83672fe6c5f$var$currentEventTransitionLane && $6981e83672fe6c5f$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $6981e83672fe6c5f$var$currentEventTransitionLane);
    for(var currentTime = $6981e83672fe6c5f$var$now(), prev = null, root = $6981e83672fe6c5f$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $6981e83672fe6c5f$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $6981e83672fe6c5f$var$firstScheduledRoot = next : prev.next = next, null === next && ($6981e83672fe6c5f$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $6981e83672fe6c5f$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $6981e83672fe6c5f$var$pendingEffectsStatus && 5 !== $6981e83672fe6c5f$var$pendingEffectsStatus || $6981e83672fe6c5f$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $6981e83672fe6c5f$var$currentEventTransitionLane && ($6981e83672fe6c5f$var$currentEventTransitionLane = 0);
}
function $6981e83672fe6c5f$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $6981e83672fe6c5f$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $6981e83672fe6c5f$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $6981e83672fe6c5f$var$workInProgressRoot;
    suspendedLanes = $6981e83672fe6c5f$var$workInProgressRootRenderLanes;
    suspendedLanes = $6981e83672fe6c5f$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $6981e83672fe6c5f$var$workInProgressSuspendedReason || 9 === $6981e83672fe6c5f$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $6981e83672fe6c5f$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $6981e83672fe6c5f$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $6981e83672fe6c5f$var$cancelCallback$1(pingedLanes);
        switch($6981e83672fe6c5f$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $6981e83672fe6c5f$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $6981e83672fe6c5f$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $6981e83672fe6c5f$var$IdlePriority;
                break;
            default:
                suspendedLanes = $6981e83672fe6c5f$var$NormalPriority$1;
        }
        pingedLanes = $6981e83672fe6c5f$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $6981e83672fe6c5f$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $6981e83672fe6c5f$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $6981e83672fe6c5f$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $6981e83672fe6c5f$var$pendingEffectsStatus && 5 !== $6981e83672fe6c5f$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($6981e83672fe6c5f$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $6981e83672fe6c5f$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $6981e83672fe6c5f$var$getNextLanes(root, root === $6981e83672fe6c5f$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $6981e83672fe6c5f$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $6981e83672fe6c5f$var$scheduleTaskForRootDuringMicrotask(root, $6981e83672fe6c5f$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $6981e83672fe6c5f$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $6981e83672fe6c5f$var$performSyncWorkOnRoot(root, lanes) {
    if ($6981e83672fe6c5f$var$flushPendingEffects()) return null;
    $6981e83672fe6c5f$var$performWorkOnRoot(root, lanes, !0);
}
function $6981e83672fe6c5f$var$scheduleImmediateRootScheduleTask() {
    $6981e83672fe6c5f$var$scheduleMicrotask(function() {
        0 !== ($6981e83672fe6c5f$var$executionContext & 6) ? $6981e83672fe6c5f$var$scheduleCallback$3($6981e83672fe6c5f$var$ImmediatePriority, $6981e83672fe6c5f$var$processRootScheduleInImmediateTask) : $6981e83672fe6c5f$var$processRootScheduleInMicrotask();
    });
}
function $6981e83672fe6c5f$var$requestTransitionLane() {
    if (0 === $6981e83672fe6c5f$var$currentEventTransitionLane) {
        var actionScopeLane = $6981e83672fe6c5f$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $6981e83672fe6c5f$var$nextTransitionUpdateLane, $6981e83672fe6c5f$var$nextTransitionUpdateLane <<= 1, 0 === ($6981e83672fe6c5f$var$nextTransitionUpdateLane & 261888) && ($6981e83672fe6c5f$var$nextTransitionUpdateLane = 256));
        $6981e83672fe6c5f$var$currentEventTransitionLane = actionScopeLane;
    }
    return $6981e83672fe6c5f$var$currentEventTransitionLane;
}
function $6981e83672fe6c5f$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $6981e83672fe6c5f$var$sanitizeURL("" + actionProp);
}
function $6981e83672fe6c5f$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $6981e83672fe6c5f$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $6981e83672fe6c5f$var$coerceFormActionProp((nativeEventTarget[$6981e83672fe6c5f$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$6981e83672fe6c5f$var$internalPropsKey] || null) ? $6981e83672fe6c5f$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $6981e83672fe6c5f$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $6981e83672fe6c5f$var$currentEventTransitionLane) {
                                var formData = submitter ? $6981e83672fe6c5f$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $6981e83672fe6c5f$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $6981e83672fe6c5f$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $6981e83672fe6c5f$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $6981e83672fe6c5f$var$i$jscomp$inline_1577 = 0; $6981e83672fe6c5f$var$i$jscomp$inline_1577 < $6981e83672fe6c5f$var$simpleEventPluginEvents.length; $6981e83672fe6c5f$var$i$jscomp$inline_1577++){
    var $6981e83672fe6c5f$var$eventName$jscomp$inline_1578 = $6981e83672fe6c5f$var$simpleEventPluginEvents[$6981e83672fe6c5f$var$i$jscomp$inline_1577], $6981e83672fe6c5f$var$domEventName$jscomp$inline_1579 = $6981e83672fe6c5f$var$eventName$jscomp$inline_1578.toLowerCase(), $6981e83672fe6c5f$var$capitalizedEvent$jscomp$inline_1580 = $6981e83672fe6c5f$var$eventName$jscomp$inline_1578[0].toUpperCase() + $6981e83672fe6c5f$var$eventName$jscomp$inline_1578.slice(1);
    $6981e83672fe6c5f$var$registerSimpleEvent($6981e83672fe6c5f$var$domEventName$jscomp$inline_1579, "on" + $6981e83672fe6c5f$var$capitalizedEvent$jscomp$inline_1580);
}
$6981e83672fe6c5f$var$registerSimpleEvent($6981e83672fe6c5f$var$ANIMATION_END, "onAnimationEnd");
$6981e83672fe6c5f$var$registerSimpleEvent($6981e83672fe6c5f$var$ANIMATION_ITERATION, "onAnimationIteration");
$6981e83672fe6c5f$var$registerSimpleEvent($6981e83672fe6c5f$var$ANIMATION_START, "onAnimationStart");
$6981e83672fe6c5f$var$registerSimpleEvent("dblclick", "onDoubleClick");
$6981e83672fe6c5f$var$registerSimpleEvent("focusin", "onFocus");
$6981e83672fe6c5f$var$registerSimpleEvent("focusout", "onBlur");
$6981e83672fe6c5f$var$registerSimpleEvent($6981e83672fe6c5f$var$TRANSITION_RUN, "onTransitionRun");
$6981e83672fe6c5f$var$registerSimpleEvent($6981e83672fe6c5f$var$TRANSITION_START, "onTransitionStart");
$6981e83672fe6c5f$var$registerSimpleEvent($6981e83672fe6c5f$var$TRANSITION_CANCEL, "onTransitionCancel");
$6981e83672fe6c5f$var$registerSimpleEvent($6981e83672fe6c5f$var$TRANSITION_END, "onTransitionEnd");
$6981e83672fe6c5f$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$6981e83672fe6c5f$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$6981e83672fe6c5f$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$6981e83672fe6c5f$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$6981e83672fe6c5f$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$6981e83672fe6c5f$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$6981e83672fe6c5f$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$6981e83672fe6c5f$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$6981e83672fe6c5f$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$6981e83672fe6c5f$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $6981e83672fe6c5f$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $6981e83672fe6c5f$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($6981e83672fe6c5f$var$mediaEventTypes));
function $6981e83672fe6c5f$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $6981e83672fe6c5f$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $6981e83672fe6c5f$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $6981e83672fe6c5f$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$6981e83672fe6c5f$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$6981e83672fe6c5f$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($6981e83672fe6c5f$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $6981e83672fe6c5f$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $6981e83672fe6c5f$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $6981e83672fe6c5f$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $6981e83672fe6c5f$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$6981e83672fe6c5f$var$listeningMarker]) {
        rootContainerElement[$6981e83672fe6c5f$var$listeningMarker] = !0;
        $6981e83672fe6c5f$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($6981e83672fe6c5f$var$nonDelegatedEvents.has(domEventName) || $6981e83672fe6c5f$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $6981e83672fe6c5f$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$6981e83672fe6c5f$var$listeningMarker] || (ownerDocument[$6981e83672fe6c5f$var$listeningMarker] = !0, $6981e83672fe6c5f$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $6981e83672fe6c5f$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($6981e83672fe6c5f$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $6981e83672fe6c5f$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $6981e83672fe6c5f$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $6981e83672fe6c5f$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$6981e83672fe6c5f$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $6981e83672fe6c5f$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $6981e83672fe6c5f$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $6981e83672fe6c5f$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $6981e83672fe6c5f$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $6981e83672fe6c5f$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $6981e83672fe6c5f$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $6981e83672fe6c5f$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $6981e83672fe6c5f$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $6981e83672fe6c5f$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $6981e83672fe6c5f$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $6981e83672fe6c5f$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $6981e83672fe6c5f$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $6981e83672fe6c5f$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $6981e83672fe6c5f$var$SyntheticTouchEvent;
                        break;
                    case $6981e83672fe6c5f$var$ANIMATION_END:
                    case $6981e83672fe6c5f$var$ANIMATION_ITERATION:
                    case $6981e83672fe6c5f$var$ANIMATION_START:
                        SyntheticEventCtor = $6981e83672fe6c5f$var$SyntheticAnimationEvent;
                        break;
                    case $6981e83672fe6c5f$var$TRANSITION_END:
                        SyntheticEventCtor = $6981e83672fe6c5f$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $6981e83672fe6c5f$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $6981e83672fe6c5f$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $6981e83672fe6c5f$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $6981e83672fe6c5f$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $6981e83672fe6c5f$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $6981e83672fe6c5f$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($6981e83672fe6c5f$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $6981e83672fe6c5f$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($6981e83672fe6c5f$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$6981e83672fe6c5f$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $6981e83672fe6c5f$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $6981e83672fe6c5f$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $6981e83672fe6c5f$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $6981e83672fe6c5f$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $6981e83672fe6c5f$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $6981e83672fe6c5f$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $6981e83672fe6c5f$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $6981e83672fe6c5f$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $6981e83672fe6c5f$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $6981e83672fe6c5f$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $6981e83672fe6c5f$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $6981e83672fe6c5f$var$getTargetInstForChangeEvent;
                else if ($6981e83672fe6c5f$var$isTextInputElement(reactName)) {
                    if ($6981e83672fe6c5f$var$isInputEventSupported) getTargetInstFunc = $6981e83672fe6c5f$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $6981e83672fe6c5f$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $6981e83672fe6c5f$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $6981e83672fe6c5f$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $6981e83672fe6c5f$var$getTargetInstForChangeEvent) : getTargetInstFunc = $6981e83672fe6c5f$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $6981e83672fe6c5f$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $6981e83672fe6c5f$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $6981e83672fe6c5f$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($6981e83672fe6c5f$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $6981e83672fe6c5f$var$activeElement = handleEventFunc, $6981e83672fe6c5f$var$activeElementInst = targetInst, $6981e83672fe6c5f$var$lastSelection = null;
                    break;
                case "focusout":
                    $6981e83672fe6c5f$var$lastSelection = $6981e83672fe6c5f$var$activeElementInst = $6981e83672fe6c5f$var$activeElement = null;
                    break;
                case "mousedown":
                    $6981e83672fe6c5f$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $6981e83672fe6c5f$var$mouseDown = !1;
                    $6981e83672fe6c5f$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($6981e83672fe6c5f$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $6981e83672fe6c5f$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($6981e83672fe6c5f$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $6981e83672fe6c5f$var$isComposing ? $6981e83672fe6c5f$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($6981e83672fe6c5f$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($6981e83672fe6c5f$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $6981e83672fe6c5f$var$isComposing && (fallbackData = $6981e83672fe6c5f$var$getData()) : ($6981e83672fe6c5f$var$root = nativeEventTarget, $6981e83672fe6c5f$var$startText = "value" in $6981e83672fe6c5f$var$root ? $6981e83672fe6c5f$var$root.value : $6981e83672fe6c5f$var$root.textContent, $6981e83672fe6c5f$var$isComposing = !0)), handleEventFunc = $6981e83672fe6c5f$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $6981e83672fe6c5f$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $6981e83672fe6c5f$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $6981e83672fe6c5f$var$canUseTextInputEvent ? $6981e83672fe6c5f$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $6981e83672fe6c5f$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $6981e83672fe6c5f$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $6981e83672fe6c5f$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $6981e83672fe6c5f$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $6981e83672fe6c5f$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $6981e83672fe6c5f$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $6981e83672fe6c5f$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $6981e83672fe6c5f$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($6981e83672fe6c5f$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $6981e83672fe6c5f$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($6981e83672fe6c5f$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $6981e83672fe6c5f$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $6981e83672fe6c5f$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $6981e83672fe6c5f$var$getListener(target, registrationName), null != stateNode && listeners.unshift($6981e83672fe6c5f$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $6981e83672fe6c5f$var$getListener(target, registrationName), null != stateNode && listeners.push($6981e83672fe6c5f$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $6981e83672fe6c5f$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $6981e83672fe6c5f$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $6981e83672fe6c5f$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($6981e83672fe6c5f$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($6981e83672fe6c5f$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $6981e83672fe6c5f$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $6981e83672fe6c5f$var$normalizeMarkupForTextOrAttribute(clientText);
    return $6981e83672fe6c5f$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $6981e83672fe6c5f$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $6981e83672fe6c5f$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $6981e83672fe6c5f$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $6981e83672fe6c5f$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $6981e83672fe6c5f$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $6981e83672fe6c5f$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $6981e83672fe6c5f$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $6981e83672fe6c5f$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $6981e83672fe6c5f$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $6981e83672fe6c5f$var$setProp(domElement, tag, "name", props.name, props, null), $6981e83672fe6c5f$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $6981e83672fe6c5f$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $6981e83672fe6c5f$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($6981e83672fe6c5f$var$setProp(domElement, tag, "encType", props.encType, props, null), $6981e83672fe6c5f$var$setProp(domElement, tag, "method", props.method, props, null), $6981e83672fe6c5f$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $6981e83672fe6c5f$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $6981e83672fe6c5f$var$noop$1);
            break;
        case "onScroll":
            null != value && $6981e83672fe6c5f$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $6981e83672fe6c5f$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $6981e83672fe6c5f$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("toggle", domElement);
            $6981e83672fe6c5f$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $6981e83672fe6c5f$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $6981e83672fe6c5f$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $6981e83672fe6c5f$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $6981e83672fe6c5f$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $6981e83672fe6c5f$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $6981e83672fe6c5f$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $6981e83672fe6c5f$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $6981e83672fe6c5f$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $6981e83672fe6c5f$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $6981e83672fe6c5f$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $6981e83672fe6c5f$var$aliases.get(key) || key, $6981e83672fe6c5f$var$setValueForAttribute(domElement, key, value);
    }
}
function $6981e83672fe6c5f$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $6981e83672fe6c5f$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $6981e83672fe6c5f$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $6981e83672fe6c5f$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $6981e83672fe6c5f$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $6981e83672fe6c5f$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $6981e83672fe6c5f$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$6981e83672fe6c5f$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$6981e83672fe6c5f$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $6981e83672fe6c5f$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $6981e83672fe6c5f$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("error", domElement);
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(137, tag));
                    default:
                        $6981e83672fe6c5f$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $6981e83672fe6c5f$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $6981e83672fe6c5f$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $6981e83672fe6c5f$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $6981e83672fe6c5f$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $6981e83672fe6c5f$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $6981e83672fe6c5f$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $6981e83672fe6c5f$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(91));
                    break;
                default:
                    $6981e83672fe6c5f$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $6981e83672fe6c5f$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $6981e83672fe6c5f$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("toggle", domElement);
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("cancel", domElement);
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $6981e83672fe6c5f$var$mediaEventTypes.length; hasSrc++)$6981e83672fe6c5f$var$listenToNonDelegatedEvent($6981e83672fe6c5f$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("error", domElement);
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $6981e83672fe6c5f$var$listenToNonDelegatedEvent("error", domElement), $6981e83672fe6c5f$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(137, tag));
                default:
                    $6981e83672fe6c5f$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($6981e83672fe6c5f$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $6981e83672fe6c5f$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $6981e83672fe6c5f$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $6981e83672fe6c5f$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $6981e83672fe6c5f$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $6981e83672fe6c5f$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $6981e83672fe6c5f$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $6981e83672fe6c5f$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $6981e83672fe6c5f$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $6981e83672fe6c5f$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $6981e83672fe6c5f$var$updateOptions(domElement, !!lastProps, tag, !0) : $6981e83672fe6c5f$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $6981e83672fe6c5f$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $6981e83672fe6c5f$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $6981e83672fe6c5f$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $6981e83672fe6c5f$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $6981e83672fe6c5f$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $6981e83672fe6c5f$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $6981e83672fe6c5f$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($6981e83672fe6c5f$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $6981e83672fe6c5f$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $6981e83672fe6c5f$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $6981e83672fe6c5f$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $6981e83672fe6c5f$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $6981e83672fe6c5f$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $6981e83672fe6c5f$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $6981e83672fe6c5f$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $6981e83672fe6c5f$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $6981e83672fe6c5f$var$eventsEnabled = null, $6981e83672fe6c5f$var$selectionInformation = null;
function $6981e83672fe6c5f$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $6981e83672fe6c5f$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $6981e83672fe6c5f$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $6981e83672fe6c5f$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $6981e83672fe6c5f$var$currentPopstateTransitionEvent = null;
function $6981e83672fe6c5f$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $6981e83672fe6c5f$var$currentPopstateTransitionEvent) return !1;
        $6981e83672fe6c5f$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $6981e83672fe6c5f$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $6981e83672fe6c5f$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $6981e83672fe6c5f$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $6981e83672fe6c5f$var$localPromise = "function" === typeof Promise ? Promise : void 0, $6981e83672fe6c5f$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $6981e83672fe6c5f$var$localPromise ? function(callback) {
    return $6981e83672fe6c5f$var$localPromise.resolve(null).then(callback).catch($6981e83672fe6c5f$var$handleErrorInNextTick);
} : $6981e83672fe6c5f$var$scheduleTimeout;
function $6981e83672fe6c5f$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $6981e83672fe6c5f$var$isSingletonScope(type) {
    return "head" === type;
}
function $6981e83672fe6c5f$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $6981e83672fe6c5f$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $6981e83672fe6c5f$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $6981e83672fe6c5f$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$6981e83672fe6c5f$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $6981e83672fe6c5f$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $6981e83672fe6c5f$var$retryIfBlockedOn(hydrationInstance);
}
function $6981e83672fe6c5f$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $6981e83672fe6c5f$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $6981e83672fe6c5f$var$clearContainerSparingly(node);
                $6981e83672fe6c5f$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $6981e83672fe6c5f$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$6981e83672fe6c5f$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $6981e83672fe6c5f$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $6981e83672fe6c5f$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $6981e83672fe6c5f$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $6981e83672fe6c5f$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $6981e83672fe6c5f$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $6981e83672fe6c5f$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $6981e83672fe6c5f$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $6981e83672fe6c5f$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $6981e83672fe6c5f$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $6981e83672fe6c5f$var$previousHydratableOnEnteringScopedSingleton = null;
function $6981e83672fe6c5f$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $6981e83672fe6c5f$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $6981e83672fe6c5f$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $6981e83672fe6c5f$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $6981e83672fe6c5f$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(451));
    }
}
function $6981e83672fe6c5f$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $6981e83672fe6c5f$var$detachDeletedInstance(instance);
}
var $6981e83672fe6c5f$var$preloadPropsMap = new Map(), $6981e83672fe6c5f$var$preconnectsSet = new Set();
function $6981e83672fe6c5f$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $6981e83672fe6c5f$var$previousDispatcher = $6981e83672fe6c5f$var$ReactDOMSharedInternals.d;
$6981e83672fe6c5f$var$ReactDOMSharedInternals.d = {
    f: $6981e83672fe6c5f$var$flushSyncWork,
    r: $6981e83672fe6c5f$var$requestFormReset,
    D: $6981e83672fe6c5f$var$prefetchDNS,
    C: $6981e83672fe6c5f$var$preconnect,
    L: $6981e83672fe6c5f$var$preload,
    m: $6981e83672fe6c5f$var$preloadModule,
    X: $6981e83672fe6c5f$var$preinitScript,
    S: $6981e83672fe6c5f$var$preinitStyle,
    M: $6981e83672fe6c5f$var$preinitModuleScript
};
function $6981e83672fe6c5f$var$flushSyncWork() {
    var previousWasRendering = $6981e83672fe6c5f$var$previousDispatcher.f(), wasRendering = $6981e83672fe6c5f$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $6981e83672fe6c5f$var$requestFormReset(form) {
    var formInst = $6981e83672fe6c5f$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $6981e83672fe6c5f$var$requestFormReset$1(formInst) : $6981e83672fe6c5f$var$previousDispatcher.r(form);
}
var $6981e83672fe6c5f$var$globalDocument = "undefined" === typeof document ? null : document;
function $6981e83672fe6c5f$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $6981e83672fe6c5f$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $6981e83672fe6c5f$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $6981e83672fe6c5f$var$preconnectsSet.has(limitedEscapedHref) || ($6981e83672fe6c5f$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $6981e83672fe6c5f$var$setInitialProperties(href, "link", rel), $6981e83672fe6c5f$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $6981e83672fe6c5f$var$prefetchDNS(href) {
    $6981e83672fe6c5f$var$previousDispatcher.D(href);
    $6981e83672fe6c5f$var$preconnectAs("dns-prefetch", href, null);
}
function $6981e83672fe6c5f$var$preconnect(href, crossOrigin) {
    $6981e83672fe6c5f$var$previousDispatcher.C(href, crossOrigin);
    $6981e83672fe6c5f$var$preconnectAs("preconnect", href, crossOrigin);
}
function $6981e83672fe6c5f$var$preload(href, as, options) {
    $6981e83672fe6c5f$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $6981e83672fe6c5f$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $6981e83672fe6c5f$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $6981e83672fe6c5f$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $6981e83672fe6c5f$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $6981e83672fe6c5f$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $6981e83672fe6c5f$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $6981e83672fe6c5f$var$getStyleKey(href);
                break;
            case "script":
                key = $6981e83672fe6c5f$var$getScriptKey(href);
        }
        $6981e83672fe6c5f$var$preloadPropsMap.has(key) || (href = $6981e83672fe6c5f$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $6981e83672fe6c5f$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($6981e83672fe6c5f$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($6981e83672fe6c5f$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $6981e83672fe6c5f$var$setInitialProperties(as, "link", href), $6981e83672fe6c5f$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $6981e83672fe6c5f$var$preloadModule(href, options) {
    $6981e83672fe6c5f$var$previousDispatcher.m(href, options);
    var ownerDocument = $6981e83672fe6c5f$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $6981e83672fe6c5f$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $6981e83672fe6c5f$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $6981e83672fe6c5f$var$getScriptKey(href);
        }
        if (!$6981e83672fe6c5f$var$preloadPropsMap.has(key) && (href = $6981e83672fe6c5f$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $6981e83672fe6c5f$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($6981e83672fe6c5f$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $6981e83672fe6c5f$var$setInitialProperties(as, "link", href);
            $6981e83672fe6c5f$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $6981e83672fe6c5f$var$preinitStyle(href, precedence, options) {
    $6981e83672fe6c5f$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $6981e83672fe6c5f$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $6981e83672fe6c5f$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $6981e83672fe6c5f$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($6981e83672fe6c5f$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $6981e83672fe6c5f$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $6981e83672fe6c5f$var$preloadPropsMap.get(key)) && $6981e83672fe6c5f$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $6981e83672fe6c5f$var$markNodeAsHoistable(link);
                $6981e83672fe6c5f$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $6981e83672fe6c5f$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $6981e83672fe6c5f$var$preinitScript(src, options) {
    $6981e83672fe6c5f$var$previousDispatcher.X(src, options);
    var ownerDocument = $6981e83672fe6c5f$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $6981e83672fe6c5f$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $6981e83672fe6c5f$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($6981e83672fe6c5f$var$getScriptSelectorFromKey(key)), resource || (src = $6981e83672fe6c5f$var$assign({
            src: src,
            async: !0
        }, options), (options = $6981e83672fe6c5f$var$preloadPropsMap.get(key)) && $6981e83672fe6c5f$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $6981e83672fe6c5f$var$markNodeAsHoistable(resource), $6981e83672fe6c5f$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $6981e83672fe6c5f$var$preinitModuleScript(src, options) {
    $6981e83672fe6c5f$var$previousDispatcher.M(src, options);
    var ownerDocument = $6981e83672fe6c5f$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $6981e83672fe6c5f$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $6981e83672fe6c5f$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($6981e83672fe6c5f$var$getScriptSelectorFromKey(key)), resource || (src = $6981e83672fe6c5f$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $6981e83672fe6c5f$var$preloadPropsMap.get(key)) && $6981e83672fe6c5f$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $6981e83672fe6c5f$var$markNodeAsHoistable(resource), $6981e83672fe6c5f$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $6981e83672fe6c5f$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $6981e83672fe6c5f$var$rootInstanceStackCursor.current) ? $6981e83672fe6c5f$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $6981e83672fe6c5f$var$getStyleKey(pendingProps.href), pendingProps = $6981e83672fe6c5f$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $6981e83672fe6c5f$var$getStyleKey(pendingProps.href);
                var styles$243 = $6981e83672fe6c5f$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($6981e83672fe6c5f$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $6981e83672fe6c5f$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $6981e83672fe6c5f$var$preloadPropsMap.set(type, pendingProps), styles$243 || $6981e83672fe6c5f$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $6981e83672fe6c5f$var$getScriptKey(pendingProps), pendingProps = $6981e83672fe6c5f$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(444, type));
    }
}
function $6981e83672fe6c5f$var$getStyleKey(href) {
    return 'href="' + $6981e83672fe6c5f$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $6981e83672fe6c5f$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $6981e83672fe6c5f$var$stylesheetPropsFromRawProps(rawProps) {
    return $6981e83672fe6c5f$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $6981e83672fe6c5f$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $6981e83672fe6c5f$var$setInitialProperties(key, "link", preloadProps), $6981e83672fe6c5f$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $6981e83672fe6c5f$var$getScriptKey(src) {
    return '[src="' + $6981e83672fe6c5f$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $6981e83672fe6c5f$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $6981e83672fe6c5f$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $6981e83672fe6c5f$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $6981e83672fe6c5f$var$markNodeAsHoistable(instance), instance;
            var styleProps = $6981e83672fe6c5f$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $6981e83672fe6c5f$var$markNodeAsHoistable(instance);
            $6981e83672fe6c5f$var$setInitialProperties(instance, "style", styleProps);
            $6981e83672fe6c5f$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $6981e83672fe6c5f$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($6981e83672fe6c5f$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $6981e83672fe6c5f$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $6981e83672fe6c5f$var$stylesheetPropsFromRawProps(props);
            (styleProps = $6981e83672fe6c5f$var$preloadPropsMap.get(styleProps)) && $6981e83672fe6c5f$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $6981e83672fe6c5f$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $6981e83672fe6c5f$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $6981e83672fe6c5f$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $6981e83672fe6c5f$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($6981e83672fe6c5f$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $6981e83672fe6c5f$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $6981e83672fe6c5f$var$preloadPropsMap.get(instance$249)) instance = $6981e83672fe6c5f$var$assign({}, props), $6981e83672fe6c5f$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $6981e83672fe6c5f$var$markNodeAsHoistable(styleProps);
            $6981e83672fe6c5f$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $6981e83672fe6c5f$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $6981e83672fe6c5f$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $6981e83672fe6c5f$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $6981e83672fe6c5f$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $6981e83672fe6c5f$var$tagCaches = null;
function $6981e83672fe6c5f$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $6981e83672fe6c5f$var$tagCaches) {
        var cache = new Map();
        var caches = $6981e83672fe6c5f$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $6981e83672fe6c5f$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$6981e83672fe6c5f$var$internalHoistableMarker] || node[$6981e83672fe6c5f$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $6981e83672fe6c5f$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $6981e83672fe6c5f$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $6981e83672fe6c5f$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $6981e83672fe6c5f$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $6981e83672fe6c5f$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($6981e83672fe6c5f$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $6981e83672fe6c5f$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $6981e83672fe6c5f$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $6981e83672fe6c5f$var$stylesheetPropsFromRawProps(props);
            (key = $6981e83672fe6c5f$var$preloadPropsMap.get(key)) && $6981e83672fe6c5f$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $6981e83672fe6c5f$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $6981e83672fe6c5f$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $6981e83672fe6c5f$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $6981e83672fe6c5f$var$estimatedBytesWithinLimit = 0;
function $6981e83672fe6c5f$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $6981e83672fe6c5f$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $6981e83672fe6c5f$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $6981e83672fe6c5f$var$estimatedBytesWithinLimit && ($6981e83672fe6c5f$var$estimatedBytesWithinLimit = 62500 * $6981e83672fe6c5f$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $6981e83672fe6c5f$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $6981e83672fe6c5f$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $6981e83672fe6c5f$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $6981e83672fe6c5f$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $6981e83672fe6c5f$var$precedencesByRoot = null;
function $6981e83672fe6c5f$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $6981e83672fe6c5f$var$precedencesByRoot = new Map(), resources.forEach($6981e83672fe6c5f$var$insertStylesheetIntoRoot, state), $6981e83672fe6c5f$var$precedencesByRoot = null, $6981e83672fe6c5f$var$onUnsuspend.call(state));
}
function $6981e83672fe6c5f$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $6981e83672fe6c5f$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $6981e83672fe6c5f$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $6981e83672fe6c5f$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $6981e83672fe6c5f$var$HostTransitionContext = {
    $$typeof: $6981e83672fe6c5f$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $6981e83672fe6c5f$var$sharedNotPendingObject,
    _currentValue2: $6981e83672fe6c5f$var$sharedNotPendingObject,
    _threadCount: 0
};
function $6981e83672fe6c5f$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $6981e83672fe6c5f$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $6981e83672fe6c5f$var$createLaneMap(0);
    this.hiddenUpdates = $6981e83672fe6c5f$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $6981e83672fe6c5f$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $6981e83672fe6c5f$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $6981e83672fe6c5f$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $6981e83672fe6c5f$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $6981e83672fe6c5f$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $6981e83672fe6c5f$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $6981e83672fe6c5f$var$emptyContextObject;
    parentComponent = $6981e83672fe6c5f$var$emptyContextObject;
    return parentComponent;
}
function $6981e83672fe6c5f$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $6981e83672fe6c5f$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $6981e83672fe6c5f$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $6981e83672fe6c5f$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($6981e83672fe6c5f$var$scheduleUpdateOnFiber(element, rootFiber, lane), $6981e83672fe6c5f$var$entangleTransitions(element, rootFiber, lane));
}
function $6981e83672fe6c5f$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $6981e83672fe6c5f$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $6981e83672fe6c5f$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $6981e83672fe6c5f$var$markRetryLaneImpl(fiber, retryLane);
}
function $6981e83672fe6c5f$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $6981e83672fe6c5f$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $6981e83672fe6c5f$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $6981e83672fe6c5f$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $6981e83672fe6c5f$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $6981e83672fe6c5f$var$requestUpdateLane();
        lane = $6981e83672fe6c5f$var$getBumpedLaneForHydrationByLane(lane);
        var root = $6981e83672fe6c5f$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $6981e83672fe6c5f$var$scheduleUpdateOnFiber(root, fiber, lane);
        $6981e83672fe6c5f$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $6981e83672fe6c5f$var$_enabled = !0;
function $6981e83672fe6c5f$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $6981e83672fe6c5f$var$ReactSharedInternals.T;
    $6981e83672fe6c5f$var$ReactSharedInternals.T = null;
    var previousPriority = $6981e83672fe6c5f$var$ReactDOMSharedInternals.p;
    try {
        $6981e83672fe6c5f$var$ReactDOMSharedInternals.p = 2, $6981e83672fe6c5f$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $6981e83672fe6c5f$var$ReactDOMSharedInternals.p = previousPriority, $6981e83672fe6c5f$var$ReactSharedInternals.T = prevTransition;
    }
}
function $6981e83672fe6c5f$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $6981e83672fe6c5f$var$ReactSharedInternals.T;
    $6981e83672fe6c5f$var$ReactSharedInternals.T = null;
    var previousPriority = $6981e83672fe6c5f$var$ReactDOMSharedInternals.p;
    try {
        $6981e83672fe6c5f$var$ReactDOMSharedInternals.p = 8, $6981e83672fe6c5f$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $6981e83672fe6c5f$var$ReactDOMSharedInternals.p = previousPriority, $6981e83672fe6c5f$var$ReactSharedInternals.T = prevTransition;
    }
}
function $6981e83672fe6c5f$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($6981e83672fe6c5f$var$_enabled) {
        var blockedOn = $6981e83672fe6c5f$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $6981e83672fe6c5f$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $6981e83672fe6c5f$var$return_targetInst, targetContainer), $6981e83672fe6c5f$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($6981e83672fe6c5f$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($6981e83672fe6c5f$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $6981e83672fe6c5f$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $6981e83672fe6c5f$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $6981e83672fe6c5f$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $6981e83672fe6c5f$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $6981e83672fe6c5f$var$ensureRootIsScheduled(fiber);
                                0 === ($6981e83672fe6c5f$var$executionContext & 6) && ($6981e83672fe6c5f$var$workInProgressRootRenderTargetTime = $6981e83672fe6c5f$var$now() + 500, $6981e83672fe6c5f$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $6981e83672fe6c5f$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $6981e83672fe6c5f$var$scheduleUpdateOnFiber(root, fiber, 2), $6981e83672fe6c5f$var$flushSyncWork$1(), $6981e83672fe6c5f$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $6981e83672fe6c5f$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $6981e83672fe6c5f$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $6981e83672fe6c5f$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $6981e83672fe6c5f$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $6981e83672fe6c5f$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $6981e83672fe6c5f$var$getEventTarget(nativeEvent);
    return $6981e83672fe6c5f$var$findInstanceBlockingTarget(nativeEvent);
}
var $6981e83672fe6c5f$var$return_targetInst = null;
function $6981e83672fe6c5f$var$findInstanceBlockingTarget(targetNode) {
    $6981e83672fe6c5f$var$return_targetInst = null;
    targetNode = $6981e83672fe6c5f$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $6981e83672fe6c5f$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $6981e83672fe6c5f$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $6981e83672fe6c5f$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $6981e83672fe6c5f$var$return_targetInst = targetNode;
    return null;
}
function $6981e83672fe6c5f$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($6981e83672fe6c5f$var$getCurrentPriorityLevel()){
                case $6981e83672fe6c5f$var$ImmediatePriority:
                    return 2;
                case $6981e83672fe6c5f$var$UserBlockingPriority:
                    return 8;
                case $6981e83672fe6c5f$var$NormalPriority$1:
                case $6981e83672fe6c5f$var$LowPriority:
                    return 32;
                case $6981e83672fe6c5f$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $6981e83672fe6c5f$var$hasScheduledReplayAttempt = !1, $6981e83672fe6c5f$var$queuedFocus = null, $6981e83672fe6c5f$var$queuedDrag = null, $6981e83672fe6c5f$var$queuedMouse = null, $6981e83672fe6c5f$var$queuedPointers = new Map(), $6981e83672fe6c5f$var$queuedPointerCaptures = new Map(), $6981e83672fe6c5f$var$queuedExplicitHydrationTargets = [], $6981e83672fe6c5f$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $6981e83672fe6c5f$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $6981e83672fe6c5f$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $6981e83672fe6c5f$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $6981e83672fe6c5f$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $6981e83672fe6c5f$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $6981e83672fe6c5f$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $6981e83672fe6c5f$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $6981e83672fe6c5f$var$getInstanceFromNode(blockedOn), null !== blockedOn && $6981e83672fe6c5f$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $6981e83672fe6c5f$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $6981e83672fe6c5f$var$queuedFocus = $6981e83672fe6c5f$var$accumulateOrCreateContinuousQueuedReplayableEvent($6981e83672fe6c5f$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $6981e83672fe6c5f$var$queuedDrag = $6981e83672fe6c5f$var$accumulateOrCreateContinuousQueuedReplayableEvent($6981e83672fe6c5f$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $6981e83672fe6c5f$var$queuedMouse = $6981e83672fe6c5f$var$accumulateOrCreateContinuousQueuedReplayableEvent($6981e83672fe6c5f$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $6981e83672fe6c5f$var$queuedPointers.set(pointerId, $6981e83672fe6c5f$var$accumulateOrCreateContinuousQueuedReplayableEvent($6981e83672fe6c5f$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $6981e83672fe6c5f$var$queuedPointerCaptures.set(pointerId, $6981e83672fe6c5f$var$accumulateOrCreateContinuousQueuedReplayableEvent($6981e83672fe6c5f$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $6981e83672fe6c5f$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $6981e83672fe6c5f$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $6981e83672fe6c5f$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $6981e83672fe6c5f$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $6981e83672fe6c5f$var$runWithPriority(queuedTarget.priority, function() {
                        $6981e83672fe6c5f$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $6981e83672fe6c5f$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $6981e83672fe6c5f$var$runWithPriority(queuedTarget.priority, function() {
                        $6981e83672fe6c5f$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $6981e83672fe6c5f$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $6981e83672fe6c5f$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $6981e83672fe6c5f$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $6981e83672fe6c5f$var$currentReplayingEvent = null;
        } else return targetContainers = $6981e83672fe6c5f$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $6981e83672fe6c5f$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $6981e83672fe6c5f$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $6981e83672fe6c5f$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $6981e83672fe6c5f$var$replayUnblockedEvents() {
    $6981e83672fe6c5f$var$hasScheduledReplayAttempt = !1;
    null !== $6981e83672fe6c5f$var$queuedFocus && $6981e83672fe6c5f$var$attemptReplayContinuousQueuedEvent($6981e83672fe6c5f$var$queuedFocus) && ($6981e83672fe6c5f$var$queuedFocus = null);
    null !== $6981e83672fe6c5f$var$queuedDrag && $6981e83672fe6c5f$var$attemptReplayContinuousQueuedEvent($6981e83672fe6c5f$var$queuedDrag) && ($6981e83672fe6c5f$var$queuedDrag = null);
    null !== $6981e83672fe6c5f$var$queuedMouse && $6981e83672fe6c5f$var$attemptReplayContinuousQueuedEvent($6981e83672fe6c5f$var$queuedMouse) && ($6981e83672fe6c5f$var$queuedMouse = null);
    $6981e83672fe6c5f$var$queuedPointers.forEach($6981e83672fe6c5f$var$attemptReplayContinuousQueuedEventInMap);
    $6981e83672fe6c5f$var$queuedPointerCaptures.forEach($6981e83672fe6c5f$var$attemptReplayContinuousQueuedEventInMap);
}
function $6981e83672fe6c5f$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $6981e83672fe6c5f$var$hasScheduledReplayAttempt || ($6981e83672fe6c5f$var$hasScheduledReplayAttempt = !0, $eHVWl.unstable_scheduleCallback($eHVWl.unstable_NormalPriority, $6981e83672fe6c5f$var$replayUnblockedEvents)));
}
var $6981e83672fe6c5f$var$lastScheduledReplayQueue = null;
function $6981e83672fe6c5f$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $6981e83672fe6c5f$var$lastScheduledReplayQueue !== formReplayingQueue && ($6981e83672fe6c5f$var$lastScheduledReplayQueue = formReplayingQueue, $eHVWl.unstable_scheduleCallback($eHVWl.unstable_NormalPriority, function() {
        $6981e83672fe6c5f$var$lastScheduledReplayQueue === formReplayingQueue && ($6981e83672fe6c5f$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $6981e83672fe6c5f$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $6981e83672fe6c5f$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $6981e83672fe6c5f$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $6981e83672fe6c5f$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $6981e83672fe6c5f$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $6981e83672fe6c5f$var$queuedFocus && $6981e83672fe6c5f$var$scheduleCallbackIfUnblocked($6981e83672fe6c5f$var$queuedFocus, unblocked);
    null !== $6981e83672fe6c5f$var$queuedDrag && $6981e83672fe6c5f$var$scheduleCallbackIfUnblocked($6981e83672fe6c5f$var$queuedDrag, unblocked);
    null !== $6981e83672fe6c5f$var$queuedMouse && $6981e83672fe6c5f$var$scheduleCallbackIfUnblocked($6981e83672fe6c5f$var$queuedMouse, unblocked);
    $6981e83672fe6c5f$var$queuedPointers.forEach(unblock);
    $6981e83672fe6c5f$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $6981e83672fe6c5f$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $6981e83672fe6c5f$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $6981e83672fe6c5f$var$queuedExplicitHydrationTargets.length && (i = $6981e83672fe6c5f$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$6981e83672fe6c5f$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $6981e83672fe6c5f$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$6981e83672fe6c5f$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $6981e83672fe6c5f$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$6981e83672fe6c5f$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $6981e83672fe6c5f$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $6981e83672fe6c5f$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $6981e83672fe6c5f$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $6981e83672fe6c5f$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$6981e83672fe6c5f$var$ReactDOMHydrationRoot.prototype.render = $6981e83672fe6c5f$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(409));
    var current = root.current, lane = $6981e83672fe6c5f$var$requestUpdateLane();
    $6981e83672fe6c5f$var$updateContainerImpl(current, lane, children, root, null, null);
};
$6981e83672fe6c5f$var$ReactDOMHydrationRoot.prototype.unmount = $6981e83672fe6c5f$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $6981e83672fe6c5f$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $6981e83672fe6c5f$var$flushSyncWork$1();
        container[$6981e83672fe6c5f$var$internalContainerInstanceKey] = null;
    }
};
function $6981e83672fe6c5f$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$6981e83672fe6c5f$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $6981e83672fe6c5f$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $6981e83672fe6c5f$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $6981e83672fe6c5f$var$queuedExplicitHydrationTargets[i].priority; i++);
        $6981e83672fe6c5f$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $6981e83672fe6c5f$var$attemptExplicitHydrationTarget(target);
    }
};
var $6981e83672fe6c5f$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $5a48l.version;
if ("19.2.5" !== $6981e83672fe6c5f$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(527, $6981e83672fe6c5f$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.5"));
$6981e83672fe6c5f$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $6981e83672fe6c5f$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $6981e83672fe6c5f$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $6981e83672fe6c5f$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.5",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $6981e83672fe6c5f$var$ReactSharedInternals,
    reconcilerVersion: "19.2.5"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $6981e83672fe6c5f$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$6981e83672fe6c5f$var$hook$jscomp$inline_2348.isDisabled && $6981e83672fe6c5f$var$hook$jscomp$inline_2348.supportsFiber) try {
        $6981e83672fe6c5f$var$rendererID = $6981e83672fe6c5f$var$hook$jscomp$inline_2348.inject($6981e83672fe6c5f$var$internals$jscomp$inline_2347), $6981e83672fe6c5f$var$injectedHook = $6981e83672fe6c5f$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$6981e83672fe6c5f$export$882461b6382ed46c = function(container, options) {
    if (!$6981e83672fe6c5f$var$isValidContainer(container)) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $6981e83672fe6c5f$var$defaultOnUncaughtError, onCaughtError = $6981e83672fe6c5f$var$defaultOnCaughtError, onRecoverableError = $6981e83672fe6c5f$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $6981e83672fe6c5f$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $6981e83672fe6c5f$var$defaultOnDefaultTransitionIndicator);
    container[$6981e83672fe6c5f$var$internalContainerInstanceKey] = options.current;
    $6981e83672fe6c5f$var$listenToAllSupportedEvents(container);
    return new $6981e83672fe6c5f$var$ReactDOMRoot(options);
};
$6981e83672fe6c5f$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$6981e83672fe6c5f$var$isValidContainer(container)) throw Error($6981e83672fe6c5f$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $6981e83672fe6c5f$var$defaultOnUncaughtError, onCaughtError = $6981e83672fe6c5f$var$defaultOnCaughtError, onRecoverableError = $6981e83672fe6c5f$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $6981e83672fe6c5f$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $6981e83672fe6c5f$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $6981e83672fe6c5f$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $6981e83672fe6c5f$var$requestUpdateLane();
    isStrictMode = $6981e83672fe6c5f$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $6981e83672fe6c5f$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $6981e83672fe6c5f$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $6981e83672fe6c5f$var$markRootUpdated$1(initialChildren, options);
    $6981e83672fe6c5f$var$ensureRootIsScheduled(initialChildren);
    container[$6981e83672fe6c5f$var$internalContainerInstanceKey] = initialChildren.current;
    $6981e83672fe6c5f$var$listenToAllSupportedEvents(container);
    return new $6981e83672fe6c5f$var$ReactDOMHydrationRoot(initialChildren);
};
$6981e83672fe6c5f$export$83d89fbfd8236492 = "19.2.5";

});
parcelRegister("eHVWl", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gbQER"));

});
parcelRegister("gbQER", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bc968532c5df670b$export$c4744153514ff05d, (v) => $bc968532c5df670b$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bc968532c5df670b$export$3e506c1ccc9cc1a7, (v) => $bc968532c5df670b$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bc968532c5df670b$export$e26fe2ed2fa76875, (v) => $bc968532c5df670b$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bc968532c5df670b$export$502329bbf4b505b1, (v) => $bc968532c5df670b$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bc968532c5df670b$export$6e3807111c4874c4, (v) => $bc968532c5df670b$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bc968532c5df670b$export$c27134553091fb3a, (v) => $bc968532c5df670b$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bc968532c5df670b$export$33ee1acdc04fd2a2, (v) => $bc968532c5df670b$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bc968532c5df670b$export$b00a404bbd5edef2, (v) => $bc968532c5df670b$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bc968532c5df670b$export$d66a1c1c77bd778b, (v) => $bc968532c5df670b$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bc968532c5df670b$export$d3dfb8e4810cb555, (v) => $bc968532c5df670b$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $bc968532c5df670b$export$72fdf0e06517287b, (v) => $bc968532c5df670b$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bc968532c5df670b$export$816d2913ae6b83b1, (v) => $bc968532c5df670b$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bc968532c5df670b$export$61bcfe829111a1d0, (v) => $bc968532c5df670b$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bc968532c5df670b$export$7ee8c9beb337bc3f, (v) => $bc968532c5df670b$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bc968532c5df670b$export$b5836b71941fa3ed, (v) => $bc968532c5df670b$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bc968532c5df670b$export$cf845f2c119da08a, (v) => $bc968532c5df670b$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bc968532c5df670b$export$c4744153514ff05d;
var $bc968532c5df670b$export$3e506c1ccc9cc1a7;
var $bc968532c5df670b$export$e26fe2ed2fa76875;
var $bc968532c5df670b$export$502329bbf4b505b1;
var $bc968532c5df670b$export$6e3807111c4874c4;
var $bc968532c5df670b$export$c27134553091fb3a;
var $bc968532c5df670b$export$33ee1acdc04fd2a2;
var $bc968532c5df670b$export$b00a404bbd5edef2;
var $bc968532c5df670b$export$d66a1c1c77bd778b;
var $bc968532c5df670b$export$d3dfb8e4810cb555;
var $bc968532c5df670b$export$72fdf0e06517287b;
var $bc968532c5df670b$export$816d2913ae6b83b1;
var $bc968532c5df670b$export$61bcfe829111a1d0;
var $bc968532c5df670b$export$7ee8c9beb337bc3f;
var $bc968532c5df670b$export$b5836b71941fa3ed;
var $bc968532c5df670b$export$cf845f2c119da08a;
"use strict";
function $bc968532c5df670b$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $bc968532c5df670b$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $bc968532c5df670b$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $bc968532c5df670b$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $bc968532c5df670b$var$compare(left, last)) rightIndex < length && 0 > $bc968532c5df670b$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $bc968532c5df670b$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $bc968532c5df670b$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$bc968532c5df670b$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bc968532c5df670b$var$localPerformance = performance;
    $bc968532c5df670b$export$c4744153514ff05d = function() {
        return $bc968532c5df670b$var$localPerformance.now();
    };
} else {
    var $bc968532c5df670b$var$localDate = Date, $bc968532c5df670b$var$initialTime = $bc968532c5df670b$var$localDate.now();
    $bc968532c5df670b$export$c4744153514ff05d = function() {
        return $bc968532c5df670b$var$localDate.now() - $bc968532c5df670b$var$initialTime;
    };
}
var $bc968532c5df670b$var$taskQueue = [], $bc968532c5df670b$var$timerQueue = [], $bc968532c5df670b$var$taskIdCounter = 1, $bc968532c5df670b$var$currentTask = null, $bc968532c5df670b$var$currentPriorityLevel = 3, $bc968532c5df670b$var$isPerformingWork = !1, $bc968532c5df670b$var$isHostCallbackScheduled = !1, $bc968532c5df670b$var$isHostTimeoutScheduled = !1, $bc968532c5df670b$var$needsPaint = !1, $bc968532c5df670b$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $bc968532c5df670b$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $bc968532c5df670b$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $bc968532c5df670b$var$advanceTimers(currentTime) {
    for(var timer = $bc968532c5df670b$var$peek($bc968532c5df670b$var$timerQueue); null !== timer;){
        if (null === timer.callback) $bc968532c5df670b$var$pop($bc968532c5df670b$var$timerQueue);
        else if (timer.startTime <= currentTime) $bc968532c5df670b$var$pop($bc968532c5df670b$var$timerQueue), timer.sortIndex = timer.expirationTime, $bc968532c5df670b$var$push($bc968532c5df670b$var$taskQueue, timer);
        else break;
        timer = $bc968532c5df670b$var$peek($bc968532c5df670b$var$timerQueue);
    }
}
function $bc968532c5df670b$var$handleTimeout(currentTime) {
    $bc968532c5df670b$var$isHostTimeoutScheduled = !1;
    $bc968532c5df670b$var$advanceTimers(currentTime);
    if (!$bc968532c5df670b$var$isHostCallbackScheduled) {
        if (null !== $bc968532c5df670b$var$peek($bc968532c5df670b$var$taskQueue)) $bc968532c5df670b$var$isHostCallbackScheduled = !0, $bc968532c5df670b$var$isMessageLoopRunning || ($bc968532c5df670b$var$isMessageLoopRunning = !0, $bc968532c5df670b$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $bc968532c5df670b$var$peek($bc968532c5df670b$var$timerQueue);
            null !== firstTimer && $bc968532c5df670b$var$requestHostTimeout($bc968532c5df670b$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $bc968532c5df670b$var$isMessageLoopRunning = !1, $bc968532c5df670b$var$taskTimeoutID = -1, $bc968532c5df670b$var$frameInterval = 5, $bc968532c5df670b$var$startTime = -1;
function $bc968532c5df670b$var$shouldYieldToHost() {
    return $bc968532c5df670b$var$needsPaint ? !0 : $bc968532c5df670b$export$c4744153514ff05d() - $bc968532c5df670b$var$startTime < $bc968532c5df670b$var$frameInterval ? !1 : !0;
}
function $bc968532c5df670b$var$performWorkUntilDeadline() {
    $bc968532c5df670b$var$needsPaint = !1;
    if ($bc968532c5df670b$var$isMessageLoopRunning) {
        var currentTime = $bc968532c5df670b$export$c4744153514ff05d();
        $bc968532c5df670b$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $bc968532c5df670b$var$isHostCallbackScheduled = !1;
                $bc968532c5df670b$var$isHostTimeoutScheduled && ($bc968532c5df670b$var$isHostTimeoutScheduled = !1, $bc968532c5df670b$var$localClearTimeout($bc968532c5df670b$var$taskTimeoutID), $bc968532c5df670b$var$taskTimeoutID = -1);
                $bc968532c5df670b$var$isPerformingWork = !0;
                var previousPriorityLevel = $bc968532c5df670b$var$currentPriorityLevel;
                try {
                    b: {
                        $bc968532c5df670b$var$advanceTimers(currentTime);
                        for($bc968532c5df670b$var$currentTask = $bc968532c5df670b$var$peek($bc968532c5df670b$var$taskQueue); null !== $bc968532c5df670b$var$currentTask && !($bc968532c5df670b$var$currentTask.expirationTime > currentTime && $bc968532c5df670b$var$shouldYieldToHost());){
                            var callback = $bc968532c5df670b$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $bc968532c5df670b$var$currentTask.callback = null;
                                $bc968532c5df670b$var$currentPriorityLevel = $bc968532c5df670b$var$currentTask.priorityLevel;
                                var continuationCallback = callback($bc968532c5df670b$var$currentTask.expirationTime <= currentTime);
                                currentTime = $bc968532c5df670b$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $bc968532c5df670b$var$currentTask.callback = continuationCallback;
                                    $bc968532c5df670b$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $bc968532c5df670b$var$currentTask === $bc968532c5df670b$var$peek($bc968532c5df670b$var$taskQueue) && $bc968532c5df670b$var$pop($bc968532c5df670b$var$taskQueue);
                                $bc968532c5df670b$var$advanceTimers(currentTime);
                            } else $bc968532c5df670b$var$pop($bc968532c5df670b$var$taskQueue);
                            $bc968532c5df670b$var$currentTask = $bc968532c5df670b$var$peek($bc968532c5df670b$var$taskQueue);
                        }
                        if (null !== $bc968532c5df670b$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $bc968532c5df670b$var$peek($bc968532c5df670b$var$timerQueue);
                            null !== firstTimer && $bc968532c5df670b$var$requestHostTimeout($bc968532c5df670b$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $bc968532c5df670b$var$currentTask = null, $bc968532c5df670b$var$currentPriorityLevel = previousPriorityLevel, $bc968532c5df670b$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $bc968532c5df670b$var$schedulePerformWorkUntilDeadline() : $bc968532c5df670b$var$isMessageLoopRunning = !1;
        }
    }
}
var $bc968532c5df670b$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $bc968532c5df670b$var$localSetImmediate) $bc968532c5df670b$var$schedulePerformWorkUntilDeadline = function() {
    $bc968532c5df670b$var$localSetImmediate($bc968532c5df670b$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bc968532c5df670b$var$channel = new MessageChannel(), $bc968532c5df670b$var$port = $bc968532c5df670b$var$channel.port2;
    $bc968532c5df670b$var$channel.port1.onmessage = $bc968532c5df670b$var$performWorkUntilDeadline;
    $bc968532c5df670b$var$schedulePerformWorkUntilDeadline = function() {
        $bc968532c5df670b$var$port.postMessage(null);
    };
} else $bc968532c5df670b$var$schedulePerformWorkUntilDeadline = function() {
    $bc968532c5df670b$var$localSetTimeout($bc968532c5df670b$var$performWorkUntilDeadline, 0);
};
function $bc968532c5df670b$var$requestHostTimeout(callback, ms) {
    $bc968532c5df670b$var$taskTimeoutID = $bc968532c5df670b$var$localSetTimeout(function() {
        callback($bc968532c5df670b$export$c4744153514ff05d());
    }, ms);
}
$bc968532c5df670b$export$3e506c1ccc9cc1a7 = 5;
$bc968532c5df670b$export$e26fe2ed2fa76875 = 1;
$bc968532c5df670b$export$502329bbf4b505b1 = 4;
$bc968532c5df670b$export$6e3807111c4874c4 = 3;
$bc968532c5df670b$export$c27134553091fb3a = null;
$bc968532c5df670b$export$33ee1acdc04fd2a2 = 2;
$bc968532c5df670b$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$bc968532c5df670b$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bc968532c5df670b$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$bc968532c5df670b$export$d3dfb8e4810cb555 = function() {
    return $bc968532c5df670b$var$currentPriorityLevel;
};
$bc968532c5df670b$export$72fdf0e06517287b = function(eventHandler) {
    switch($bc968532c5df670b$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $bc968532c5df670b$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $bc968532c5df670b$var$currentPriorityLevel;
    $bc968532c5df670b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $bc968532c5df670b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$bc968532c5df670b$export$816d2913ae6b83b1 = function() {
    $bc968532c5df670b$var$needsPaint = !0;
};
$bc968532c5df670b$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $bc968532c5df670b$var$currentPriorityLevel;
    $bc968532c5df670b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $bc968532c5df670b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$bc968532c5df670b$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $bc968532c5df670b$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $bc968532c5df670b$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $bc968532c5df670b$var$push($bc968532c5df670b$var$timerQueue, priorityLevel), null === $bc968532c5df670b$var$peek($bc968532c5df670b$var$taskQueue) && priorityLevel === $bc968532c5df670b$var$peek($bc968532c5df670b$var$timerQueue) && ($bc968532c5df670b$var$isHostTimeoutScheduled ? ($bc968532c5df670b$var$localClearTimeout($bc968532c5df670b$var$taskTimeoutID), $bc968532c5df670b$var$taskTimeoutID = -1) : $bc968532c5df670b$var$isHostTimeoutScheduled = !0, $bc968532c5df670b$var$requestHostTimeout($bc968532c5df670b$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $bc968532c5df670b$var$push($bc968532c5df670b$var$taskQueue, priorityLevel), $bc968532c5df670b$var$isHostCallbackScheduled || $bc968532c5df670b$var$isPerformingWork || ($bc968532c5df670b$var$isHostCallbackScheduled = !0, $bc968532c5df670b$var$isMessageLoopRunning || ($bc968532c5df670b$var$isMessageLoopRunning = !0, $bc968532c5df670b$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$bc968532c5df670b$export$b5836b71941fa3ed = $bc968532c5df670b$var$shouldYieldToHost;
$bc968532c5df670b$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $bc968532c5df670b$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $bc968532c5df670b$var$currentPriorityLevel;
        $bc968532c5df670b$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $bc968532c5df670b$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("5a48l", function(module, exports) {
'use strict';

module.exports = (parcelRequire("k9SHz"));

});

parcelRegister("7aO71", function(module, exports) {
'use strict';
function $015909a8969229e2$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($015909a8969229e2$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$015909a8969229e2$var$checkDCE();

module.exports = (parcelRequire("9g9tP"));

});
parcelRegister("9g9tP", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $6bdcf63de316039a$export$69ce8ef3fe5cead0, (v) => $6bdcf63de316039a$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $6bdcf63de316039a$export$d39a5bbd09211389, (v) => $6bdcf63de316039a$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $6bdcf63de316039a$export$cd75ccfd720a3cd4, (v) => $6bdcf63de316039a$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $6bdcf63de316039a$export$a0816fa17a9e79be, (v) => $6bdcf63de316039a$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $6bdcf63de316039a$export$7292efcadded39f3, (v) => $6bdcf63de316039a$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $6bdcf63de316039a$export$da407abadb9b8f86, (v) => $6bdcf63de316039a$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $6bdcf63de316039a$export$314cfea32580671c, (v) => $6bdcf63de316039a$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $6bdcf63de316039a$export$513ccb98c53b8039, (v) => $6bdcf63de316039a$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $6bdcf63de316039a$export$dbca993bc2d264a, (v) => $6bdcf63de316039a$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $6bdcf63de316039a$export$4797a8006f0655d0, (v) => $6bdcf63de316039a$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $6bdcf63de316039a$export$c78a37762a8d58e1, (v) => $6bdcf63de316039a$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $6bdcf63de316039a$export$606f11b2eb45ecc6, (v) => $6bdcf63de316039a$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $6bdcf63de316039a$export$f7e8a0bf92324b1e, (v) => $6bdcf63de316039a$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $6bdcf63de316039a$export$83d89fbfd8236492, (v) => $6bdcf63de316039a$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6bdcf63de316039a$export$69ce8ef3fe5cead0;
var $6bdcf63de316039a$export$d39a5bbd09211389;
var $6bdcf63de316039a$export$cd75ccfd720a3cd4;
var $6bdcf63de316039a$export$a0816fa17a9e79be;
var $6bdcf63de316039a$export$7292efcadded39f3;
var $6bdcf63de316039a$export$da407abadb9b8f86;
var $6bdcf63de316039a$export$314cfea32580671c;
var $6bdcf63de316039a$export$513ccb98c53b8039;
var $6bdcf63de316039a$export$dbca993bc2d264a;
var $6bdcf63de316039a$export$4797a8006f0655d0;
var $6bdcf63de316039a$export$c78a37762a8d58e1;
var $6bdcf63de316039a$export$606f11b2eb45ecc6;
var $6bdcf63de316039a$export$f7e8a0bf92324b1e;
var $6bdcf63de316039a$export$83d89fbfd8236492;
"use strict";

var $5a48l = parcelRequire("5a48l");
function $6bdcf63de316039a$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $6bdcf63de316039a$var$noop() {}
var $6bdcf63de316039a$var$Internals = {
    d: {
        f: $6bdcf63de316039a$var$noop,
        r: function() {
            throw Error($6bdcf63de316039a$var$formatProdErrorMessage(522));
        },
        D: $6bdcf63de316039a$var$noop,
        C: $6bdcf63de316039a$var$noop,
        L: $6bdcf63de316039a$var$noop,
        m: $6bdcf63de316039a$var$noop,
        X: $6bdcf63de316039a$var$noop,
        S: $6bdcf63de316039a$var$noop,
        M: $6bdcf63de316039a$var$noop
    },
    p: 0,
    findDOMNode: null
}, $6bdcf63de316039a$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $6bdcf63de316039a$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $6bdcf63de316039a$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $6bdcf63de316039a$var$ReactSharedInternals = $5a48l.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $6bdcf63de316039a$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$6bdcf63de316039a$export$69ce8ef3fe5cead0 = $6bdcf63de316039a$var$Internals;
$6bdcf63de316039a$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($6bdcf63de316039a$var$formatProdErrorMessage(299));
    return $6bdcf63de316039a$var$createPortal$1(children, container, null, key);
};
$6bdcf63de316039a$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $6bdcf63de316039a$var$ReactSharedInternals.T, previousUpdatePriority = $6bdcf63de316039a$var$Internals.p;
    try {
        if ($6bdcf63de316039a$var$ReactSharedInternals.T = null, $6bdcf63de316039a$var$Internals.p = 2, fn) return fn();
    } finally{
        $6bdcf63de316039a$var$ReactSharedInternals.T = previousTransition, $6bdcf63de316039a$var$Internals.p = previousUpdatePriority, $6bdcf63de316039a$var$Internals.d.f();
    }
};
$6bdcf63de316039a$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $6bdcf63de316039a$var$Internals.d.C(href, options));
};
$6bdcf63de316039a$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $6bdcf63de316039a$var$Internals.d.D(href);
};
$6bdcf63de316039a$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $6bdcf63de316039a$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $6bdcf63de316039a$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $6bdcf63de316039a$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$6bdcf63de316039a$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $6bdcf63de316039a$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $6bdcf63de316039a$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $6bdcf63de316039a$var$Internals.d.M(href);
    }
};
$6bdcf63de316039a$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $6bdcf63de316039a$var$getCrossOriginStringAs(as, options.crossOrigin);
        $6bdcf63de316039a$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$6bdcf63de316039a$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $6bdcf63de316039a$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $6bdcf63de316039a$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $6bdcf63de316039a$var$Internals.d.m(href);
    }
};
$6bdcf63de316039a$export$4797a8006f0655d0 = function(form) {
    $6bdcf63de316039a$var$Internals.d.r(form);
};
$6bdcf63de316039a$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$6bdcf63de316039a$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $6bdcf63de316039a$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$6bdcf63de316039a$export$f7e8a0bf92324b1e = function() {
    return $6bdcf63de316039a$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$6bdcf63de316039a$export$83d89fbfd8236492 = "19.2.5";

});



var $e198763f6a656b3c$exports = {};
'use strict';

$e198763f6a656b3c$exports = (parcelRequire("22qj4"));







var $5a48l = parcelRequire("5a48l");
const $a88be774e5dadb59$var$Hero = ()=>{
    const heroRef = (0, $5a48l.useRef)(null);
    (0, $5a48l.useEffect)(()=>{
        const hero = heroRef.current;
        if (!hero) return;
        const colors = [
            '#2B5CE6',
            '#D97757',
            '#8B8B8B'
        ]; // blue, orange, gray from site palette
        let colorIndex = 0;
        let lastRippleTime = 0;
        const handleMouseMove = (e)=>{
            const now = Date.now();
            if (now - lastRippleTime < 80) return; // throttle to ~12 ripples/sec
            lastRippleTime = now;
            const rect = hero.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            const ripple = document.createElement('div');
            ripple.className = 'ripple-effect';
            ripple.style.left = `${x}px`;
            ripple.style.top = `${y}px`;
            ripple.style.backgroundColor = colors[colorIndex % colors.length];
            colorIndex++;
            hero.appendChild(ripple);
            ripple.addEventListener('animationend', ()=>ripple.remove());
        };
        hero.addEventListener('mousemove', handleMouseMove);
        return ()=>{
            hero.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);
    return /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("section", {
        ref: heroRef,
        className: "hero-section animate-fade-in-up",
        children: /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
            className: "hero-content",
            children: [
                /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("h1", {
                    className: "hero-title",
                    children: "KANAKO TAGA"
                }),
                /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
                    className: "hero-roles",
                    children: [
                        /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("span", {
                            className: "hero-role",
                            children: "PRODUCT MANAGER"
                        }),
                        /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("span", {
                            className: "hero-role-divider",
                            children: "\u2022"
                        }),
                        /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("span", {
                            className: "hero-role",
                            children: "FULL-STACK DEVELOPER"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("p", {
                    className: "hero-description",
                    children: "Leveraging 9+ years of IT leadership to build scalable, customer-centric applications, with a long-term business mindset."
                }),
                /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
                    className: "hero-cta animate-scale delay-2",
                    children: [
                        /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("a", {
                            href: "#projects",
                            className: "cta-button primary",
                            children: "View Projects"
                        }),
                        /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("a", {
                            href: "#contact",
                            className: "cta-button secondary",
                            children: "Get In Touch"
                        })
                    ]
                })
            ]
        })
    });
};
var $a88be774e5dadb59$export$2e2bcd8739ae039 = $a88be774e5dadb59$var$Hero;



parcelRequire("5a48l");
const $845516e37b1d38d1$var$About = ()=>{
    return /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("section", {
        className: "about-section",
        id: "about",
        children: [
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
                className: "section-header animate-fade-in-up",
                children: [
                    /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("div", {
                        className: "section-label",
                        children: "BACKGROUND"
                    }),
                    /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("h2", {
                        className: "section-title",
                        children: "ABOUT ME"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
                className: "about-content-wrapper animate-fade-in-up delay-1",
                children: [
                    /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
                        className: "about-text",
                        children: [
                            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("p", {
                                children: "Product Manager and Full-Stack Developer who bridges business strategy with technical execution. With 9 years in the IT industry, I combine a 'Customer-Obsessed' approach with deep technical insight to build products that balance sophisticated User Experience with long-term business scalability. I thrive in cross-functional environments, collaborating with engineering, product, and business development teams to maximize output and deliver high-impact solutions."
                            }),
                            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("h3", {
                                className: "about-experience-header",
                                children: "Experience"
                            }),
                            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("h4", {
                                children: "Senior Account Manager, Amazon Web Services (AWS) Japan G.K. (2018 \u2013 2024)"
                            }),
                            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("p", {
                                className: "about-experience-text",
                                children: "Managed a diverse portfolio from high-growth startups to large enterprise groups. Deep domain expertise in AdTech, E-commerce, and Fintech industries."
                            }),
                            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("h4", {
                                children: "Enterprise Sales (ERP Packages), IT Sector (2015 \u2013 2017)"
                            }),
                            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("p", {
                                className: "about-experience-text",
                                children: "Focused on HR, Accounting, Supply Chain Management (SCM), and E-commerce solutions for enterprise-level clients."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("div", {
                        className: "about-photo",
                        children: /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("div", {
                            className: "profile-photo-frame",
                            children: /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("img", {
                                src: "/img/profile-photo.webp",
                                alt: "Kanako Taga - Full Stack Developer"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $845516e37b1d38d1$export$2e2bcd8739ae039 = $845516e37b1d38d1$var$About;




var $5a48l = parcelRequire("5a48l");
const $60c23ef4e898d115$var$techStackData = {
    languages: {
        title: "Languages",
        skills: [
            "JavaScript",
            "TypeScript",
            "Python",
            "HTML5",
            "CSS3"
        ]
    },
    frontend: {
        title: "Frontend",
        skills: [
            "React",
            "React Native",
            "Angular",
            "Tailwind CSS"
        ]
    },
    backend: {
        title: "Backend",
        skills: [
            "Node.js",
            "Express.js",
            "Hono",
            "Zod",
            "Next.js"
        ]
    },
    database: {
        title: "Database",
        skills: [
            "PostgreSQL",
            "MongoDB",
            "MySQL",
            "Drizzle ORM",
            "Firestore"
        ]
    },
    devops: {
        title: "DevOps & Tools",
        skills: [
            "Git",
            "AWS",
            "GitHub Actions",
            "Jira",
            "AI Tools"
        ]
    },
    Others: {
        title: "Others",
        skills: [
            "Figma",
            "Adobe Photoshop",
            "Adobe Illustrator"
        ]
    }
};
const $60c23ef4e898d115$var$TechStackCard = ({ data: data })=>{
    return /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
        className: "expertise-card animate-fade-in-up",
        children: [
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("h3", {
                className: "expertise-title",
                children: data.title
            }),
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("div", {
                className: "expertise-list",
                children: data.skills.map((skill, index)=>/*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5a48l))).Fragment, {
                        children: [
                            skill,
                            index < data.skills.length - 1 && /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("br", {})
                        ]
                    }, skill))
            })
        ]
    });
};
const $60c23ef4e898d115$var$coreCompetencies = [
    "Customer-First Product Thinking",
    "Product Strategy",
    "Project Management",
    "Agile Methodologies",
    "Cross-Functional Leadership",
    "Stakeholder Management",
    "Data Analysis",
    "User Research",
    "Technical Communication"
];
const $60c23ef4e898d115$var$TechStack = ()=>{
    return /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("section", {
        className: "expertise-section",
        id: "expertise",
        children: [
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
                className: "section-header animate-fade-in-up",
                children: [
                    /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("div", {
                        className: "section-label",
                        children: "WHAT I DO"
                    }),
                    /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("h2", {
                        className: "section-title",
                        children: "EXPERTISE"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
                className: "core-competencies-strip animate-fade-in-up delay-1",
                children: [
                    /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("div", {
                        className: "core-competencies-label",
                        children: "CORE COMPETENCIES"
                    }),
                    /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("div", {
                        className: "core-competencies-pills",
                        children: $60c23ef4e898d115$var$coreCompetencies.map((item)=>/*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("span", {
                                className: "competency-pill",
                                children: item
                            }, item))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("div", {
                className: "technical-skills-label animate-fade-in-up delay-2",
                children: "TECHNICAL SKILLS"
            }),
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("div", {
                className: "expertise-grid",
                children: Object.entries($60c23ef4e898d115$var$techStackData).map(([category, data])=>/*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)($60c23ef4e898d115$var$TechStackCard, {
                        category: category,
                        data: data
                    }, category))
            })
        ]
    });
};
var $60c23ef4e898d115$export$2e2bcd8739ae039 = $60c23ef4e898d115$var$TechStack;




var $5a48l = parcelRequire("5a48l");
const $184a9ed2e74adf5a$var$projectsData = [
    {
        id: 1,
        title: "Reano",
        subtitle: "AI-Powered Home Design & AR Room Visualization App",
        period: "Jan 2026 - Apr 2026",
        icon: "\uD83C\uDFE0",
        image: "/img/reano-ad.webp",
        detailPage: "projects/reano.html",
        description: "A cross-platform mobile app (iOS & Android) that bridges the gap between interior design inspiration and real purchasing decisions. Users build AI-powered Style Boards from their inspiration photos, visualize furniture in their actual rooms via AR, and virtually repaint walls \u2014 turning scattered ideas into confident, spatial choices.",
        role: "Product Manager / Co-Project Manager / Full-Stack Developer",
        contributions: [
            "Shaped the core product vision from user research and competitive analysis into a focused MVP across a 12-week capstone timeline",
            "Led sprint planning and cross-team alignment between 4 developers and 7 designers",
            "Implemented AI furniture recommendation system using OpenAI text-embedding-3-small with cosine similarity ranking",
            "Built a custom React Native polling hook to withhold render until recommendation results are stable",
            "Contributed to furniture listing and filtering UI with recommendation ranking and profile-based preferences"
        ],
        techStack: [
            "React Native",
            "TypeScript",
            "Expo",
            "NativeWind",
            "TanStack Query",
            "Zustand",
            "Viro (AR)",
            "Hono",
            "Node.js",
            "Drizzle ORM",
            "PostgreSQL",
            "OpenAI API",
            "Replicate",
            "AWS EC2",
            "AWS S3",
            "PM2"
        ],
        links: {
            demo: "https://reano.pages.dev",
            github: "https://github.com/keipalg/reano"
        }
    },
    {
        id: 2,
        title: "Arvo",
        subtitle: "Product Management Platform for Handcraft Makers",
        period: "Sep 2025 - Nov 2025",
        icon: "\uD83C\uDFA8",
        image: "/img/arvo/arvo-ad.webp",
        detailPage: "projects/arvo.html",
        description: "A web application empowering solo handcraft entrepreneurs to transform creativity into sustainable business. This platform addresses the critical challenges of cost tracking, inventory valuation, and pricing decisions. By centralizing financial data with AI-driven insights, it helps makers track profitability, optimize pricing strategies, and reduce administrative burden\u2014freeing them to focus on their craft.",
        role: "Product Manager / Co-Project Manager / Full-stack Developer",
        contributions: [
            "Led product planning and feature design with a customer-focused approach",
            "Provided significant contribution in analyzing and implementing business logic",
            "Delivered Product modules: Product Inventory Management, Production Batch and Production Cost Management",
            "Implemented price suggestion feature using AI (GPT-5 mini)"
        ],
        techStack: [
            "React",
            "TypeScript",
            "Node.js",
            "PostgreSQL",
            "OpenAI API",
            "Tailwind CSS",
            "Google Cloud Storage",
            " Vite",
            "TanStack Query",
            "TanStack Router",
            "Chart.js",
            "Hono",
            "Drizzle ORM",
            "Better Auth"
        ],
        links: {
            demo: "https://wmdd-pj2-handcraft-23b18.web.app/",
            github: "https://github.com/keipalg/arvo"
        }
    },
    {
        id: 3,
        title: "Delista",
        subtitle: "Restaurant Menu Digitization Platform",
        period: "May 2025 - Jul 2025",
        icon: "\uD83C\uDF7D\uFE0F",
        image: "/img/delista/delista-ad.webp",
        detailPage: "projects/delista.html",
        description: "B2B/B2C Web PWA for restaurant menu digitization. This solution accelerates digital transformation for restaurants using paper or PDF menus while addressing challenges faced by diners in Vancouver's diverse, multicultural food scene. It streamlines dining and menu management with real-time updates, dietary filters, and QR-accessible menus. It helps diners eat with confidence and restaurants manage with ease.",
        role: "Product Manager / Full-Stack Developer",
        contributions: [
            "Developed customer menu interface with favorites system and Google Maps integration",
            "Partnered with designers to define feature requirements and UI specifications",
            "Optimized user experience to minimize onboarding friction for both B2B (restaurant owners) and B2C (diners) users",
            "Created strategic business plan for future scalability"
        ],
        techStack: [
            "HTML",
            "CSS",
            "JavaScript",
            "Firebase",
            "GitHub"
        ],
        links: {
            demo: "https://langara-app.ca/projects/delista",
            github: null
        }
    },
    {
        id: 4,
        title: "Data for Good Vancouver Website",
        subtitle: "High UX Quality & Conversion Improvement",
        period: "Feb 2025 - Apr 2025",
        icon: "\uD83D\uDCC8",
        image: "/img/dfg-website-renewal.png",
        detailPage: "projects/dfg.html",
        description: "Website renewal and content update project for Data for Good Vancouver designed to attract both clients and volunteers.",
        role: "UX/UI Designer / Frontend Web Developer",
        contributions: [
            "Redesigned information architecture and user flows based on stakeholder interviews",
            "Created custom visuals aligned with content to improve information absorption",
            "Reduced copy to essentials, minimizing drop-off before calls to action",
            "Delivered website renewal that increased inquiries by 4.5x"
        ],
        techStack: [
            "HTML",
            "CSS",
            "WordPress",
            "Figma",
            "Adobe Photoshop",
            "Adobe Illustrator"
        ],
        links: {
            demo: "https://vancouver.dataforgood.ca/",
            github: null
        }
    }
];
const $184a9ed2e74adf5a$var$ProjectCard = ({ project: project, index: index, onClick: onClick })=>{
    const handleClick = ()=>{
        if (project.detailPage) window.location.href = project.detailPage;
        else onClick(project);
    };
    return /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
        className: `project-card animate-fade-in-up delay-${index + 1}`,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("div", {
                className: "project-image",
                children: /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("img", {
                    src: project.image,
                    alt: project.title
                })
            }),
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
                className: "project-card-overlay",
                children: [
                    /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("div", {
                        className: "project-number",
                        children: String(project.id).padStart(2, '0')
                    }),
                    /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("h3", {
                        className: "project-title",
                        children: project.title
                    }),
                    /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("p", {
                        className: "project-role-badge",
                        children: project.role
                    }),
                    /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
                        className: "project-tags",
                        children: [
                            project.techStack.slice(0, 5).map((tech)=>/*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("span", {
                                    className: "tag",
                                    children: tech
                                }, tech)),
                            project.techStack.length > 5 && /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("span", {
                                className: "tag",
                                children: [
                                    "+",
                                    project.techStack.length - 5
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("span", {
                        className: "project-period",
                        children: project.period
                    })
                ]
            })
        ]
    });
};
const $184a9ed2e74adf5a$var$ProjectModal = ({ project: project, onClose: onClose })=>{
    if (!project) return null;
    return /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("div", {
        className: "modal-overlay",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
            className: "modal-content",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("button", {
                    className: "modal-close",
                    onClick: onClose,
                    children: "\xd7"
                }),
                /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
                    className: "modal-header",
                    children: [
                        /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("div", {
                            className: "project-number",
                            children: String(project.id).padStart(2, '0')
                        }),
                        /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("h2", {
                            className: "project-title",
                            children: project.title
                        }),
                        /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("h3", {
                            className: "project-subtitle",
                            children: project.subtitle
                        }),
                        /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("p", {
                            className: "project-period",
                            children: project.period
                        })
                    ]
                }),
                project.image && /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("div", {
                    className: "modal-image",
                    children: /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("img", {
                        src: project.image,
                        alt: project.title
                    })
                }),
                /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
                    className: "modal-body",
                    children: [
                        /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("p", {
                            className: "project-description",
                            children: project.description
                        }),
                        /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
                            className: "project-role",
                            children: [
                                /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("strong", {
                                    children: "Role:"
                                }),
                                " ",
                                project.role
                            ]
                        }),
                        /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
                            className: "project-contributions",
                            children: [
                                /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("strong", {
                                    children: "Key Contributions:"
                                }),
                                /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("ul", {
                                    children: project.contributions.map((contribution, idx)=>/*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("li", {
                                            children: contribution
                                        }, idx))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
                            className: "project-tags",
                            children: [
                                /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("strong", {
                                    children: "Tech Stack:"
                                }),
                                /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("div", {
                                    className: "tags-container",
                                    children: project.techStack.map((tech)=>/*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("span", {
                                            className: "tag",
                                            children: tech
                                        }, tech))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
                            className: "project-links",
                            children: [
                                project.links.demo && /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("a", {
                                    href: project.links.demo,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "project-link",
                                    children: "View Live Demo \u2192"
                                }),
                                project.links.github && /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("a", {
                                    href: project.links.github,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "project-link",
                                    children: "View Code \u2192"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $184a9ed2e74adf5a$var$Projects = ()=>{
    const [selectedProject, setSelectedProject] = (0, $5a48l.useState)(null);
    const handleCardClick = (project)=>{
        setSelectedProject(project);
    };
    const handleCloseModal = ()=>{
        setSelectedProject(null);
    };
    return /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("section", {
        className: "featured-section",
        id: "projects",
        children: [
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
                className: "section-header animate-fade-in-up",
                children: [
                    /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("div", {
                        className: "section-label",
                        children: "SELECTED PROJECTS"
                    }),
                    /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("h2", {
                        className: "section-title",
                        children: "FEATURED WORK"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("div", {
                className: "projects-grid",
                children: $184a9ed2e74adf5a$var$projectsData.map((project, index)=>/*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)($184a9ed2e74adf5a$var$ProjectCard, {
                        project: project,
                        index: index,
                        onClick: handleCardClick
                    }, project.id))
            }),
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)($184a9ed2e74adf5a$var$ProjectModal, {
                project: selectedProject,
                onClose: handleCloseModal
            })
        ]
    });
};
var $184a9ed2e74adf5a$export$2e2bcd8739ae039 = $184a9ed2e74adf5a$var$Projects;



parcelRequire("5a48l");
const $22bd9f6ad04f7d02$var$Contact = ()=>{
    return /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("section", {
        className: "contact-section",
        id: "contact",
        children: [
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("p", {
                className: "animate-fade-in-up delay-1",
                children: "Have a project in mind? Let's discuss how we can work together."
            }),
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("div", {
                className: "contact-buttons animate-scale delay-2",
                children: [
                    /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("a", {
                        href: "https://www.linkedin.com/in/kanako-taga-191363159/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "contact-button",
                        children: [
                            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24",
                                fill: "currentColor",
                                width: "18",
                                height: "18",
                                children: /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("path", {
                                    d: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                                })
                            }),
                            "Connect on LinkedIn"
                        ]
                    }),
                    /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("a", {
                        href: "https://github.com/kanadev00",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "contact-button secondary",
                        children: [
                            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24",
                                fill: "currentColor",
                                width: "18",
                                height: "18",
                                children: /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("path", {
                                    d: "M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"
                                })
                            }),
                            "View GitHub"
                        ]
                    })
                ]
            })
        ]
    });
};
var $22bd9f6ad04f7d02$export$2e2bcd8739ae039 = $22bd9f6ad04f7d02$var$Contact;



parcelRequire("5a48l");
const $9d0d71344050cac1$var$Footer = ()=>{
    return /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)("footer", {
        className: "animate-fade-in",
        children: "\xa9 2026 KANAKO TAGA \u2022 PRODUCT MANAGER \u2022 FULL-STACK DEVELOPER \u2022 VANCOUVER, BC, CANADA"
    });
};
var $9d0d71344050cac1$export$2e2bcd8739ae039 = $9d0d71344050cac1$var$Footer;


const $e21d885460231ee0$var$MainContainer = ()=>{
    return /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsxs)("main", {
        className: "main-container",
        children: [
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)((0, $a88be774e5dadb59$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)((0, $184a9ed2e74adf5a$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)((0, $60c23ef4e898d115$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)((0, $845516e37b1d38d1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)((0, $22bd9f6ad04f7d02$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)((0, $9d0d71344050cac1$export$2e2bcd8739ae039), {})
        ]
    });
};
var $e21d885460231ee0$export$2e2bcd8739ae039 = $e21d885460231ee0$var$MainContainer;


const $67cc0fc50d29e272$var$App = ()=>{
    return /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)((0, $e198763f6a656b3c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)((0, $e21d885460231ee0$export$2e2bcd8739ae039), {})
    });
};
var $67cc0fc50d29e272$export$2e2bcd8739ae039 = $67cc0fc50d29e272$var$App;


var $6e8aa0025d249b6c$exports = {};
'use strict';
function $6e8aa0025d249b6c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6e8aa0025d249b6c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6e8aa0025d249b6c$var$checkDCE();

$6e8aa0025d249b6c$exports = (parcelRequire("93C2Y"));


console.log('Script loaded, attempting to mount React...');
const $c18b972ff1be62b2$var$container = document.getElementById('react-container');
console.log('Container element:', $c18b972ff1be62b2$var$container);
if ($c18b972ff1be62b2$var$container) {
    const root = (0, $6e8aa0025d249b6c$exports.createRoot)($c18b972ff1be62b2$var$container);
    console.log('Root created, rendering App...');
    root.render(/*#__PURE__*/ (0, $e198763f6a656b3c$exports.jsx)((0, $67cc0fc50d29e272$export$2e2bcd8739ae039), {}));
    console.log('App rendered successfully');
} else console.error('Could not find #react-container element!');


//# sourceMappingURL=portfolio.9970453e.js.map
